/**
 * Swiper 14.0.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2026 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 26, 2026
 */

var Swiper = (function () {
  'use strict';
  function e(e = '') {
    return e
      .trim()
      .split(' ')
      .filter(e => !!e.trim());
  }
  function t(e, t = 0) {
    return setTimeout(e, t);
  }
  function s() {
    return Date.now();
  }
  function i(e, t = 'x') {
    const s = (function (e) {
        return window.getComputedStyle(e, null);
      })(e),
      i = s.transform || s.webkitTransform;
    if (!i || 'none' === i) return 0;
    const r = new DOMMatrixReadOnly(i);
    return 'x' === t ? r.m41 : r.m42;
  }
  function r(e) {
    return (
      'object' == typeof e &&
      null !== e &&
      e.constructor === Object &&
      'Object' === Object.prototype.toString.call(e).slice(8, -1)
    );
  }
  function a(e) {
    return (
      ('undefined' != typeof HTMLElement && e instanceof HTMLElement) ||
      (!!e && 'object' == typeof e && (1 === e.nodeType || 11 === e.nodeType))
    );
  }
  function n(e, ...t) {
    const s = Object(e);
    for (let e = 0; e < t.length; e += 1) {
      const i = t[e];
      if (null == i || a(i)) continue;
      const l = i,
        o = Object.keys(Object(l)).filter(
          e => '__proto__' !== e && 'constructor' !== e && 'prototype' !== e
        );
      for (const e of o) {
        const t = Object.getOwnPropertyDescriptor(l, e);
        if (!t || !t.enumerable) continue;
        const i = l[e];
        r(s[e]) && r(i)
          ? i.__swiper__
            ? (s[e] = i)
            : n(s[e], i)
          : !r(s[e]) && r(i)
            ? ((s[e] = {}), i.__swiper__ ? (s[e] = i) : n(s[e], i))
            : (s[e] = i);
      }
    }
    return s;
  }
  function l(e, t, s) {
    e.style.setProperty(t, s);
  }
  function o(e) {
    const t = e.querySelector('.swiper-slide-transform');
    if (t) return t;
    if (e.shadowRoot) {
      const t = e.shadowRoot.querySelector('.swiper-slide-transform');
      if (t) return t;
    }
    return e;
  }
  function d(e, t = '') {
    const s = [...e.children];
    return (
      e instanceof HTMLSlotElement && s.push(...e.assignedElements()),
      t ? s.filter(e => e.matches(t)) : s
    );
  }
  function c(e) {
    try {
      console.warn(e);
    } catch {}
  }
  function p(t, s = []) {
    const i = document.createElement(t);
    return (i.classList.add(...(Array.isArray(s) ? s : e(s))), i);
  }
  function u(e) {
    const t = e.getBoundingClientRect();
    return {
      top: t.top + window.scrollY - (e.clientTop || 0),
      left: t.left + window.scrollX - (e.clientLeft || 0),
    };
  }
  function m(e, t) {
    return window.getComputedStyle(e, null).getPropertyValue(t);
  }
  function h(e) {
    if (e && e.parentNode) return [...e.parentNode.children].indexOf(e);
  }
  function f(e, t) {
    const s = [];
    let i = e.parentElement;
    for (; i; ) ((t && !i.matches(t)) || s.push(i), (i = i.parentElement));
    return s;
  }
  function g(e, t) {
    t &&
      e.addEventListener(
        'transitionend',
        function (s) {
          s.target === e && t.call(e, s);
        },
        { once: !0 }
      );
  }
  function v(e, t, s) {
    {
      const s = window.getComputedStyle(e, null);
      return (
        e['width' === t ? 'offsetWidth' : 'offsetHeight'] +
        parseFloat(
          s.getPropertyValue('width' === t ? 'margin-right' : 'margin-top')
        ) +
        parseFloat(
          s.getPropertyValue('width' === t ? 'margin-left' : 'margin-bottom')
        )
      );
    }
  }
  function w(e) {
    return (Array.isArray(e) ? e : [e]).filter(e => !!e);
  }
  function b(e) {
    return t =>
      Math.abs(t) > 0 &&
      e.browser &&
      e.browser.need3dFix &&
      Math.abs(t) % 90 == 0
        ? t + 0.001
        : t;
  }
  function y(e, t = '') {
    const s = globalThis.trustedTypes;
    e.innerHTML =
      void 0 !== s
        ? s.createPolicy('html', { createHTML: e => e }).createHTML(t)
        : t;
  }
  let E, S, x;
  function T() {
    return (
      E ||
        (E =
          'undefined' == typeof window
            ? { touch: !1 }
            : {
                touch: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
              }),
      E
    );
  }
  function M(e = {}) {
    return (
      S ||
        (S = (function ({ userAgent: e } = {}) {
          if ('undefined' == typeof window) return { ios: !1, android: !1 };
          const t = T(),
            s = navigator.platform,
            i = e || navigator.userAgent,
            r = { ios: !1, android: !1 },
            a = /(Android);?[\s/]+([\d.]+)?/.test(i),
            n = /(iPhone\sOS|iOS|iPod)/.test(i),
            l = /iPad/.test(i),
            o = 'MacIntel' === s && t.touch && navigator.maxTouchPoints > 1,
            d = l || o;
          return (
            a && !('Win32' === s) && ((r.os = 'android'), (r.android = !0)),
            (d || n) && ((r.os = 'ios'), (r.ios = !0)),
            r
          );
        })(e)),
      S
    );
  }
  function C() {
    return (
      x ||
        (x = (function () {
          if ('undefined' == typeof window)
            return { isSafari: !1, isWebView: !1, need3dFix: !1 };
          const e = M(),
            t = navigator.userAgent,
            s = t.toLowerCase(),
            i =
              s.includes('safari') &&
              !s.includes('chrome') &&
              !s.includes('android'),
            r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t);
          return { isSafari: i, isWebView: r, need3dFix: i || (r && e.ios) };
        })()),
      x
    );
  }
  const P = (e, t) => {
      if (!e || e.destroyed || !e.params) return;
      const s = t.closest(
        e.isElement ? 'swiper-slide' : `.${e.params.slideClass}`
      );
      if (s) {
        let t = s.querySelector(`.${e.params.lazyPreloaderClass}`);
        (!t &&
          e.isElement &&
          (s.shadowRoot
            ? (t = s.shadowRoot.querySelector(
                `.${e.params.lazyPreloaderClass}`
              ))
            : requestAnimationFrame(() => {
                if (s.shadowRoot) {
                  const t = s.shadowRoot.querySelector(
                    `.${e.params.lazyPreloaderClass}`
                  );
                  t && !t.lazyPreloaderManaged && t.remove();
                }
              })),
          t && !t.lazyPreloaderManaged && t.remove());
      }
    },
    L = (e, t) => {
      if (!e.slides[t]) return;
      const s = e.slides[t].querySelector('[loading="lazy"]');
      s && s.removeAttribute('loading');
    },
    A = e => {
      if (!e || e.destroyed || !e.params) return;
      let t = e.params.lazyPreloadPrevNext;
      const s = e.slides.length;
      if (!s || !t || t < 0) return;
      t = Math.min(t, s);
      const i =
          'auto' === e.params.slidesPerView
            ? e.slidesPerViewDynamic()
            : Math.ceil(e.params.slidesPerView),
        r = e.activeIndex;
      if (e.params.grid && (e.params.grid.rows ?? 1) > 1) {
        const s = r,
          a = [s - t];
        return (
          a.push(...Array.from({ length: t }).map((e, t) => s + i + t)),
          void e.slides.forEach((t, s) => {
            void 0 !== t.column && a.includes(t.column) && L(e, s);
          })
        );
      }
      const a = r + i - 1;
      if (e.params.rewind || e.params.loop)
        for (let i = r - t; i <= a + t; i += 1) {
          const t = ((i % s) + s) % s;
          (t < r || t > a) && L(e, t);
        }
      else
        for (let i = Math.max(r - t, 0); i <= Math.min(a + t, s - 1); i += 1)
          i !== r && (i > a || i < r) && L(e, i);
    };
  const I = (e, t) => !!(e.grid && t.grid && t.grid.rows > 1);
  var z = {
    setBreakpoint: function () {
      const e = this,
        { realIndex: t, initialized: s, params: i, el: r } = e,
        a = i.breakpoints;
      if (!a || (a && 0 === Object.keys(a).length)) return;
      const l =
          'window' !== i.breakpointsBase && i.breakpointsBase
            ? 'container'
            : i.breakpointsBase,
        o =
          ['window', 'container'].includes(i.breakpointsBase) ||
          !i.breakpointsBase
            ? e.el
            : document.querySelector(i.breakpointsBase),
        d = e.getBreakpoint(a, l, o);
      if (!d || e.currentBreakpoint === d) return;
      const c = (d in a ? a[d] : void 0) || e.originalParams,
        p = I(e, i),
        u = I(e, c),
        m = e.params.grabCursor,
        h = c.grabCursor,
        f = i.enabled;
      (p && !u
        ? (r.classList.remove(
            `${i.containerModifierClass}grid`,
            `${i.containerModifierClass}grid-column`
          ),
          e.emitContainerClasses())
        : !p &&
          u &&
          (r.classList.add(`${i.containerModifierClass}grid`),
          ((c.grid.fill && 'column' === c.grid.fill) ||
            (!c.grid.fill && 'column' === i.grid.fill)) &&
            r.classList.add(`${i.containerModifierClass}grid-column`),
          e.emitContainerClasses()),
        m && !h ? e.unsetGrabCursor() : !m && h && e.setGrabCursor());
      const g = (e, t) => e[t];
      ['navigation', 'pagination', 'scrollbar'].forEach(t => {
        const s = g(c, t);
        if (void 0 === s) return;
        const r = g(i, t),
          a = 'object' == typeof r && null !== r && r.enabled,
          n = 'object' == typeof s && null !== s && s.enabled,
          l = e[t];
        (a && !n && l?.disable?.(), !a && n && l?.enable?.());
      });
      const v = c.direction && c.direction !== i.direction,
        w = i.loop && (c.slidesPerView !== i.slidesPerView || v),
        b = i.loop;
      (v && s && e.changeDirection(), n(e.params, c));
      const y = e.params.enabled,
        E = e.params.loop;
      (Object.assign(e, {
        allowTouchMove: e.params.allowTouchMove,
        allowSlideNext: e.params.allowSlideNext,
        allowSlidePrev: e.params.allowSlidePrev,
      }),
        f && !y ? e.disable() : !f && y && e.enable(),
        (e.currentBreakpoint = d),
        e.emit('_beforeBreakpoint', c),
        s &&
          (w
            ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides())
            : !b && E
              ? (e.loopCreate(t), e.updateSlides())
              : b && !E && e.loopDestroy()),
        e.emit('breakpoint', c));
    },
    getBreakpoint: function (e, t = 'window', s) {
      if (!e || ('container' === t && !s)) return;
      let i = !1;
      const r = 'window' === t ? window.innerHeight : s.clientHeight,
        a = Object.keys(e).map(e => {
          if ('string' == typeof e && 0 === e.indexOf('@')) {
            const t = parseFloat(e.substr(1));
            return { value: r * t, point: e };
          }
          return { value: e, point: e };
        });
      a.sort(
        (e, t) => parseInt(String(e.value), 10) - parseInt(String(t.value), 10)
      );
      for (let e = 0; e < a.length; e += 1) {
        const { point: r, value: n } = a[e];
        'window' === t
          ? window.matchMedia(`(min-width: ${n}px)`).matches && (i = r)
          : n <= s.clientWidth && (i = r);
      }
      return i || 'max';
    },
  };
  var $ = {
    checkOverflow: function () {
      const e = this,
        { isLocked: t, params: s } = e,
        { slidesOffsetBefore: i } = s;
      if (i) {
        const t = e.slides.length - 1,
          s = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
        e.isLocked = e.size > s;
      } else e.isLocked = 1 === e.snapGrid.length;
      (!0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked),
        !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
        t && t !== e.isLocked && (e.isEnd = !1),
        t !== e.isLocked && e.emit(e.isLocked ? 'lock' : 'unlock'));
    },
  };
  var k = {
    addClasses: function () {
      const e = this,
        { classNames: t, params: s, rtl: i, el: r, device: a } = e,
        n = (function (e, t) {
          const s = [];
          return (
            e.forEach(e => {
              'object' == typeof e
                ? Object.keys(e).forEach(i => {
                    e[i] && s.push(t + i);
                  })
                : 'string' == typeof e && s.push(t + e);
            }),
            s
          );
        })(
          [
            'initialized',
            s.direction,
            { 'free-mode': e.params.freeMode && s.freeMode.enabled },
            { autoheight: s.autoHeight },
            { rtl: i },
            { grid: s.grid && s.grid.rows > 1 },
            {
              'grid-column':
                s.grid && s.grid.rows > 1 && 'column' === s.grid.fill,
            },
            { android: a.android },
            { ios: a.ios },
            { 'css-mode': s.cssMode },
            { centered: s.cssMode && s.centeredSlides },
            { 'watch-progress': s.watchSlidesProgress },
          ],
          s.containerModifierClass
        );
      (t.push(...n), r.classList.add(...t), e.emitContainerClasses());
    },
    removeClasses: function () {
      const { el: e, classNames: t } = this;
      e &&
        'string' != typeof e &&
        (e.classList.remove(...t), this.emitContainerClasses());
    },
  };
  const O = {
    init: !0,
    direction: 'horizontal',
    oneWayMovement: !1,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: 'swiper',
    enabled: !0,
    focusableElements: 'input, select, option, textarea, button, video, label',
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: 'slide',
    breakpoints: void 0,
    breakpointsBase: 'window',
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    snapToSlideEdge: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: 'swiper-',
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  };
  var D = {
    on(e, t, s) {
      const i = this;
      if (!i.eventsListeners || i.destroyed) return i;
      if ('function' != typeof t) return i;
      const r = s ? 'unshift' : 'push';
      return (
        e.split(' ').forEach(e => {
          (i.eventsListeners[e] || (i.eventsListeners[e] = []),
            i.eventsListeners[e][r](t));
        }),
        i
      );
    },
    once(e, t, s) {
      const i = this;
      if (!i.eventsListeners || i.destroyed) return i;
      if ('function' != typeof t) return i;
      const r = function (...s) {
        (i.off(e, r),
          r.__emitterProxy && delete r.__emitterProxy,
          t.apply(i, s));
      };
      return ((r.__emitterProxy = t), i.on(e, r, s));
    },
    onAny(e, t) {
      const s = this;
      if (!s.eventsListeners || s.destroyed) return s;
      if ('function' != typeof e) return s;
      const i = t ? 'unshift' : 'push';
      return (
        s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[i](e),
        s
      );
    },
    offAny(e) {
      const t = this;
      if (!t.eventsListeners || t.destroyed) return t;
      if (!t.eventsAnyListeners) return t;
      const s = t.eventsAnyListeners.indexOf(e);
      return (s >= 0 && t.eventsAnyListeners.splice(s, 1), t);
    },
    off(e, t) {
      const s = this;
      return !s.eventsListeners || s.destroyed
        ? s
        : s.eventsListeners
          ? (e.split(' ').forEach(e => {
              void 0 === t
                ? (s.eventsListeners[e] = [])
                : s.eventsListeners[e] &&
                  s.eventsListeners[e].forEach((i, r) => {
                    (i === t || (i.__emitterProxy && i.__emitterProxy === t)) &&
                      s.eventsListeners[e].splice(r, 1);
                  });
            }),
            s)
          : s;
    },
    emit(...e) {
      const t = this;
      if (!t.eventsListeners || t.destroyed) return t;
      if (!t.eventsListeners) return t;
      let s, i, r;
      if ('string' == typeof e[0] || Array.isArray(e[0]))
        ((s = e[0]), (i = e.slice(1, e.length)), (r = t));
      else {
        const a = e[0];
        ((s = a.events), (i = a.data ?? []), (r = a.context || t));
      }
      i.unshift(r);
      return (
        (Array.isArray(s) ? s : s.split(' ')).forEach(e => {
          (t.eventsAnyListeners &&
            t.eventsAnyListeners.length &&
            t.eventsAnyListeners.forEach(t => {
              t.apply(r, [e, ...i]);
            }),
            t.eventsListeners &&
              t.eventsListeners[e] &&
              t.eventsListeners[e].forEach(e => {
                e.apply(r, i);
              }));
        }),
        t
      );
    },
  };
  function G(e) {
    const t = this;
    t.destroyed ||
      (t.enabled &&
        (t.allowClick ||
          (t.params.preventClicks && e.preventDefault(),
          t.params.preventClicksPropagation &&
            t.animating &&
            (e.stopPropagation(), e.stopImmediatePropagation()))));
  }
  function X() {
    const e = this;
    e.destroyed ||
      e.documentTouchHandlerProceeded ||
      ((e.documentTouchHandlerProceeded = !0),
      e.params.touchReleaseOnEdges && (e.el.style.touchAction = 'auto'));
  }
  function B(e) {
    const t = this;
    t.destroyed ||
      (P(t, e.target),
      t.params.cssMode ||
        ('auto' !== t.params.slidesPerView && !t.params.autoHeight) ||
        t.update());
  }
  function H() {
    const e = this,
      { params: t, el: s } = e;
    if (s && 0 === s.offsetWidth) return;
    t.breakpoints && e.setBreakpoint();
    const { allowSlideNext: i, allowSlidePrev: r, snapGrid: a } = e,
      n = e.virtual && e.params.virtual?.enabled;
    ((e.allowSlideNext = !0),
      (e.allowSlidePrev = !0),
      e.updateSize(),
      e.updateSlides(),
      e.updateSlidesClasses());
    const l = n && t.loop;
    if (
      !('auto' === t.slidesPerView || t.slidesPerView > 1) ||
      !e.isEnd ||
      e.isBeginning ||
      e.params.centeredSlides ||
      l
    )
      e.params.loop && !n
        ? e.slideToLoop(e.realIndex, 0, !1, !0)
        : e.slideTo(e.activeIndex, 0, !1, !0);
    else {
      const t = n ? e.virtual.slides.length : e.slides.length;
      e.slideTo(t - 1, 0, !1, !0);
    }
    if (e.autoplay && e.autoplay.running && e.autoplay.paused) {
      const t = e.autoplay;
      (clearTimeout(t.resizeTimeout),
        (t.resizeTimeout = setTimeout(() => {
          e.autoplay &&
            e.autoplay.running &&
            e.autoplay.paused &&
            e.autoplay.resume();
        }, 500)));
    }
    ((e.allowSlidePrev = r),
      (e.allowSlideNext = i),
      e.params.watchOverflow && a !== e.snapGrid && e.checkOverflow());
  }
  function Y() {
    const e = this;
    if (e.destroyed) return;
    const { wrapperEl: t, rtlTranslate: s, enabled: i } = e;
    if (!i) return;
    let r;
    ((e.previousTranslate = e.translate),
      e.isHorizontal()
        ? (e.translate = -t.scrollLeft)
        : (e.translate = -t.scrollTop),
      0 === e.translate && (e.translate = 0),
      e.updateActiveIndex(),
      e.updateSlidesClasses());
    const a = e.maxTranslate() - e.minTranslate();
    ((r = 0 === a ? 0 : (e.translate - e.minTranslate()) / a),
      r !== e.progress && e.updateProgress(s ? -e.translate : e.translate),
      e.emit('setTranslate', e.translate, !1));
  }
  function R(e) {
    const i = this;
    if (i.destroyed) return;
    const r = i.touchEventsData;
    let a = e.originalEvent ?? e;
    if ('touchend' === a.type || 'touchcancel' === a.type) {
      const e = [...a.changedTouches].find(e => e.identifier === r.touchId);
      if (!e || e.identifier !== r.touchId) return;
    } else {
      if (null !== r.touchId) return;
      if (a.pointerId !== r.pointerId) return;
    }
    if (
      ['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(
        a.type
      )
    ) {
      if (
        !(
          ['pointercancel', 'contextmenu'].includes(a.type) &&
          (i.browser.isSafari || i.browser.isWebView)
        )
      )
        return;
    }
    ((r.pointerId = null), (r.touchId = null));
    const {
      params: n,
      touches: l,
      rtlTranslate: o,
      slidesGrid: d,
      enabled: c,
    } = i;
    if (!c) return;
    if (!n.simulateTouch && 'mouse' === a.pointerType) return;
    if (
      (r.allowTouchCallbacks && i.emit('touchEnd', a),
      (r.allowTouchCallbacks = !1),
      !r.isTouched)
    )
      return (
        r.isMoved && n.grabCursor && i.setGrabCursor(!1),
        (r.isMoved = !1),
        void (r.startMoving = !1)
      );
    n.grabCursor &&
      r.isMoved &&
      r.isTouched &&
      (!0 === i.allowSlideNext || !0 === i.allowSlidePrev) &&
      i.setGrabCursor(!1);
    const p = s(),
      u = p - r.touchStartTime;
    if (i.allowClick) {
      const e = a.path ?? (a.composedPath && a.composedPath());
      (i.updateClickedSlide(e && e[0], e),
        i.emit('tap click', a),
        u < 300 &&
          p - r.lastClickTime < 300 &&
          i.emit('doubleTap doubleClick', a));
    }
    if (
      ((r.lastClickTime = s()),
      t(() => {
        i.destroyed || (i.allowClick = !0);
      }),
      !r.isTouched ||
        !r.isMoved ||
        !i.swipeDirection ||
        (0 === l.diff && !r.loopSwapReset) ||
        (r.currentTranslate === r.startTranslate && !r.loopSwapReset))
    )
      return ((r.isTouched = !1), (r.isMoved = !1), void (r.startMoving = !1));
    let m;
    if (
      ((r.isTouched = !1),
      (r.isMoved = !1),
      (r.startMoving = !1),
      (m = n.followFinger
        ? o
          ? i.translate
          : -i.translate
        : -(r.currentTranslate ?? 0)),
      n.cssMode)
    )
      return;
    if (n.freeMode && n.freeMode.enabled)
      return void i.freeMode.onTouchEnd({ currentPos: m });
    const h = m >= -i.maxTranslate() && !i.params.loop;
    let f = 0,
      g = i.slidesSizesGrid[0];
    for (
      let e = 0;
      e < d.length;
      e += e < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup
    ) {
      const t = e < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
      void 0 !== d[e + t]
        ? (h || (m >= d[e] && m < d[e + t])) && ((f = e), (g = d[e + t] - d[e]))
        : (h || m >= d[e]) &&
          ((f = e), (g = d[d.length - 1] - d[d.length - 2]));
    }
    let v = null,
      w = null;
    n.rewind &&
      (i.isBeginning
        ? (w =
            n.virtual?.enabled && i.virtual
              ? i.virtual.slides.length - 1
              : i.slides.length - 1)
        : i.isEnd && (v = 0));
    const b = (m - d[f]) / g,
      y = f < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
    if (u > n.longSwipesMs) {
      if (!n.longSwipes) return void i.slideTo(i.activeIndex);
      ('next' === i.swipeDirection &&
        (b >= n.longSwipesRatio
          ? i.slideTo(n.rewind && i.isEnd ? v : f + y)
          : i.slideTo(f)),
        'prev' === i.swipeDirection &&
          (b > 1 - n.longSwipesRatio
            ? i.slideTo(f + y)
            : null !== w && b < 0 && Math.abs(b) > n.longSwipesRatio
              ? i.slideTo(w)
              : i.slideTo(f)));
    } else {
      if (!n.shortSwipes) return void i.slideTo(i.activeIndex);
      i.navigation &&
      (a.target === i.navigation.nextEl || a.target === i.navigation.prevEl)
        ? a.target === i.navigation.nextEl
          ? i.slideTo(f + y)
          : i.slideTo(f)
        : ('next' === i.swipeDirection && i.slideTo(null !== v ? v : f + y),
          'prev' === i.swipeDirection && i.slideTo(null !== w ? w : f));
    }
  }
  function N(e) {
    const t = this;
    if (t.destroyed) return;
    const i = t.touchEventsData,
      { params: r, touches: a, rtlTranslate: n, enabled: l } = t;
    if (!l) return;
    if (!r.simulateTouch && 'mouse' === e.pointerType) return;
    const o = e,
      d = o.originalEvent ?? o;
    if ('pointermove' === d.type) {
      if (null !== i.touchId) return;
      if (d.pointerId !== i.pointerId) return;
    }
    let c;
    if ('touchmove' === d.type) {
      const e = [...d.changedTouches].find(e => e.identifier === i.touchId);
      if (!e || e.identifier !== i.touchId) return;
      c = e;
    } else c = d;
    if (!i.isTouched)
      return void (
        i.startMoving &&
        i.isScrolling &&
        t.emit('touchMoveOpposite', d)
      );
    const p = c.pageX,
      u = c.pageY;
    if (d.preventedByNestedSwiper) return ((a.startX = p), void (a.startY = u));
    if (!t.allowTouchMove)
      return (
        d.target.matches(i.focusableElements) || (t.allowClick = !1),
        void (
          i.isTouched &&
          (Object.assign(a, { startX: p, startY: u, currentX: p, currentY: u }),
          (i.touchStartTime = s()))
        )
      );
    if (r.touchReleaseOnEdges && !r.loop)
      if (t.isVertical()) {
        if (
          (u < a.startY && t.translate <= t.maxTranslate()) ||
          (u > a.startY && t.translate >= t.minTranslate())
        )
          return ((i.isTouched = !1), void (i.isMoved = !1));
      } else {
        if (
          n &&
          ((p > a.startX && -t.translate <= t.maxTranslate()) ||
            (p < a.startX && -t.translate >= t.minTranslate()))
        )
          return;
        if (
          !n &&
          ((p < a.startX && t.translate <= t.maxTranslate()) ||
            (p > a.startX && t.translate >= t.minTranslate()))
        )
          return;
      }
    if (
      (document.activeElement &&
        document.activeElement.matches(i.focusableElements) &&
        document.activeElement !== d.target &&
        'mouse' !== d.pointerType &&
        document.activeElement.blur(),
      document.activeElement &&
        d.target === document.activeElement &&
        d.target.matches(i.focusableElements))
    )
      return ((i.isMoved = !0), void (t.allowClick = !1));
    (i.allowTouchCallbacks && t.emit('touchMove', d),
      (a.previousX = a.currentX),
      (a.previousY = a.currentY),
      (a.currentX = p),
      (a.currentY = u));
    const m = a.currentX - a.startX,
      h = a.currentY - a.startY;
    if (t.params.threshold && Math.sqrt(m ** 2 + h ** 2) < t.params.threshold)
      return;
    if (void 0 === i.isScrolling) {
      let e;
      (t.isHorizontal() && a.currentY === a.startY) ||
      (t.isVertical() && a.currentX === a.startX)
        ? (i.isScrolling = !1)
        : m * m + h * h >= 25 &&
          ((e = (180 * Math.atan2(Math.abs(h), Math.abs(m))) / Math.PI),
          (i.isScrolling = t.isHorizontal()
            ? e > r.touchAngle
            : 90 - e > r.touchAngle));
    }
    if (
      (i.isScrolling && t.emit('touchMoveOpposite', d),
      void 0 === i.startMoving &&
        ((a.currentX === a.startX && a.currentY === a.startY) ||
          (i.startMoving = !0)),
      i.isScrolling ||
        ('touchmove' === d.type && i.preventTouchMoveFromPointerMove))
    )
      return void (i.isTouched = !1);
    if (!i.startMoving) return;
    ((t.allowClick = !1),
      !r.cssMode && d.cancelable && d.preventDefault(),
      r.touchMoveStopPropagation && !r.nested && d.stopPropagation());
    let f = t.isHorizontal() ? m : h,
      g = t.isHorizontal()
        ? a.currentX - a.previousX
        : a.currentY - a.previousY;
    (r.oneWayMovement &&
      ((f = Math.abs(f) * (n ? 1 : -1)), (g = Math.abs(g) * (n ? 1 : -1))),
      (a.diff = f),
      (f *= r.touchRatio),
      n && ((f = -f), (g = -g)));
    const v = t.touchesDirection;
    ((t.swipeDirection = f > 0 ? 'prev' : 'next'),
      (t.touchesDirection = g > 0 ? 'prev' : 'next'));
    const w = t.params.loop && !r.cssMode,
      b =
        ('next' === t.touchesDirection && t.allowSlideNext) ||
        ('prev' === t.touchesDirection && t.allowSlidePrev);
    if (!i.isMoved) {
      if (
        (w && b && t.loopFix({ direction: t.swipeDirection }),
        (i.startTranslate = t.getTranslate()),
        t.setTransition(0),
        t.animating)
      ) {
        const e = new window.CustomEvent('transitionend', {
          bubbles: !0,
          cancelable: !0,
          detail: { bySwiperTouchMove: !0 },
        });
        t.wrapperEl.dispatchEvent(e);
      }
      ((i.allowMomentumBounce = !1),
        !r.grabCursor ||
          (!0 !== t.allowSlideNext && !0 !== t.allowSlidePrev) ||
          t.setGrabCursor(!0),
        t.emit('sliderFirstMove', d));
    }
    if (
      (new Date().getTime(),
      !1 !== r._loopSwapReset &&
        i.isMoved &&
        i.allowThresholdMove &&
        v !== t.touchesDirection &&
        w &&
        b &&
        Math.abs(f) >= 1)
    )
      return (
        Object.assign(a, {
          startX: p,
          startY: u,
          currentX: p,
          currentY: u,
          startTranslate: i.currentTranslate,
        }),
        (i.loopSwapReset = !0),
        void (i.startTranslate = i.currentTranslate)
      );
    (t.emit('sliderMove', d), (i.isMoved = !0));
    const y = i.startTranslate ?? 0;
    i.currentTranslate = f + y;
    let E = !0,
      S = r.resistanceRatio;
    if (
      (r.touchReleaseOnEdges && (S = 0),
      f > 0
        ? (w &&
            b &&
            i.allowThresholdMove &&
            i.currentTranslate >
              (r.centeredSlides
                ? t.minTranslate() -
                  t.slidesSizesGrid[t.activeIndex + 1] -
                  ('auto' !== r.slidesPerView &&
                  t.slides.length - r.slidesPerView >= 2
                    ? t.slidesSizesGrid[t.activeIndex + 1] +
                      t.params.spaceBetween
                    : 0) -
                  t.params.spaceBetween
                : t.minTranslate()) &&
            t.loopFix({
              direction: 'prev',
              setTranslate: !0,
              activeSlideIndex: 0,
            }),
          i.currentTranslate > t.minTranslate() &&
            ((E = !1),
            r.resistance &&
              (i.currentTranslate =
                t.minTranslate() - 1 + (-t.minTranslate() + y + f) ** S)))
        : f < 0 &&
          (w &&
            b &&
            i.allowThresholdMove &&
            i.currentTranslate <
              (r.centeredSlides
                ? t.maxTranslate() +
                  t.slidesSizesGrid[t.slidesSizesGrid.length - 1] +
                  t.params.spaceBetween +
                  ('auto' !== r.slidesPerView &&
                  t.slides.length - r.slidesPerView >= 2
                    ? t.slidesSizesGrid[t.slidesSizesGrid.length - 1] +
                      t.params.spaceBetween
                    : 0)
                : t.maxTranslate()) &&
            t.loopFix({
              direction: 'next',
              setTranslate: !0,
              activeSlideIndex:
                t.slides.length -
                ('auto' === r.slidesPerView
                  ? t.slidesPerViewDynamic()
                  : Math.ceil(parseFloat(String(r.slidesPerView)))),
            }),
          i.currentTranslate < t.maxTranslate() &&
            ((E = !1),
            r.resistance &&
              (i.currentTranslate =
                t.maxTranslate() + 1 - (t.maxTranslate() - y - f) ** S))),
      E && (d.preventedByNestedSwiper = !0),
      !t.allowSlideNext &&
        'next' === t.swipeDirection &&
        (i.currentTranslate ?? 0) < y &&
        (i.currentTranslate = y),
      !t.allowSlidePrev &&
        'prev' === t.swipeDirection &&
        (i.currentTranslate ?? 0) > y &&
        (i.currentTranslate = y),
      t.allowSlidePrev || t.allowSlideNext || (i.currentTranslate = y),
      r.threshold > 0)
    ) {
      if (!(Math.abs(f) > r.threshold || i.allowThresholdMove))
        return void (i.currentTranslate = i.startTranslate);
      if (!i.allowThresholdMove)
        return (
          (i.allowThresholdMove = !0),
          (a.startX = a.currentX),
          (a.startY = a.currentY),
          (i.currentTranslate = i.startTranslate),
          void (a.diff = t.isHorizontal()
            ? a.currentX - a.startX
            : a.currentY - a.startY)
        );
    }
    r.followFinger &&
      !r.cssMode &&
      (((r.freeMode && r.freeMode.enabled && t.freeMode) ||
        r.watchSlidesProgress) &&
        (t.updateActiveIndex(), t.updateSlidesClasses()),
      r.freeMode &&
        r.freeMode.enabled &&
        t.freeMode &&
        t.freeMode.onTouchMove(),
      t.updateProgress(i.currentTranslate),
      t.setTranslate(i.currentTranslate ?? 0));
  }
  function V(e, t, s) {
    const { params: i } = e,
      r = i.edgeSwipeDetection,
      a = i.edgeSwipeThreshold;
    return (
      !r ||
      !(s <= a || s >= window.innerWidth - a) ||
      ('prevent' === r && (t.preventDefault(), !0))
    );
  }
  function q(e) {
    const t = this;
    if (t.destroyed) return;
    const i = e.originalEvent ?? e,
      r = t.touchEventsData;
    if ('pointerdown' === i.type) {
      const e = i;
      if (null !== r.pointerId && r.pointerId !== e.pointerId) return;
      r.pointerId = e.pointerId;
    } else
      'touchstart' === i.type &&
        1 === i.targetTouches.length &&
        (r.touchId = i.targetTouches[0].identifier);
    if ('touchstart' === i.type) return void V(t, i, i.targetTouches[0].pageX);
    const { params: a, touches: n, enabled: l } = t;
    if (!l) return;
    if (!a.simulateTouch && 'mouse' === i.pointerType) return;
    if (t.animating && a.preventInteractionOnTransition) return;
    !t.animating && a.cssMode && a.loop && t.loopFix();
    let o = i.target;
    if (
      'wrapper' === a.touchEventsTarget &&
      !(function (e, t) {
        let s = t.contains(e);
        !s &&
          t instanceof HTMLSlotElement &&
          ((s = [...t.assignedElements()].includes(e)),
          s ||
            (s = (function (e, t) {
              const s = [t];
              for (; s.length > 0; ) {
                const t = s.shift();
                if (e === t) return !0;
                s.push(
                  ...t.children,
                  ...(t.shadowRoot ? t.shadowRoot.children : []),
                  ...(t.assignedElements ? t.assignedElements() : [])
                );
              }
              return !1;
            })(e, t)));
        return s;
      })(o, t.wrapperEl)
    )
      return;
    const d = i;
    if ('number' == typeof d.which && 3 === d.which) return;
    if ('number' == typeof d.button && d.button > 0) return;
    if (r.isTouched && r.isMoved) return;
    const c = !!a.noSwipingClass && '' !== a.noSwipingClass,
      p = i.composedPath ? i.composedPath() : i.path;
    c && i.target && i.target.shadowRoot && p && (o = p[0]);
    const u = a.noSwipingSelector
        ? a.noSwipingSelector
        : `.${a.noSwipingClass}`,
      m = !(!i.target || !i.target.shadowRoot);
    if (
      a.noSwiping &&
      (m
        ? ((h = u),
          (function e(t) {
            if (!t || t === document || t === window) return null;
            let s = t;
            s.assignedSlot && (s = s.assignedSlot);
            const i = s.closest(h);
            if (!i && !s.getRootNode) return null;
            const r = s.getRootNode();
            return i || e(r.host);
          })(o))
        : o.closest(u))
    )
      return void (t.allowClick = !0);
    var h;
    if (
      a.swipeHandler &&
      'string' == typeof a.swipeHandler &&
      !o.closest(a.swipeHandler)
    )
      return;
    const f = i;
    ((n.currentX = f.pageX), (n.currentY = f.pageY));
    const g = n.currentX,
      v = n.currentY;
    if (!V(t, i, g)) return;
    (Object.assign(r, {
      isTouched: !0,
      isMoved: !1,
      allowTouchCallbacks: !0,
      isScrolling: void 0,
      startMoving: void 0,
    }),
      (n.startX = g),
      (n.startY = v),
      (r.touchStartTime = s()),
      (t.allowClick = !0),
      t.updateSize(),
      (t.swipeDirection = void 0),
      a.threshold > 0 && (r.allowThresholdMove = !1));
    let w = !0;
    (o.matches(r.focusableElements) &&
      ((w = !1), 'SELECT' === o.nodeName && (r.isTouched = !1)),
      document.activeElement &&
        document.activeElement.matches(r.focusableElements) &&
        document.activeElement !== o &&
        ('mouse' === f.pointerType ||
          ('mouse' !== f.pointerType && !o.matches(r.focusableElements))) &&
        document.activeElement.blur());
    const b = w && t.allowTouchMove && a.touchStartPreventDefault;
    ((!a.touchStartForcePreventDefault && !b) ||
      o.isContentEditable ||
      i.preventDefault(),
      a.freeMode &&
        a.freeMode.enabled &&
        t.freeMode &&
        t.animating &&
        !a.cssMode &&
        t.freeMode.onTouchStart(),
      t.emit('touchStart', i));
  }
  const _ = (e, t) => {
    const { params: s, el: i, wrapperEl: r, device: a } = e,
      n = !!s.nested,
      l = 'on' === t ? 'addEventListener' : 'removeEventListener',
      o = t;
    if (!i || 'string' == typeof i) return;
    (document[l]('touchstart', e.onDocumentTouchStart, {
      passive: !1,
      capture: n,
    }),
      i[l]('touchstart', e.onTouchStart, { passive: !1 }),
      i[l]('pointerdown', e.onTouchStart, { passive: !1 }),
      document[l]('touchmove', e.onTouchMove, { passive: !1, capture: n }),
      document[l]('pointermove', e.onTouchMove, { passive: !1, capture: n }),
      document[l]('touchend', e.onTouchEnd, { passive: !0 }),
      document[l]('pointerup', e.onTouchEnd, { passive: !0 }),
      document[l]('pointercancel', e.onTouchEnd, { passive: !0 }),
      document[l]('touchcancel', e.onTouchEnd, { passive: !0 }),
      document[l]('pointerout', e.onTouchEnd, { passive: !0 }),
      document[l]('pointerleave', e.onTouchEnd, { passive: !0 }),
      document[l]('contextmenu', e.onTouchEnd, { passive: !0 }),
      (s.preventClicks || s.preventClicksPropagation) &&
        i[l]('click', e.onClick, !0),
      s.cssMode && r[l]('scroll', e.onScroll));
    const d = t => {
      e[o](t, H, !0);
    };
    (s.updateOnWindowResize
      ? d(
          a.ios || a.android
            ? 'resize orientationchange observerUpdate'
            : 'resize observerUpdate'
        )
      : d('observerUpdate'),
      i[l]('load', e.onLoad, { capture: !0 }));
  };
  var W = {
    loopCreate: function (e, t) {
      const s = this,
        { params: i, slidesEl: r } = s;
      if (!i.loop || (s.virtual && s.params.virtual?.enabled)) return;
      const a = () => {
          d(r, `.${i.slideClass}, swiper-slide`).forEach((e, t) => {
            e.setAttribute('data-swiper-slide-index', String(t));
          });
        },
        n = s.grid && i.grid && i.grid.rows > 1;
      i.loopAddBlankSlides &&
        (i.slidesPerGroup > 1 || n) &&
        (() => {
          const e = d(r, `.${i.slideBlankClass}`);
          (e.forEach(e => {
            e.remove();
          }),
            e.length > 0 && (s.recalcSlides(), s.updateSlides()));
        })();
      const l = i.slidesPerGroup * (n ? i.grid.rows : 1),
        o = s.slides.length % l !== 0,
        u = n && s.slides.length % i.grid.rows !== 0,
        m = e => {
          for (let t = 0; t < e; t += 1) {
            const e = s.isElement
              ? p('swiper-slide', [i.slideBlankClass])
              : p('div', [i.slideClass, i.slideBlankClass]);
            s.slidesEl.append(e);
          }
        };
      if (o) {
        if (i.loopAddBlankSlides) {
          (m(l - (s.slides.length % l)), s.recalcSlides(), s.updateSlides());
        } else
          c(
            'Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
          );
        a();
      } else if (u) {
        if (i.loopAddBlankSlides) {
          (m(i.grid.rows - (s.slides.length % i.grid.rows)),
            s.recalcSlides(),
            s.updateSlides());
        } else
          c(
            'Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
          );
        a();
      } else a();
      const h =
        i.centeredSlides || !!i.slidesOffsetBefore || !!i.slidesOffsetAfter;
      s.loopFix({
        slideRealIndex: e,
        direction: h ? void 0 : 'next',
        initial: t,
      });
    },
    loopFix: function (e = {}) {
      const {
        slideRealIndex: t,
        slideTo: s = !0,
        direction: i,
        setTranslate: r,
        activeSlideIndex: a,
        initial: n,
        byController: l,
        byMousewheel: o,
      } = e;
      let d = a;
      const p = this;
      if (!p.params.loop) return;
      p.emit('beforeLoopFix');
      const {
          slides: u,
          allowSlidePrev: m,
          allowSlideNext: h,
          slidesEl: f,
          params: g,
        } = p,
        {
          centeredSlides: v,
          slidesOffsetBefore: w,
          slidesOffsetAfter: b,
          initialSlide: y,
        } = g,
        E = v || !!w || !!b;
      if (
        ((p.allowSlidePrev = !0),
        (p.allowSlideNext = !0),
        p.virtual && g.virtual?.enabled)
      ) {
        if (s) {
          const e = p.virtual.slides.length,
            t = p.virtual.slidesBefore ?? 0;
          E || 0 !== p.snapIndex
            ? E && p.snapIndex < g.slidesPerView
              ? p.slideTo(e + p.snapIndex, 0, !1, !0)
              : p.snapIndex === p.snapGrid.length - 1 && p.slideTo(t, 0, !1, !0)
            : p.slideTo(e, 0, !1, !0);
        }
        return (
          (p.allowSlidePrev = m),
          (p.allowSlideNext = h),
          void p.emit('loopFix')
        );
      }
      let S = g.slidesPerView;
      'auto' === S
        ? (S = p.slidesPerViewDynamic())
        : ((S = Math.ceil(parseFloat(String(g.slidesPerView)))),
          E && S % 2 == 0 && (S += 1));
      const x = g.slidesPerGroupAuto ? S : g.slidesPerGroup;
      let T = E ? Math.max(x, Math.ceil(S / 2)) : x;
      (T % x !== 0 && (T += x - (T % x)),
        (T += g.loopAdditionalSlides),
        (p.loopedSlides = T));
      const M = p.grid && g.grid && g.grid.rows > 1;
      u.length < S + T || ('cards' === p.params.effect && u.length < S + 2 * T)
        ? c(
            'Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters'
          )
        : M &&
          'row' === g.grid.fill &&
          c(
            'Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`'
          );
      const C = [],
        P = [],
        L = M ? Math.ceil(u.length / g.grid.rows) : u.length,
        A = n && L - y < S && !E;
      let I = A ? y : p.activeIndex;
      void 0 === d
        ? (d = p.getSlideIndex(
            u.find(e => e.classList.contains(g.slideActiveClass))
          ))
        : (I = d);
      const z = 'next' === i || !i,
        $ = 'prev' === i || !i;
      let k = 0,
        O = 0;
      const D =
        (M ? (u[d].column ?? 0) : d) + (E && void 0 === r ? -S / 2 + 0.5 : 0);
      if (D < T) {
        k = Math.max(T - D, x);
        for (let e = 0; e < T - D; e += 1) {
          const t = e - Math.floor(e / L) * L;
          if (M) {
            const e = L - t - 1;
            for (let t = u.length - 1; t >= 0; t -= 1)
              u[t].column === e && C.push(t);
          } else C.push(L - t - 1);
        }
      } else if (D + S > L - T) {
        ((O = Math.max(D - (L - 2 * T), x)),
          A && (O = Math.max(O, S - L + y + 1)));
        for (let e = 0; e < O; e += 1) {
          const t = e - Math.floor(e / L) * L;
          M
            ? u.forEach((e, s) => {
                e.column === t && P.push(s);
              })
            : P.push(t);
        }
      }
      if (
        ((p.__preventObserver__ = !0),
        requestAnimationFrame(() => {
          p.__preventObserver__ = !1;
        }),
        'cards' === p.params.effect &&
          u.length < S + 2 * T &&
          (P.includes(d) && P.splice(P.indexOf(d), 1),
          C.includes(d) && C.splice(C.indexOf(d), 1)),
        $ &&
          C.forEach(e => {
            const t = u[e];
            ((t.swiperLoopMoveDOM = !0),
              f.prepend(t),
              (t.swiperLoopMoveDOM = !1));
          }),
        z &&
          P.forEach(e => {
            const t = u[e];
            ((t.swiperLoopMoveDOM = !0),
              f.append(t),
              (t.swiperLoopMoveDOM = !1));
          }),
        p.recalcSlides(),
        'auto' === g.slidesPerView
          ? p.updateSlides()
          : M &&
            ((C.length > 0 && $) || (P.length > 0 && z)) &&
            p.slides.forEach((e, t) => {
              p.grid.updateSlide(t, e, p.slides);
            }),
        g.watchSlidesProgress && p.updateSlidesOffset(),
        s)
      )
        if (C.length > 0 && $) {
          if (void 0 === t) {
            const e = p.slidesGrid[I],
              t = p.slidesGrid[I + k] - e;
            o
              ? p.setTranslate(p.translate - t)
              : (p.slideTo(I + Math.ceil(k), 0, !1, !0),
                r &&
                  ((p.touchEventsData.startTranslate =
                    p.touchEventsData.startTranslate - t),
                  (p.touchEventsData.currentTranslate =
                    p.touchEventsData.currentTranslate - t)));
          } else if (r) {
            const e = M ? C.length / g.grid.rows : C.length;
            (p.slideTo(p.activeIndex + e, 0, !1, !0),
              (p.touchEventsData.currentTranslate = p.translate));
          }
        } else if (P.length > 0 && z)
          if (void 0 === t) {
            const e = p.slidesGrid[I],
              t = p.slidesGrid[I - O] - e;
            o
              ? p.setTranslate(p.translate - t)
              : (p.slideTo(I - O, 0, !1, !0),
                r &&
                  ((p.touchEventsData.startTranslate =
                    p.touchEventsData.startTranslate - t),
                  (p.touchEventsData.currentTranslate =
                    p.touchEventsData.currentTranslate - t)));
          } else {
            const e = M ? P.length / g.grid.rows : P.length;
            p.slideTo(p.activeIndex - e, 0, !1, !0);
          }
      ((p.allowSlidePrev = m), (p.allowSlideNext = h));
      const G = p.controller?.control;
      if (G && !l) {
        const e = {
          slideRealIndex: t,
          direction: i,
          setTranslate: r,
          activeSlideIndex: d,
          byController: !0,
        };
        Array.isArray(G)
          ? G.forEach(t => {
              !t.destroyed &&
                t.params.loop &&
                t.loopFix({
                  ...e,
                  slideTo: t.params.slidesPerView === g.slidesPerView && s,
                });
            })
          : G instanceof p.constructor &&
            G.params.loop &&
            G.loopFix({
              ...e,
              slideTo: G.params.slidesPerView === g.slidesPerView && s,
            });
      }
      p.emit('loopFix');
    },
    loopDestroy: function () {
      const e = this,
        { params: t, slidesEl: s } = e;
      if (!t.loop || !s || (e.virtual && e.params.virtual?.enabled)) return;
      e.recalcSlides();
      const i = [];
      (e.slides.forEach(e => {
        const t = e,
          s =
            void 0 === t.swiperSlideIndex
              ? Number(e.getAttribute('data-swiper-slide-index'))
              : t.swiperSlideIndex;
        i[s] = e;
      }),
        e.slides.forEach(e => {
          e.removeAttribute('data-swiper-slide-index');
        }),
        i.forEach(e => {
          s.append(e);
        }),
        e.recalcSlides(),
        e.slideTo(e.realIndex, 0));
    },
  };
  function F(e, t) {
    return function (s = {}) {
      const i = Object.keys(s)[0],
        r = s[i];
      'object' == typeof r && null !== r
        ? (!0 === e[i] && (e[i] = { enabled: !0 }),
          'navigation' === i &&
            e[i] &&
            e[i].enabled &&
            !e[i].prevEl &&
            !e[i].nextEl &&
            (e[i].auto = !0),
          ['pagination', 'scrollbar'].indexOf(i) >= 0 &&
            e[i] &&
            e[i].enabled &&
            !e[i].el &&
            (e[i].auto = !0),
          i in e && 'enabled' in r
            ? ('object' != typeof e[i] ||
                'enabled' in e[i] ||
                (e[i].enabled = !0),
              e[i] || (e[i] = { enabled: !1 }),
              n(t, s))
            : n(t, s))
        : n(t, s);
    };
  }
  var j = {
    slideTo: function (e = 0, t, s = !0, i, r) {
      'string' == typeof e && (e = parseInt(e, 10));
      const a = this;
      let n = e;
      n < 0 && (n = 0);
      const {
        params: l,
        snapGrid: o,
        slidesGrid: d,
        previousIndex: c,
        activeIndex: p,
        rtlTranslate: u,
        wrapperEl: m,
        enabled: h,
      } = a;
      if (
        (!h && !i && !r) ||
        a.destroyed ||
        (a.animating && l.preventInteractionOnTransition)
      )
        return !1;
      void 0 === t && (t = a.params.speed);
      const f = Math.min(a.params.slidesPerGroupSkip, n);
      let g = f + Math.floor((n - f) / a.params.slidesPerGroup);
      g >= o.length && (g = o.length - 1);
      const v = -o[g];
      if (l.normalizeSlideIndex)
        for (let e = 0; e < d.length; e += 1) {
          const t = -Math.floor(100 * v),
            s = Math.floor(100 * d[e]),
            i = Math.floor(100 * d[e + 1]);
          void 0 !== d[e + 1]
            ? t >= s && t < i - (i - s) / 2
              ? (n = e)
              : t >= s && t < i && (n = e + 1)
            : t >= s && (n = e);
        }
      if (a.initialized && n !== p) {
        if (
          !a.allowSlideNext &&
          (u
            ? v > a.translate && v > a.minTranslate()
            : v < a.translate && v < a.minTranslate())
        )
          return !1;
        if (
          !a.allowSlidePrev &&
          v > a.translate &&
          v > a.maxTranslate() &&
          (p || 0) !== n
        )
          return !1;
      }
      let w;
      (n !== (c || 0) && s && a.emit('beforeSlideChangeStart'),
        a.updateProgress(v),
        (w = n > p ? 'next' : n < p ? 'prev' : 'reset'));
      const b = a.virtual && a.params.virtual?.enabled;
      if (!(b && r) && ((u && -v === a.translate) || (!u && v === a.translate)))
        return (
          a.updateActiveIndex(n),
          l.autoHeight && a.updateAutoHeight(),
          a.updateSlidesClasses(),
          'slide' !== l.effect && a.setTranslate(v),
          'reset' !== w && (a.transitionStart(s, w), a.transitionEnd(s, w)),
          !1
        );
      if (l.cssMode) {
        const e = a.isHorizontal(),
          s = u ? v : -v;
        return (
          0 === t
            ? (b &&
                ((a.wrapperEl.style.scrollSnapType = 'none'),
                (a._immediateVirtual = !0)),
              b &&
              !a._cssModeVirtualInitialSet &&
              (a.params.initialSlide ?? 0) > 0
                ? ((a._cssModeVirtualInitialSet = !0),
                  requestAnimationFrame(() => {
                    m[e ? 'scrollLeft' : 'scrollTop'] = s;
                  }))
                : (m[e ? 'scrollLeft' : 'scrollTop'] = s),
              b &&
                requestAnimationFrame(() => {
                  ((a.wrapperEl.style.scrollSnapType = ''),
                    (a._immediateVirtual = !1));
                }))
            : m.scrollTo({ [e ? 'left' : 'top']: s, behavior: 'smooth' }),
          !0
        );
      }
      const y = C().isSafari;
      return (
        b && !r && y && a.isElement && a.virtual.update(!1, !1, n),
        a.setTransition(t),
        a.setTranslate(v),
        a.updateActiveIndex(n),
        a.updateSlidesClasses(),
        a.emit('beforeTransitionStart', t, i),
        a.transitionStart(s, w),
        0 === t
          ? a.transitionEnd(s, w)
          : a.animating ||
            ((a.animating = !0),
            a.onSlideToWrapperTransitionEnd ||
              (a.onSlideToWrapperTransitionEnd = function (e) {
                a &&
                  !a.destroyed &&
                  e.target === this &&
                  (a.wrapperEl.removeEventListener(
                    'transitionend',
                    a.onSlideToWrapperTransitionEnd
                  ),
                  (a.onSlideToWrapperTransitionEnd = null),
                  delete a.onSlideToWrapperTransitionEnd,
                  a.transitionEnd(s, w));
              }),
            a.wrapperEl.addEventListener(
              'transitionend',
              a.onSlideToWrapperTransitionEnd
            )),
        !0
      );
    },
    slideToLoop: function (e = 0, t, s = !0, i) {
      if ('string' == typeof e) {
        e = parseInt(e, 10);
      }
      const r = this;
      if (r.destroyed) return;
      void 0 === t && (t = r.params.speed);
      const a = r.grid && r.params.grid && r.params.grid.rows > 1;
      let n = e;
      if (r.params.loop)
        if (r.virtual && r.params.virtual?.enabled)
          n += r.virtual.slidesBefore ?? 0;
        else {
          let e;
          if (a) {
            const t = n * r.params.grid.rows,
              s = r.slides.find(
                e => Number(e.getAttribute('data-swiper-slide-index')) === t
              );
            e = s?.column ?? 0;
          } else e = r.getSlideIndexByData(n);
          const t = a
              ? Math.ceil(r.slides.length / r.params.grid.rows)
              : r.slides.length,
            {
              centeredSlides: s,
              slidesOffsetBefore: l,
              slidesOffsetAfter: o,
            } = r.params,
            d = s || !!l || !!o;
          let c;
          'auto' === r.params.slidesPerView
            ? (c = r.slidesPerViewDynamic())
            : ((c = Math.ceil(parseFloat(String(r.params.slidesPerView)))),
              d && c % 2 == 0 && (c += 1));
          let p = t - e < c;
          if (
            (d && (p = p || e < Math.ceil(c / 2)),
            i && d && 'auto' !== r.params.slidesPerView && !a && (p = !1),
            p)
          ) {
            const s = d
              ? e < r.activeIndex
                ? 'prev'
                : 'next'
              : e - r.activeIndex - 1 < r.params.slidesPerView
                ? 'next'
                : 'prev';
            r.loopFix({
              direction: s,
              slideTo: !0,
              activeSlideIndex: 'next' === s ? e + 1 : e - t + 1,
              slideRealIndex: 'next' === s ? r.realIndex : void 0,
            });
          }
          if (a) {
            const e = n * r.params.grid.rows,
              t = r.slides.find(
                t => Number(t.getAttribute('data-swiper-slide-index')) === e
              );
            n = t?.column ?? 0;
          } else n = r.getSlideIndexByData(n);
        }
      return (
        requestAnimationFrame(() => {
          r.slideTo(n, t, s, i);
        }),
        r
      );
    },
    slideNext: function (e, t = !0, s) {
      const i = this,
        { enabled: r, params: a, animating: n } = i;
      if (!r || i.destroyed) return i;
      void 0 === e && (e = i.params.speed);
      let l = a.slidesPerGroup;
      'auto' === a.slidesPerView &&
        1 === a.slidesPerGroup &&
        a.slidesPerGroupAuto &&
        (l = Math.max(i.slidesPerViewDynamic('current', !0), 1));
      const o = i.activeIndex < a.slidesPerGroupSkip ? 1 : l,
        d = i.virtual && a.virtual?.enabled;
      if (a.loop) {
        if (n && !d && a.loopPreventsSliding) return !1;
        if (
          (i.loopFix({ direction: 'next' }),
          (i._clientLeft = i.wrapperEl.clientLeft),
          i.activeIndex === i.slides.length - 1 && a.cssMode)
        )
          return (
            requestAnimationFrame(() => {
              i.slideTo(i.activeIndex + o, e, t, s);
            }),
            !0
          );
      }
      return a.rewind && i.isEnd
        ? i.slideTo(0, e, t, s)
        : i.slideTo(i.activeIndex + o, e, t, s);
    },
    slidePrev: function (e, t = !0, s) {
      const i = this,
        {
          params: r,
          snapGrid: a,
          slidesGrid: n,
          rtlTranslate: l,
          enabled: o,
          animating: d,
        } = i;
      if (!o || i.destroyed) return i;
      void 0 === e && (e = i.params.speed);
      const c = i.virtual && r.virtual?.enabled;
      if (r.loop) {
        if (d && !c && r.loopPreventsSliding) return !1;
        (i.loopFix({ direction: 'prev' }),
          (i._clientLeft = i.wrapperEl.clientLeft));
      }
      function p(e) {
        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
      }
      const u = p(l ? i.translate : -i.translate),
        m = a.map(e => p(e)),
        h = r.freeMode && r.freeMode.enabled;
      let f = a[m.indexOf(u) - 1];
      if (void 0 === f && (r.cssMode || h)) {
        let e;
        (a.forEach((t, s) => {
          u >= t && (e = s);
        }),
          void 0 !== e && (f = h ? a[e] : a[e > 0 ? e - 1 : e]));
      }
      let g = 0;
      if (
        (void 0 !== f &&
          ((g = n.indexOf(f)),
          g < 0 && (g = i.activeIndex - 1),
          'auto' === r.slidesPerView &&
            1 === r.slidesPerGroup &&
            r.slidesPerGroupAuto &&
            ((g = g - i.slidesPerViewDynamic('previous', !0) + 1),
            (g = Math.max(g, 0)))),
        r.rewind && i.isBeginning)
      ) {
        const r =
          i.params.virtual?.enabled && i.virtual
            ? i.virtual.slides.length - 1
            : i.slides.length - 1;
        return i.slideTo(r, e, t, s);
      }
      return r.loop && 0 === i.activeIndex && r.cssMode
        ? (requestAnimationFrame(() => {
            i.slideTo(g, e, t, s);
          }),
          !0)
        : i.slideTo(g, e, t, s);
    },
    slideReset: function (e, t = !0, s) {
      const i = this;
      if (!i.destroyed)
        return (
          void 0 === e && (e = i.params.speed),
          i.slideTo(i.activeIndex, e, t, s)
        );
    },
    slideToClosest: function (e, t = !0, s, i = 0.5) {
      const r = this;
      if (r.destroyed) return;
      void 0 === e && (e = r.params.speed);
      let a = r.activeIndex;
      const n = Math.min(r.params.slidesPerGroupSkip, a),
        l = n + Math.floor((a - n) / r.params.slidesPerGroup),
        o = r.rtlTranslate ? r.translate : -r.translate;
      if (o >= r.snapGrid[l]) {
        const e = r.snapGrid[l];
        o - e > (r.snapGrid[l + 1] - e) * i && (a += r.params.slidesPerGroup);
      } else {
        const e = r.snapGrid[l - 1];
        o - e <= (r.snapGrid[l] - e) * i && (a -= r.params.slidesPerGroup);
      }
      return (
        (a = Math.max(a, 0)),
        (a = Math.min(a, r.slidesGrid.length - 1)),
        r.slideTo(a, e, t, s)
      );
    },
    slideToClickedSlide: function () {
      const e = this;
      if (e.destroyed) return;
      const { params: s, slidesEl: i, clickedSlide: r, clickedIndex: a } = e;
      if (void 0 === r || void 0 === a) return;
      const n =
        'auto' === s.slidesPerView ? e.slidesPerViewDynamic() : s.slidesPerView;
      let l,
        o = e.getSlideIndexWhenGrid(a);
      const c = e.isElement ? 'swiper-slide' : `.${s.slideClass}`,
        p = e.grid && e.params.grid && e.params.grid.rows > 1;
      if (s.loop) {
        if (e.animating) return;
        ((l = parseInt(r.getAttribute('data-swiper-slide-index'), 10)),
          s.centeredSlides
            ? e.slideToLoop(l)
            : o >
                (p
                  ? (e.slides.length - n) / 2 - (e.params.grid.rows - 1)
                  : e.slides.length - n)
              ? (e.loopFix(),
                (o = e.getSlideIndex(
                  d(i, `${c}[data-swiper-slide-index="${l}"]`)[0]
                )),
                t(() => {
                  e.slideTo(o);
                }))
              : e.slideTo(o));
      } else e.slideTo(o);
    },
  };
  function U({ swiper: e, runCallbacks: t, direction: s, step: i }) {
    const { activeIndex: r, previousIndex: a } = e;
    let n = s;
    (n || (n = r > a ? 'next' : r < a ? 'prev' : 'reset'),
      e.emit(`transition${i}`),
      t && 'reset' === n
        ? e.emit(`slideResetTransition${i}`)
        : t &&
          r !== a &&
          (e.emit(`slideChangeTransition${i}`),
          'next' === n
            ? e.emit(`slideNextTransition${i}`)
            : e.emit(`slidePrevTransition${i}`)));
  }
  var K = {
    getTranslate: function (e = this.isHorizontal() ? 'x' : 'y') {
      const { params: t, rtlTranslate: s, translate: r, wrapperEl: a } = this;
      if (t.virtualTranslate) return s ? -r : r;
      if (t.cssMode) return r;
      let n = i(a, e);
      return ((n += this.cssOverflowAdjustment()), s && (n = -n), n || 0);
    },
    setTranslate: function (e, t) {
      const s = this,
        { rtlTranslate: i, params: r, wrapperEl: a, progress: n } = s;
      let l,
        o = 0,
        d = 0;
      (s.isHorizontal() ? (o = i ? -e : e) : (d = e),
        r.roundLengths && ((o = Math.floor(o)), (d = Math.floor(d))),
        (s.previousTranslate = s.translate),
        (s.translate = s.isHorizontal() ? o : d),
        r.cssMode
          ? (a[s.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = s.isHorizontal()
              ? -o
              : -d)
          : r.virtualTranslate ||
            (s.isHorizontal()
              ? (o -= s.cssOverflowAdjustment())
              : (d -= s.cssOverflowAdjustment()),
            (a.style.transform = `translate3d(${o}px, ${d}px, 0px)`)));
      const c = s.maxTranslate() - s.minTranslate();
      ((l = 0 === c ? 0 : (e - s.minTranslate()) / c),
        l !== n && s.updateProgress(e),
        s.emit('setTranslate', s.translate, t));
    },
    minTranslate: function () {
      return -this.snapGrid[0];
    },
    maxTranslate: function () {
      return -this.snapGrid[this.snapGrid.length - 1];
    },
    translateTo: function (e = 0, t = this.params.speed, s = !0, i = !0, r) {
      const a = this,
        { params: n, wrapperEl: l } = a;
      if (a.animating && n.preventInteractionOnTransition) return !1;
      const o = a.minTranslate(),
        d = a.maxTranslate();
      let c;
      if (
        ((c = i && e > o ? o : i && e < d ? d : e),
        a.updateProgress(c),
        n.cssMode)
      ) {
        const e = a.isHorizontal();
        return (
          0 === t
            ? (l[e ? 'scrollLeft' : 'scrollTop'] = -c)
            : l.scrollTo({ [e ? 'left' : 'top']: -c, behavior: 'smooth' }),
          !0
        );
      }
      return (
        0 === t
          ? (a.setTransition(0),
            a.setTranslate(c),
            s &&
              (a.emit('beforeTransitionStart', t, r), a.emit('transitionEnd')))
          : (a.setTransition(t),
            a.setTranslate(c),
            s &&
              (a.emit('beforeTransitionStart', t, r),
              a.emit('transitionStart')),
            a.animating ||
              ((a.animating = !0),
              a.onTranslateToWrapperTransitionEnd ||
                (a.onTranslateToWrapperTransitionEnd = function (e) {
                  a &&
                    !a.destroyed &&
                    e.target === this &&
                    (a.wrapperEl.removeEventListener(
                      'transitionend',
                      a.onTranslateToWrapperTransitionEnd
                    ),
                    (a.onTranslateToWrapperTransitionEnd = null),
                    delete a.onTranslateToWrapperTransitionEnd,
                    (a.animating = !1),
                    s && a.emit('transitionEnd'));
                }),
              a.wrapperEl.addEventListener(
                'transitionend',
                a.onTranslateToWrapperTransitionEnd
              ))),
        !0
      );
    },
  };
  const Z = (e, t, s) => {
    t && !e.classList.contains(s)
      ? e.classList.add(s)
      : !t && e.classList.contains(s) && e.classList.remove(s);
  };
  const Q = (e, t, s) => {
    t && !e.classList.contains(s)
      ? e.classList.add(s)
      : !t && e.classList.contains(s) && e.classList.remove(s);
  };
  var J = {
    updateSize: function () {
      const e = this;
      let t, s;
      const i = e.el;
      ((t =
        void 0 !== e.params.width && null !== e.params.width
          ? e.params.width
          : i.clientWidth),
        (s =
          void 0 !== e.params.height && null !== e.params.height
            ? e.params.height
            : i.clientHeight),
        (0 === t && e.isHorizontal()) ||
          (0 === s && e.isVertical()) ||
          ((t =
            t -
            parseInt(m(i, 'padding-left') || '0', 10) -
            parseInt(m(i, 'padding-right') || '0', 10)),
          (s =
            s -
            parseInt(m(i, 'padding-top') || '0', 10) -
            parseInt(m(i, 'padding-bottom') || '0', 10)),
          Number.isNaN(t) && (t = 0),
          Number.isNaN(s) && (s = 0),
          Object.assign(e, {
            width: t,
            height: s,
            size: e.isHorizontal() ? t : s,
          })));
    },
    updateSlides: function () {
      const e = this;
      function t(t, s) {
        return parseFloat(t.getPropertyValue(e.getDirectionLabel(s)) || '0');
      }
      const s = e.params,
        { wrapperEl: i, slidesEl: r, rtlTranslate: a, wrongRTL: n } = e,
        o = !(!e.virtual || !s.virtual?.enabled),
        c = o ? e.virtual.slides.length : e.slides.length,
        p = d(r, `.${e.params.slideClass}, swiper-slide`),
        u = o ? e.virtual.slides.length : p.length;
      let h = [];
      const f = [],
        g = [],
        w = t => ('function' == typeof t ? t.call(e) : t),
        b = w(s.slidesOffsetBefore),
        y = w(s.slidesOffsetAfter),
        E = e.snapGrid.length,
        S = e.slidesGrid.length,
        x = e.size - b - y;
      let T = s.spaceBetween,
        M = -b,
        C = 0,
        P = 0;
      if (void 0 === x) return;
      ('string' == typeof T && T.indexOf('%') >= 0
        ? (T = (parseFloat(T.replace('%', '')) / 100) * x)
        : 'string' == typeof T && (T = parseFloat(T)),
        (e.virtualSize = -T - b - y),
        p.forEach(e => {
          (a ? (e.style.marginLeft = '') : (e.style.marginRight = ''),
            (e.style.marginBottom = ''),
            (e.style.marginTop = ''));
        }),
        s.centeredSlides &&
          s.cssMode &&
          (l(i, '--swiper-centered-offset-before', ''),
          l(i, '--swiper-centered-offset-after', '')),
        s.cssMode &&
          (l(i, '--swiper-slides-offset-before', `${b}px`),
          l(i, '--swiper-slides-offset-after', `${y}px`)));
      const L = s.grid && s.grid.rows > 1 && e.grid;
      L ? e.grid.initSlides(p) : e.grid && e.grid.unsetSlides();
      let A = 0;
      const I =
        'auto' === s.slidesPerView &&
        s.breakpoints &&
        Object.keys(s.breakpoints).filter(e => {
          const t = s.breakpoints[e];
          return void 0 !== t?.slidesPerView;
        }).length > 0;
      for (let i = 0; i < u; i += 1) {
        A = 0;
        const r = p[i];
        if (
          !r ||
          (L && e.grid.updateSlide(i, r, p), 'none' !== m(r, 'display'))
        ) {
          if (o && 'auto' === s.slidesPerView)
            (s.virtual?.slidesPerViewAutoSlideSize &&
              (A = s.virtual.slidesPerViewAutoSlideSize),
              A &&
                r &&
                (s.roundLengths && (A = Math.floor(A)),
                (r.style[e.getDirectionLabel('width')] = `${A}px`)));
          else if ('auto' === s.slidesPerView) {
            I && (r.style[e.getDirectionLabel('width')] = '');
            const i = getComputedStyle(r),
              a = r.style.transform,
              n = r.style.webkitTransform;
            if (
              (a && (r.style.transform = 'none'),
              n && (r.style.webkitTransform = 'none'),
              s.roundLengths)
            )
              A = e.isHorizontal() ? v(r, 'width') : v(r, 'height');
            else {
              const e = t(i, 'width'),
                s = t(i, 'padding-left'),
                a = t(i, 'padding-right'),
                n = t(i, 'margin-left'),
                l = t(i, 'margin-right'),
                o = i.getPropertyValue('box-sizing');
              if (o && 'border-box' === o) A = e + n + l;
              else {
                const { clientWidth: t, offsetWidth: i } = r;
                A = e + s + a + n + l + (i - t);
              }
            }
            (a && (r.style.transform = a),
              n && (r.style.webkitTransform = n),
              s.roundLengths && (A = Math.floor(A)));
          } else
            ((A = (x - (s.slidesPerView - 1) * T) / s.slidesPerView),
              s.roundLengths && (A = Math.floor(A)),
              r && (r.style[e.getDirectionLabel('width')] = `${A}px`));
          (r && (r.swiperSlideSize = A),
            g.push(A),
            s.centeredSlides
              ? ((M = M + A / 2 + C / 2 + T),
                0 === C && 0 !== i && (M = M - x / 2 - T),
                0 === i && (M = M - x / 2 - T),
                Math.abs(M) < 0.001 && (M = 0),
                s.roundLengths && (M = Math.floor(M)),
                P % s.slidesPerGroup === 0 && h.push(M),
                f.push(M))
              : (s.roundLengths && (M = Math.floor(M)),
                (P - Math.min(e.params.slidesPerGroupSkip, P)) %
                  e.params.slidesPerGroup ===
                  0 && h.push(M),
                f.push(M),
                (M = M + A + T)),
            (e.virtualSize += A + T),
            (C = A),
            (P += 1));
        }
      }
      if (
        ((e.virtualSize = Math.max(e.virtualSize, x) + y),
        a &&
          n &&
          ('slide' === s.effect || 'coverflow' === s.effect) &&
          (i.style.width = `${e.virtualSize + T}px`),
        s.setWrapperSize &&
          (i.style[e.getDirectionLabel('width')] = `${e.virtualSize + T}px`),
        L && e.grid.updateWrapperSize(A, h),
        !s.centeredSlides)
      ) {
        const t = 'auto' !== s.slidesPerView && s.slidesPerView % 1 != 0,
          i = s.snapToSlideEdge && !s.loop && ('auto' === s.slidesPerView || t);
        let r = h.length;
        if (i) {
          let e;
          if ('auto' === s.slidesPerView) {
            e = 1;
            let t = 0;
            for (
              let s = g.length - 1;
              s >= 0 && ((t += g[s] + (s < g.length - 1 ? T : 0)), t <= x);
              s -= 1
            )
              e = g.length - s;
          } else e = Math.floor(s.slidesPerView);
          r = Math.max(u - e, 0);
        }
        const a = [];
        for (let t = 0; t < h.length; t += 1) {
          let n = h[t];
          (s.roundLengths && (n = Math.floor(n)),
            i ? t <= r && a.push(n) : h[t] <= e.virtualSize - x && a.push(n));
        }
        ((h = a),
          Math.floor(e.virtualSize - x) - Math.floor(h[h.length - 1]) > 1 &&
            (i || h.push(e.virtualSize - x)));
      }
      if (o && s.loop) {
        const t = g[0] + T,
          i = (e.virtual.slidesBefore ?? 0) + (e.virtual.slidesAfter ?? 0);
        if (s.slidesPerGroup > 1) {
          const e = Math.ceil(i / s.slidesPerGroup),
            r = t * s.slidesPerGroup;
          for (let t = 0; t < e; t += 1) h.push(h[h.length - 1] + r);
        }
        for (let r = 0; r < i; r += 1)
          (1 === s.slidesPerGroup && h.push(h[h.length - 1] + t),
            f.push(f[f.length - 1] + t),
            (e.virtualSize += t));
      }
      if ((0 === h.length && (h = [0]), 0 !== T)) {
        const t =
          e.isHorizontal() && a
            ? 'marginLeft'
            : e.getDirectionLabel('marginRight');
        p.filter(
          (e, t) => !(s.cssMode && !s.loop) || t !== p.length - 1
        ).forEach(e => {
          e.style[t] = `${T}px`;
        });
      }
      if (s.centeredSlides && s.centeredSlidesBounds) {
        let e = 0;
        (g.forEach(t => {
          e += t + (T || 0);
        }),
          (e -= T));
        const t = e > x ? e - x : 0;
        h = h.map(e => (e <= 0 ? -b : e > t ? t + y : e));
      }
      if (s.centerInsufficientSlides) {
        let e = 0;
        if (
          (g.forEach(t => {
            e += t + (T || 0);
          }),
          (e -= T),
          e < x)
        ) {
          const t = (x - e) / 2;
          (h.forEach((e, s) => {
            h[s] = e - t;
          }),
            f.forEach((e, s) => {
              f[s] = e + t;
            }));
        }
      }
      if (
        (Object.assign(e, {
          slides: p,
          snapGrid: h,
          slidesGrid: f,
          slidesSizesGrid: g,
        }),
        s.centeredSlides && s.cssMode && !s.centeredSlidesBounds)
      ) {
        (l(i, '--swiper-centered-offset-before', -h[0] + 'px'),
          l(
            i,
            '--swiper-centered-offset-after',
            e.size / 2 - g[g.length - 1] / 2 + 'px'
          ));
        const t = -e.snapGrid[0],
          s = -e.slidesGrid[0];
        ((e.snapGrid = e.snapGrid.map(e => e + t)),
          (e.slidesGrid = e.slidesGrid.map(e => e + s)));
      }
      if (
        (u !== c && e.emit('slidesLengthChange'),
        h.length !== E &&
          (e.params.watchOverflow && e.checkOverflow(),
          e.emit('snapGridLengthChange')),
        f.length !== S && e.emit('slidesGridLengthChange'),
        s.watchSlidesProgress && e.updateSlidesOffset(),
        e.emit('slidesUpdated'),
        !(o || s.cssMode || ('slide' !== s.effect && 'fade' !== s.effect)))
      ) {
        const t = `${s.containerModifierClass}backface-hidden`,
          i = e.el.classList.contains(t);
        u <= s.maxBackfaceHiddenSlides
          ? i || e.el.classList.add(t)
          : i && e.el.classList.remove(t);
      }
    },
    updateAutoHeight: function (e) {
      const t = this,
        s = [],
        i = t.virtual && t.params.virtual?.enabled;
      let r,
        a = 0;
      'number' == typeof e
        ? t.setTransition(e)
        : !0 === e && t.setTransition(t.params.speed);
      const n = e => (i ? t.slides[t.getSlideIndexByData(e)] : t.slides[e]);
      if ('auto' !== t.params.slidesPerView && t.params.slidesPerView > 1)
        if (t.params.centeredSlides)
          (t.visibleSlides || []).forEach(e => {
            s.push(e);
          });
        else
          for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
            const e = t.activeIndex + r;
            if (e > t.slides.length && !i) break;
            const a = n(e);
            a && s.push(a);
          }
      else {
        const e = n(t.activeIndex);
        e && s.push(e);
      }
      for (r = 0; r < s.length; r += 1)
        if (void 0 !== s[r]) {
          const e = s[r].offsetHeight;
          a = e > a ? e : a;
        }
      (a || 0 === a) && (t.wrapperEl.style.height = `${a}px`);
    },
    updateSlidesOffset: function () {
      const e = this,
        t = e.slides,
        s = e.isElement
          ? e.isHorizontal()
            ? e.wrapperEl.offsetLeft
            : e.wrapperEl.offsetTop
          : 0;
      for (let i = 0; i < t.length; i += 1)
        t[i].swiperSlideOffset =
          (e.isHorizontal() ? t[i].offsetLeft : t[i].offsetTop) -
          s -
          e.cssOverflowAdjustment();
    },
    updateSlidesProgress: function (e = (this && this.translate) || 0) {
      const t = this,
        s = t.params,
        { slides: i, rtlTranslate: r, snapGrid: a } = t;
      if (0 === i.length) return;
      void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
      let n = -e;
      (r && (n = e), (t.visibleSlidesIndexes = []), (t.visibleSlides = []));
      let l = s.spaceBetween;
      'string' == typeof l && l.indexOf('%') >= 0
        ? (l = (parseFloat(l.replace('%', '')) / 100) * t.size)
        : 'string' == typeof l && (l = parseFloat(l));
      for (let e = 0; e < i.length; e += 1) {
        const o = i[e];
        let d = o.swiperSlideOffset ?? 0;
        s.cssMode && s.centeredSlides && (d -= i[0].swiperSlideOffset ?? 0);
        const c = o.swiperSlideSize ?? 0,
          p = (n + (s.centeredSlides ? t.minTranslate() : 0) - d) / (c + l),
          u =
            (n - a[0] + (s.centeredSlides ? t.minTranslate() : 0) - d) /
            (c + l),
          m = -(n - d),
          h = m + t.slidesSizesGrid[e],
          f = m >= 0 && m <= t.size - t.slidesSizesGrid[e],
          g =
            (m >= 0 && m < t.size - 1) ||
            (h > 1 && h <= t.size) ||
            (m <= 0 && h >= t.size);
        (g && (t.visibleSlides.push(o), t.visibleSlidesIndexes.push(e)),
          Q(o, g, s.slideVisibleClass),
          Q(o, f, s.slideFullyVisibleClass),
          (o.progress = r ? -p : p),
          (o.originalProgress = r ? -u : u));
      }
    },
    updateProgress: function (e) {
      const t = this;
      if (void 0 === e) {
        const s = t.rtlTranslate ? -1 : 1;
        e = (t && t.translate && t.translate * s) || 0;
      }
      const s = t.params,
        i = t.maxTranslate() - t.minTranslate();
      let { progress: r, isBeginning: a, isEnd: n } = t,
        l = t.progressLoop;
      const o = a,
        d = n;
      if (0 === i) ((r = 0), (a = !0), (n = !0));
      else {
        r = (e - t.minTranslate()) / i;
        const s = Math.abs(e - t.minTranslate()) < 1,
          l = Math.abs(e - t.maxTranslate()) < 1;
        ((a = s || r <= 0), (n = l || r >= 1), s && (r = 0), l && (r = 1));
      }
      if (s.loop) {
        const s = t.getSlideIndexByData(0),
          i = t.getSlideIndexByData(t.slides.length - 1),
          r = t.slidesGrid[s],
          a = t.slidesGrid[i],
          n = t.slidesGrid[t.slidesGrid.length - 1],
          o = Math.abs(e);
        ((l = o >= r ? (o - r) / n : (o + n - a) / n), l > 1 && (l -= 1));
      }
      (Object.assign(t, {
        progress: r,
        progressLoop: l,
        isBeginning: a,
        isEnd: n,
      }),
        (s.watchSlidesProgress || (s.centeredSlides && s.autoHeight)) &&
          t.updateSlidesProgress(e),
        a && !o && t.emit('reachBeginning toEdge'),
        n && !d && t.emit('reachEnd toEdge'),
        ((o && !a) || (d && !n)) && t.emit('fromEdge'),
        t.emit('progress', r));
    },
    updateSlidesClasses: function () {
      const e = this,
        { slides: t, params: s, slidesEl: i, activeIndex: r } = e,
        a = !(!e.virtual || !s.virtual?.enabled),
        n = e.grid && s.grid && s.grid.rows > 1,
        l = e => d(i, `.${s.slideClass}${e}, swiper-slide${e}`)[0];
      let o, c, p;
      if (a)
        if (s.loop) {
          const t = e.virtual.slides;
          let s = r - (e.virtual.slidesBefore ?? 0);
          (s < 0 && (s = t.length + s),
            s >= t.length && (s -= t.length),
            (o = l(`[data-swiper-slide-index="${s}"]`)));
        } else o = l(`[data-swiper-slide-index="${r}"]`);
      else
        n
          ? ((o = t.find(e => e.column === r)),
            (p = t.find(e => e.column === r + 1)),
            (c = t.find(e => e.column === r - 1)))
          : (o = t[r]);
      (o &&
        (n ||
          ((p = (function (e, t) {
            const s = [];
            let i = e.nextElementSibling;
            for (; i; )
              ((t && !i.matches(t)) || s.push(i), (i = i.nextElementSibling));
            return s;
          })(o, `.${s.slideClass}, swiper-slide`)[0]),
          s.loop && !p && (p = t[0]),
          (c = (function (e, t) {
            const s = [];
            let i = e.previousElementSibling;
            for (; i; )
              ((t && !i.matches(t)) || s.push(i),
                (i = i.previousElementSibling));
            return s;
          })(o, `.${s.slideClass}, swiper-slide`)[0]),
          s.loop && 0 === !c && (c = t[t.length - 1]))),
        t.forEach(e => {
          (Z(e, e === o, s.slideActiveClass),
            Z(e, e === p, s.slideNextClass),
            Z(e, e === c, s.slidePrevClass));
        }),
        e.emitSlidesClasses());
    },
    updateActiveIndex: function (e) {
      const t = this,
        s = t.rtlTranslate ? t.translate : -t.translate,
        {
          snapGrid: i,
          params: r,
          activeIndex: a,
          realIndex: n,
          snapIndex: l,
        } = t;
      let o,
        d = e;
      const c = e => {
        const s = t.virtual.slides;
        let i = e - (t.virtual.slidesBefore ?? 0);
        return (
          i < 0 && (i = s.length + i),
          i >= s.length && (i -= s.length),
          i
        );
      };
      if (
        (void 0 === d &&
          (d = (function (e) {
            const { slidesGrid: t, params: s } = e,
              i = e.rtlTranslate ? e.translate : -e.translate;
            let r;
            for (let e = 0; e < t.length; e += 1)
              void 0 !== t[e + 1]
                ? i >= t[e] && i < t[e + 1] - (t[e + 1] - t[e]) / 2
                  ? (r = e)
                  : i >= t[e] && i < t[e + 1] && (r = e + 1)
                : i >= t[e] && (r = e);
            return (
              s.normalizeSlideIndex && (r < 0 || void 0 === r) && (r = 0),
              r
            );
          })(t)),
        i.indexOf(s) >= 0)
      )
        o = i.indexOf(s);
      else {
        const e = Math.min(r.slidesPerGroupSkip, d);
        o = e + Math.floor((d - e) / r.slidesPerGroup);
      }
      if ((o >= i.length && (o = i.length - 1), d === a && !t.params.loop))
        return void (o !== l && ((t.snapIndex = o), t.emit('snapIndexChange')));
      if (d === a && t.params.loop && t.virtual && t.params.virtual?.enabled)
        return void (t.realIndex = c(d));
      const p = t.grid && r.grid && r.grid.rows > 1;
      let u;
      if (t.virtual && r.virtual?.enabled) u = r.loop ? c(d) : d;
      else if (p) {
        const e = t.slides.find(e => e.column === d);
        let s = parseInt(e.getAttribute('data-swiper-slide-index'), 10);
        (Number.isNaN(s) && (s = Math.max(t.slides.indexOf(e), 0)),
          (u = Math.floor(s / r.grid.rows)));
      } else if (t.slides[d]) {
        const e = t.slides[d].getAttribute('data-swiper-slide-index');
        u = e ? parseInt(e, 10) : d;
      } else u = d;
      (Object.assign(t, {
        previousSnapIndex: l,
        snapIndex: o,
        previousRealIndex: n,
        realIndex: u,
        previousIndex: a,
        activeIndex: d,
      }),
        t.initialized && A(t),
        t.emit('activeIndexChange'),
        t.emit('snapIndexChange'),
        (t.initialized || t.params.runCallbacksOnInit) &&
          (n !== u && t.emit('realIndexChange'), t.emit('slideChange')));
    },
    updateClickedSlide: function (e, t) {
      const s = this,
        i = s.params;
      let r = e.closest(`.${i.slideClass}, swiper-slide`);
      !r &&
        s.isElement &&
        t &&
        t.length > 1 &&
        t.includes(e) &&
        [...t.slice(t.indexOf(e) + 1, t.length)].forEach(e => {
          !r &&
            e.matches &&
            e.matches(`.${i.slideClass}, swiper-slide`) &&
            (r = e);
        });
      let a,
        n = !1;
      if (r)
        for (let e = 0; e < s.slides.length; e += 1)
          if (s.slides[e] === r) {
            ((n = !0), (a = e));
            break;
          }
      if (!r || !n)
        return ((s.clickedSlide = void 0), void (s.clickedIndex = void 0));
      ((s.clickedSlide = r),
        s.virtual && s.params.virtual?.enabled
          ? (s.clickedIndex = parseInt(
              r.getAttribute('data-swiper-slide-index'),
              10
            ))
          : (s.clickedIndex = a),
        i.slideToClickedSlide &&
          void 0 !== s.clickedIndex &&
          s.clickedIndex !== s.activeIndex &&
          s.slideToClickedSlide());
    },
  };
  const ee = {
      eventsEmitter: D,
      update: J,
      translate: K,
      transition: {
        setTransition: function (e, t) {
          const s = this;
          (s.params.cssMode ||
            ((s.wrapperEl.style.transitionDuration = `${e}ms`),
            (s.wrapperEl.style.transitionDelay = 0 === e ? '0ms' : '')),
            s.emit('setTransition', e, t));
        },
        transitionStart: function (e = !0, t) {
          const s = this,
            { params: i } = s;
          i.cssMode ||
            (i.autoHeight && s.updateAutoHeight(),
            U({ swiper: s, runCallbacks: e, direction: t, step: 'Start' }));
        },
        transitionEnd: function (e = !0, t) {
          const s = this,
            { params: i } = s;
          ((s.animating = !1),
            i.cssMode ||
              (s.setTransition(0),
              U({ swiper: s, runCallbacks: e, direction: t, step: 'End' })));
        },
      },
      slide: j,
      loop: W,
      grabCursor: {
        setGrabCursor: function (e) {
          const t = this;
          if (
            !t.params.simulateTouch ||
            (t.params.watchOverflow && t.isLocked) ||
            t.params.cssMode
          )
            return;
          const s =
            'container' === t.params.touchEventsTarget ? t.el : t.wrapperEl;
          (t.isElement && (t.__preventObserver__ = !0),
            (s.style.cursor = 'move'),
            (s.style.cursor = e ? 'grabbing' : 'grab'),
            t.isElement &&
              requestAnimationFrame(() => {
                t.__preventObserver__ = !1;
              }));
        },
        unsetGrabCursor: function () {
          const e = this;
          (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e.isElement && (e.__preventObserver__ = !0),
            (e[
              'container' === e.params.touchEventsTarget ? 'el' : 'wrapperEl'
            ].style.cursor = ''),
            e.isElement &&
              requestAnimationFrame(() => {
                e.__preventObserver__ = !1;
              }));
        },
      },
      events: {
        attachEvents: function () {
          const e = this,
            { params: t } = e;
          ((e.onTouchStart = q.bind(e)),
            (e.onTouchMove = N.bind(e)),
            (e.onTouchEnd = R.bind(e)),
            (e.onDocumentTouchStart = X.bind(e)),
            t.cssMode && (e.onScroll = Y.bind(e)),
            (e.onClick = G.bind(e)),
            (e.onLoad = B.bind(e)),
            _(e, 'on'));
        },
        detachEvents: function () {
          _(this, 'off');
        },
      },
      breakpoints: z,
      checkOverflow: $,
      classes: k,
    },
    te = {};
  class se {
    static extendedDefaults;
    static defaults;
    constructor(...e) {
      let t, s;
      if (
        (1 === e.length &&
        null !== e[0] &&
        'object' == typeof e[0] &&
        'Object' === Object.prototype.toString.call(e[0]).slice(8, -1)
          ? (s = e[0])
          : ([t, s] = e),
        s || (s = {}),
        (s = n({}, s)),
        t && !s.el && (s.el = t),
        s.el &&
          'string' == typeof s.el &&
          'undefined' != typeof document &&
          document.querySelectorAll(s.el).length > 1)
      ) {
        const e = [];
        return (
          document.querySelectorAll(s.el).forEach(t => {
            const i = n({}, s, { el: t });
            e.push(new se(i));
          }),
          e
        );
      }
      const i = this;
      ((i.__swiper__ = !0),
        (i.support = T()),
        (i.device = M({ userAgent: s.userAgent ?? void 0 })),
        (i.browser = C()),
        (i.eventsListeners = {}),
        (i.eventsAnyListeners = []),
        (i.modules = [...(i.__modules__ || [])]),
        s.modules &&
          Array.isArray(s.modules) &&
          s.modules.forEach(e => {
            const t = e;
            'function' == typeof t &&
              i.modules.indexOf(t) < 0 &&
              i.modules.push(t);
          }));
      const r = {};
      i.modules.forEach(e => {
        e({
          params: s,
          swiper: i,
          extendParams: F(s, r),
          on: i.on.bind(i),
          once: i.once.bind(i),
          off: i.off.bind(i),
          emit: i.emit.bind(i),
        });
      });
      const a = n({}, O, r);
      if (
        ((i.params = n({}, a, te, s)),
        (i.originalParams = n({}, i.params)),
        (i.passedParams = n({}, s)),
        i.params && i.params.on)
      ) {
        const e = i.params.on;
        Object.keys(e).forEach(t => {
          const s = e[t];
          s && i.on(t, s);
        });
      }
      return (
        i.params && i.params.onAny && i.onAny(i.params.onAny),
        Object.assign(i, {
          enabled: i.params.enabled,
          el: t,
          classNames: [],
          slides: [],
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal: () => 'horizontal' === i.params.direction,
          isVertical: () => 'vertical' === i.params.direction,
          activeIndex: 0,
          realIndex: 0,
          isBeginning: !0,
          isEnd: !1,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: !1,
          cssOverflowAdjustment() {
            return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
          },
          allowSlideNext: i.params.allowSlideNext,
          allowSlidePrev: i.params.allowSlidePrev,
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            focusableElements: i.params.focusableElements,
            lastClickTime: 0,
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            startMoving: void 0,
            pointerId: null,
            touchId: null,
          },
          allowClick: !0,
          allowTouchMove: i.params.allowTouchMove,
          touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
          imagesToLoad: [],
          imagesLoaded: 0,
        }),
        i.emit('_swiper'),
        i.params.init && i.init(),
        i
      );
    }
    getDirectionLabel(e) {
      return this.isHorizontal()
        ? e
        : {
            width: 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            marginRight: 'marginBottom',
          }[e];
    }
    isHorizontal() {
      return 'horizontal' === this.params.direction;
    }
    isVertical() {
      return 'vertical' === this.params.direction;
    }
    cssOverflowAdjustment() {
      return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
    }
    getSlideIndex(e) {
      const { slidesEl: t, params: s } = this,
        i = h(d(t, `.${s.slideClass}, swiper-slide`)[0]);
      return h(e) - (i ?? 0);
    }
    getSlideIndexByData(e) {
      return this.getSlideIndex(
        this.slides.find(
          t => Number(t.getAttribute('data-swiper-slide-index')) === e
        )
      );
    }
    getSlideIndexWhenGrid(e) {
      return (
        this.grid &&
          this.params.grid &&
          this.params.grid.rows > 1 &&
          ('column' === this.params.grid.fill
            ? (e = Math.floor(e / this.params.grid.rows))
            : 'row' === this.params.grid.fill &&
              (e %= Math.ceil(this.slides.length / this.params.grid.rows))),
        e
      );
    }
    recalcSlides() {
      const { slidesEl: e, params: t } = this;
      this.slides = d(e, `.${t.slideClass}, swiper-slide`);
    }
    enable() {
      this.enabled ||
        ((this.enabled = !0),
        this.params.grabCursor && this.setGrabCursor(),
        this.emit('enable'));
    }
    disable() {
      this.enabled &&
        ((this.enabled = !1),
        this.params.grabCursor && this.unsetGrabCursor(),
        this.emit('disable'));
    }
    setProgress(e, t) {
      e = Math.min(Math.max(e, 0), 1);
      const s = this.minTranslate(),
        i = (this.maxTranslate() - s) * e + s;
      (this.translateTo(i, void 0 === t ? 0 : t),
        this.updateActiveIndex(),
        this.updateSlidesClasses());
    }
    emitContainerClasses() {
      if (!this.params._emitClasses || !this.el) return;
      const e = this.el.className
        .split(' ')
        .filter(
          e =>
            0 === e.indexOf('swiper') ||
            0 === e.indexOf(this.params.containerModifierClass)
        );
      this.emit('_containerClasses', e.join(' '));
    }
    getSlideClasses(e) {
      return this.destroyed
        ? ''
        : e.className
            .split(' ')
            .filter(
              e =>
                0 === e.indexOf('swiper-slide') ||
                0 === e.indexOf(this.params.slideClass)
            )
            .join(' ');
    }
    emitSlidesClasses() {
      if (!this.params._emitClasses || !this.el) return;
      const e = [];
      (this.slides.forEach(t => {
        const s = this.getSlideClasses(t);
        (e.push({ slideEl: t, classNames: s }), this.emit('_slideClass', t, s));
      }),
        this.emit('_slideClasses', e));
    }
    slidesPerViewDynamic(e = 'current', t = !1) {
      const {
        params: s,
        slides: i,
        slidesGrid: r,
        slidesSizesGrid: a,
        size: n,
        activeIndex: l,
      } = this;
      let o = 1;
      if ('number' == typeof s.slidesPerView) return s.slidesPerView;
      if (s.centeredSlides) {
        let e = i[l] ? Math.ceil(i[l].swiperSlideSize ?? 0) : 0,
          t = !1;
        for (let s = l + 1; s < i.length; s += 1)
          i[s] &&
            !t &&
            ((e += Math.ceil(i[s].swiperSlideSize ?? 0)),
            (o += 1),
            e > n && (t = !0));
        for (let s = l - 1; s >= 0; s -= 1)
          i[s] &&
            !t &&
            ((e += i[s].swiperSlideSize ?? 0), (o += 1), e > n && (t = !0));
      } else if ('current' === e)
        for (let e = l + 1; e < i.length; e += 1) {
          (t ? r[e] + a[e] - r[l] < n : r[e] - r[l] < n) && (o += 1);
        }
      else
        for (let e = l - 1; e >= 0; e -= 1) {
          r[l] - r[e] < n && (o += 1);
        }
      return o;
    }
    update() {
      const e = this;
      if (!e || e.destroyed) return;
      const { snapGrid: t, params: s } = e;
      function i() {
        const t = e.rtlTranslate ? -1 * e.translate : e.translate,
          s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
        (e.setTranslate(s), e.updateActiveIndex(), e.updateSlidesClasses());
      }
      let r;
      if (
        (s.breakpoints && e.setBreakpoint(),
        [...e.el.querySelectorAll('[loading="lazy"]')].forEach(t => {
          t.complete && P(e, t);
        }),
        e.updateSize(),
        e.updateSlides(),
        e.updateProgress(),
        e.updateSlidesClasses(),
        s.freeMode?.enabled && !s.cssMode)
      )
        (i(), s.autoHeight && e.updateAutoHeight());
      else {
        if (
          ('auto' === s.slidesPerView || s.slidesPerView > 1) &&
          e.isEnd &&
          !s.centeredSlides
        ) {
          const t =
            e.virtual && s.virtual?.enabled
              ? e.virtual.slides.length
              : e.slides.length;
          r = e.slideTo(t - 1, 0, !1, !0);
        } else r = e.slideTo(e.activeIndex, 0, !1, !0);
        r || i();
      }
      (s.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
        e.emit('update'));
    }
    changeDirection(e, t = !0) {
      const s = this,
        i = s.params.direction;
      return (
        e || (e = 'horizontal' === i ? 'vertical' : 'horizontal'),
        e === i ||
          ('horizontal' !== e && 'vertical' !== e) ||
          (s.el.classList.remove(`${s.params.containerModifierClass}${i}`),
          s.el.classList.add(`${s.params.containerModifierClass}${e}`),
          s.emitContainerClasses(),
          (s.params.direction = e),
          s.slides.forEach(t => {
            'vertical' === e ? (t.style.width = '') : (t.style.height = '');
          }),
          s.emit('changeDirection'),
          t && s.update()),
        s
      );
    }
    changeLanguageDirection(e) {
      const t = this;
      (t.rtl && 'rtl' === e) ||
        (!t.rtl && 'ltr' === e) ||
        ((t.rtl = 'rtl' === e),
        (t.rtlTranslate = 'horizontal' === t.params.direction && t.rtl),
        t.rtl
          ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`),
            (t.el.dir = 'rtl'))
          : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`),
            (t.el.dir = 'ltr')),
        t.update());
    }
    mount(e) {
      const t = this;
      if (t.mounted) return !0;
      if ('undefined' == typeof document) return !1;
      const s = e ?? t.params.el;
      let i = null;
      if (
        ('string' == typeof s
          ? (i = document.querySelector(s))
          : s instanceof HTMLElement && (i = s),
        !i)
      )
        return !1;
      i.swiper = t;
      const r = i.parentNode;
      r &&
        r.host &&
        r.host.nodeName === t.params.swiperElementNodeName.toUpperCase() &&
        (t.isElement = !0);
      const a = () =>
        `.${(t.params.wrapperClass || '').trim().split(' ').join('.')}`;
      let n = (() => {
        if (i && i.shadowRoot) {
          return i.shadowRoot.querySelector(a());
        }
        return d(i, a())[0];
      })();
      !n &&
        t.params.createElements &&
        ((n = p('div', t.params.wrapperClass)),
        i.append(n),
        d(i, `.${t.params.slideClass}`).forEach(e => {
          n.append(e);
        }));
      const l = t.isElement ? i.parentNode.host : null;
      return (
        Object.assign(t, {
          el: i,
          wrapperEl: n,
          slidesEl: t.isElement && !l.slideSlots ? i.parentNode : n,
          hostEl: t.isElement ? l : i,
          mounted: !0,
          rtl: 'rtl' === i.dir.toLowerCase() || 'rtl' === m(i, 'direction'),
          rtlTranslate:
            'horizontal' === t.params.direction &&
            ('rtl' === i.dir.toLowerCase() || 'rtl' === m(i, 'direction')),
          wrongRTL: '-webkit-box' === m(n, 'display'),
        }),
        !0
      );
    }
    init(e) {
      const t = this;
      if (t.initialized) return t;
      if (!1 === t.mount(e)) return t;
      (t.emit('beforeInit'),
        t.params.breakpoints && t.setBreakpoint(),
        t.addClasses(),
        t.updateSize(),
        t.updateSlides(),
        t.params.watchOverflow && t.checkOverflow(),
        t.params.grabCursor && t.enabled && t.setGrabCursor(),
        t.params.loop && t.virtual && t.params.virtual?.enabled
          ? t.slideTo(
              (t.params.initialSlide ?? 0) + (t.virtual.slidesBefore ?? 0),
              0,
              t.params.runCallbacksOnInit,
              !1,
              !0
            )
          : t.slideTo(
              t.params.initialSlide,
              0,
              t.params.runCallbacksOnInit,
              !1,
              !0
            ),
        t.params.loop && t.loopCreate(void 0, !0),
        t.attachEvents());
      const s = [...t.el.querySelectorAll('[loading="lazy"]')];
      return (
        t.isElement && s.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
        s.forEach(e => {
          e.complete
            ? P(t, e)
            : e.addEventListener('load', e => {
                P(t, e.target);
              });
        }),
        A(t),
        (t.initialized = !0),
        A(t),
        t.emit('init'),
        t.emit('afterInit'),
        t
      );
    }
    destroy(e = !0, t = !0) {
      const s = this,
        { params: i, el: r, wrapperEl: a, slides: n } = s;
      return (
        void 0 === s.params ||
          s.destroyed ||
          (s.emit('beforeDestroy'),
          (s.initialized = !1),
          s.detachEvents(),
          i.loop && s.loopDestroy(),
          t &&
            (s.removeClasses(),
            r && 'string' != typeof r && r.removeAttribute('style'),
            a && a.removeAttribute('style'),
            n &&
              n.length &&
              n.forEach(e => {
                (e.classList.remove(
                  i.slideVisibleClass,
                  i.slideFullyVisibleClass,
                  i.slideActiveClass,
                  i.slideNextClass,
                  i.slidePrevClass
                ),
                  e.removeAttribute('style'),
                  e.removeAttribute('data-swiper-slide-index'));
              })),
          s.emit('destroy'),
          Object.keys(s.eventsListeners).forEach(e => {
            s.off(e);
          }),
          !1 !== e &&
            (s.el && 'string' != typeof s.el && (s.el.swiper = null),
            (l = s),
            Object.keys(l).forEach(e => {
              try {
                l[e] = null;
              } catch {}
              try {
                delete l[e];
              } catch {}
            })),
          (s.destroyed = !0)),
        null
      );
      var l;
    }
    static extendDefaults(e) {
      n(te, e);
    }
    static installModule(e) {
      se.prototype.__modules__ || (se.prototype.__modules__ = []);
      const t = se.prototype.__modules__;
      'function' == typeof e && t.indexOf(e) < 0 && t.push(e);
    }
    static use(e) {
      return Array.isArray(e)
        ? (e.forEach(e => se.installModule(e)), se)
        : (se.installModule(e), se);
    }
  }
  (Object.defineProperty(se, 'extendedDefaults', { get: () => te }),
    Object.defineProperty(se, 'defaults', { get: () => O }));
  const ie = ee,
    re = se.prototype;
  (Object.keys(ie).forEach(e => {
    const t = ie[e];
    Object.keys(t).forEach(e => {
      re[e] = t[e];
    });
  }),
    se.use([
      ({ swiper: e, on: t, emit: s }) => {
        let i = null,
          r = null;
        const a = () => {
            e &&
              !e.destroyed &&
              e.initialized &&
              (s('beforeResize'), s('resize'));
          },
          n = () => {
            e && !e.destroyed && e.initialized && s('orientationchange');
          };
        (t('init', () => {
          e.params.resizeObserver && void 0 !== window.ResizeObserver
            ? e &&
              !e.destroyed &&
              e.initialized &&
              ((i = new ResizeObserver(t => {
                r = window.requestAnimationFrame(() => {
                  const { width: s, height: i } = e;
                  let r = s,
                    n = i;
                  (t.forEach(
                    ({ contentBoxSize: t, contentRect: s, target: i }) => {
                      if (i && i !== e.el) return;
                      const a = Array.isArray(t) ? t[0] : t;
                      ((r = s ? s.width : a.inlineSize),
                        (n = s ? s.height : a.blockSize));
                    }
                  ),
                    (r === s && n === i) || a());
                });
              })),
              i.observe(e.el))
            : (window.addEventListener('resize', a),
              window.addEventListener('orientationchange', n));
        }),
          t('destroy', () => {
            (r && window.cancelAnimationFrame(r),
              i && i.unobserve && e.el && (i.unobserve(e.el), (i = null)),
              window.removeEventListener('resize', a),
              window.removeEventListener('orientationchange', n));
          }));
      },
      ({ swiper: e, extendParams: t, on: s }) => {
        const i = [],
          r = (t, s = {}) => {
            const r = window.MutationObserver || window.WebkitMutationObserver;
            if (!r) return;
            const a = new r(t => {
              if (e.__preventObserver__) return;
              if (1 === t.length) return void e.emit('observerUpdate', t[0]);
              const s = function () {
                e.emit('observerUpdate', t[0]);
              };
              window.requestAnimationFrame
                ? window.requestAnimationFrame(s)
                : window.setTimeout(s, 0);
            });
            (a.observe(t, {
              attributes: void 0 === s.attributes || s.attributes,
              childList: e.isElement || void 0 === s.childList || s.childList,
              characterData: void 0 === s.characterData || s.characterData,
            }),
              i.push(a));
          };
        (t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          s('init', () => {
            if (e.params.observer) {
              if (e.params.observeParents) {
                const t = f(e.hostEl);
                for (let e = 0; e < t.length; e += 1) r(t[e]);
              }
              (r(e.hostEl, { childList: e.params.observeSlideChildren }),
                r(e.wrapperEl, { attributes: !1 }));
            }
          }),
          s('destroy', () => {
            (i.forEach(e => {
              e.disconnect();
            }),
              i.splice(0, i.length));
          }));
      },
    ]));
  function ae(e, t, s, i) {
    const r = s ?? {},
      a = t ?? {};
    return (
      e.params.createElements &&
        Object.keys(i).forEach(t => {
          if (!r[t] && !0 === r.auto) {
            let s = d(e.el, `.${i[t]}`)[0];
            (s || ((s = p('div', i[t])), (s.className = i[t]), e.el.append(s)),
              (r[t] = s),
              (a[t] = s));
          }
        }),
      r
    );
  }
  const ne =
    '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>';
  function le(e = '') {
    return `.${e
      .trim()
      .replace(/([.:!+/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1')
      .replace(/ /g, '.')}`;
  }
  const oe = e => !!e.virtual && !!e.params.virtual?.enabled;
  class de {
    x;
    y;
    lastIndex;
    binarySearch;
    constructor(e, t) {
      let s, i, r;
      ((this.binarySearch = (e, t) => {
        for (i = -1, s = e.length; s - i > 1; )
          ((r = (s + i) >> 1), e[r] <= t ? (i = r) : (s = r));
        return s;
      }),
        (this.x = e),
        (this.y = t),
        (this.lastIndex = e.length - 1));
    }
    interpolate(e) {
      if (!e) return 0;
      const t = this.binarySearch(this.x, e),
        s = t - 1;
      return (
        ((e - this.x[s]) * (this.y[t] - this.y[s])) / (this.x[t] - this.x[s]) +
        this.y[s]
      );
    }
  }
  const ce = e => !!e.virtual && !!e.params.virtual?.enabled;
  function pe(e, t) {
    const s = this,
      { params: i, activeIndex: r, slidesEl: a } = s;
    let n = r;
    i.loop && ((n -= s.loopedSlides ?? 0), s.loopDestroy(), s.recalcSlides());
    const l = s.slides.length;
    if (e <= 0) return void s.prependSlide(t);
    if (e >= l) return void s.appendSlide(t);
    let o = n > e ? n + 1 : n;
    const d = [];
    for (let t = l - 1; t >= e; t -= 1) {
      const e = s.slides[t];
      e && (e.remove(), d.unshift(e));
    }
    if (Array.isArray(t)) {
      for (let e = 0; e < t.length; e += 1) {
        const s = t[e];
        s && a.append(s);
      }
      o = n > e ? n + t.length : n;
    } else a.append(t);
    for (let e = 0; e < d.length; e += 1) a.append(d[e]);
    (s.recalcSlides(),
      i.loop && s.loopCreate(),
      (i.observer && !s.isElement) || s.update(),
      i.loop
        ? s.slideTo(o + (s.loopedSlides ?? 0), 0, !1)
        : s.slideTo(o, 0, !1));
  }
  function ue(e) {
    const t = this,
      { params: s, slidesEl: i } = t;
    s.loop && t.loopDestroy();
    const r = e => {
      if ('string' == typeof e) {
        const t = document.createElement('div');
        y(t, e);
        const s = t.children[0];
        (s && i.append(s), y(t, ''));
      } else i.append(e);
    };
    if (Array.isArray(e))
      for (let t = 0; t < e.length; t += 1) {
        const s = e[t];
        s && r(s);
      }
    else r(e);
    (t.recalcSlides(),
      s.loop && t.loopCreate(),
      (s.observer && !t.isElement) || t.update());
  }
  function me(e) {
    const t = this,
      { params: s, activeIndex: i, slidesEl: r } = t;
    s.loop && t.loopDestroy();
    let a = i + 1;
    const n = e => {
      if ('string' == typeof e) {
        const t = document.createElement('div');
        y(t, e);
        const s = t.children[0];
        (s && r.prepend(s), y(t, ''));
      } else r.prepend(e);
    };
    if (Array.isArray(e)) {
      for (let t = 0; t < e.length; t += 1) {
        const s = e[t];
        s && n(s);
      }
      a = i + e.length;
    } else n(e);
    (t.recalcSlides(),
      s.loop && t.loopCreate(),
      (s.observer && !t.isElement) || t.update(),
      t.slideTo(a, 0, !1));
  }
  function he() {
    const e = this,
      t = [];
    for (let s = 0; s < e.slides.length; s += 1) t.push(s);
    e.removeSlide(t);
  }
  function fe(e) {
    const t = this,
      { params: s, activeIndex: i } = t;
    let r = i;
    s.loop && ((r -= t.loopedSlides ?? 0), t.loopDestroy());
    let a = r;
    if (Array.isArray(e)) {
      for (let s = 0; s < e.length; s += 1) {
        const i = e[s];
        (t.slides[i] && t.slides[i].remove(), i < a && (a -= 1));
      }
      a = Math.max(a, 0);
    } else {
      const s = e;
      (t.slides[s] && t.slides[s].remove(),
        s < a && (a -= 1),
        (a = Math.max(a, 0)));
    }
    (t.recalcSlides(),
      s.loop && t.loopCreate(),
      (s.observer && !t.isElement) || t.update(),
      s.loop
        ? t.slideTo(a + (t.loopedSlides ?? 0), 0, !1)
        : t.slideTo(a, 0, !1));
  }
  function ge(e) {
    const {
      effect: t,
      swiper: s,
      on: i,
      setTranslate: r,
      setTransition: a,
      overwriteParams: n,
      perspective: l,
      recreateShadows: o,
      getEffectParams: d,
    } = e;
    (i('beforeInit', () => {
      if (s.params.effect !== t) return;
      (s.classNames.push(`${s.params.containerModifierClass}${t}`),
        l && l() && s.classNames.push(`${s.params.containerModifierClass}3d`));
      const e = n ? n() : {};
      (Object.assign(s.params, e), Object.assign(s.originalParams, e));
    }),
      i('setTranslate _virtualUpdated', () => {
        s.params.effect === t && r();
      }),
      i('setTransition', (e, i) => {
        s.params.effect === t && a(i);
      }),
      i('transitionEnd', () => {
        if (s.params.effect === t && o) {
          const e = d ? d() : void 0;
          if (!e || !e.slideShadows) return;
          (s.slides.forEach(e => {
            e.querySelectorAll(
              '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
            ).forEach(e => e.remove());
          }),
            o());
        }
      }));
    let c = !1;
    i('virtualUpdate', () => {
      s.params.effect === t &&
        (s.slides.length || (c = !0),
        requestAnimationFrame(() => {
          c && s.slides && s.slides.length && (r(), (c = !1));
        }));
    });
  }
  function ve(e, t) {
    const s = o(t);
    return (
      s !== t &&
        ((s.style.backfaceVisibility = 'hidden'),
        s.style.setProperty('-webkit-backface-visibility', 'hidden')),
      s
    );
  }
  function we({ swiper: e, duration: t, transformElements: s, allSlides: i }) {
    const { activeIndex: r } = e;
    if (e.params.virtualTranslate && 0 !== t) {
      let t,
        a = !1;
      ((t = i
        ? s
        : s.filter(t => {
            const s = t.classList.contains('swiper-slide-transform')
              ? (t =>
                  t.parentElement
                    ? t.parentElement instanceof HTMLElement
                      ? t.parentElement
                      : void 0
                    : e.slides.find(
                        e => e.shadowRoot && e.shadowRoot === t.parentNode
                      ))(t)
              : t;
            return !!s && e.getSlideIndex(s) === r;
          })),
        t.forEach(t => {
          g(t, () => {
            if (a) return;
            if (!e || e.destroyed) return;
            ((a = !0), (e.animating = !1));
            const t = new CustomEvent('transitionend', {
              bubbles: !0,
              cancelable: !0,
            });
            e.wrapperEl.dispatchEvent(t);
          });
        }));
    }
  }
  function be(e, t, s) {
    const i = `swiper-slide-shadow${s ? `-${s}` : ''}${e ? ` swiper-slide-shadow-${e}` : ''}`,
      r = o(t),
      a = `.${i.split(' ').join('.')}`,
      n = r.querySelector(a);
    if (n) return n;
    const l = p('div', i.split(' '));
    return (r.append(l), l);
  }
  const ye = [
    ({ swiper: e, extendParams: t, on: s, emit: i }) => {
      let r, a;
      function n() {
        return e.params.virtual;
      }
      (t({
        virtual: {
          enabled: !1,
          slides: [],
          cache: !0,
          slidesPerViewAutoSlideSize: 320,
          renderSlide: null,
          renderExternal: null,
          renderExternalUpdate: !0,
          addSlidesBefore: 0,
          addSlidesAfter: 0,
        },
      }),
        (e.virtual = {
          cache: {},
          from: 0,
          to: 0,
          slides: [],
          offset: 0,
          slidesGrid: [],
        }));
      function o(t, s) {
        const i = n();
        if (i.cache && e.virtual.cache[s]) return e.virtual.cache[s];
        let r;
        if (i.renderSlide) {
          const n = i.renderSlide.call(e, t, s);
          if ('string' == typeof n) {
            const e = (a ??= document.createElement('div'));
            (y(e, n), (r = e.children[0]));
          } else r = n;
        } else
          r = e.isElement ? p('swiper-slide') : p('div', e.params.slideClass);
        return (
          r.setAttribute('data-swiper-slide-index', String(s)),
          i.renderSlide || y(r, t),
          i.cache && (e.virtual.cache[s] = r),
          r
        );
      }
      function c(t, s, r) {
        const {
          slidesPerGroup: a,
          centeredSlides: l,
          slidesPerView: c,
          loop: p,
          initialSlide: u,
        } = e.params;
        if (s && !p && (u ?? 0) > 0) return;
        const {
            addSlidesBefore: m,
            addSlidesAfter: h,
            slidesPerViewAutoSlideSize: f,
          } = n(),
          { from: g, to: v, slides: w, slidesGrid: b, offset: y } = e.virtual;
        e.params.cssMode || e.updateActiveIndex();
        const E = void 0 === r ? e.activeIndex || 0 : r;
        let S, x;
        if (
          ((S = e.rtlTranslate ? 'right' : e.isHorizontal() ? 'left' : 'top'),
          'auto' === c)
        )
          if (f) {
            let t = e.size;
            (t ||
              (t = e.isHorizontal()
                ? e.el.getBoundingClientRect().width
                : e.el.getBoundingClientRect().height),
              (x = Math.max(1, Math.ceil(t / f))));
          } else x = 1;
        else x = c ?? 1;
        const T = a ?? 1;
        let M, C;
        l
          ? ((M = Math.floor(x / 2) + T + h), (C = Math.floor(x / 2) + T + m))
          : ((M = x + (T - 1) + h), (C = (p ? x : T) + m));
        let P = E - C,
          L = E + M;
        p || ((P = Math.max(P, 0)), (L = Math.min(L, w.length - 1)));
        let A = (e.slidesGrid[P] || 0) - (e.slidesGrid[0] || 0);
        function I() {
          (e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            i('virtualUpdate'));
        }
        if (
          (p && E >= C
            ? ((P -= C), l || (A += e.slidesGrid[0]))
            : p && E < C && ((P = -C), l && (A += e.slidesGrid[0])),
          Object.assign(e.virtual, {
            from: P,
            to: L,
            offset: A,
            slidesGrid: e.slidesGrid,
            slidesBefore: C,
            slidesAfter: M,
          }),
          g === P && v === L && !t)
        )
          return (
            e.slidesGrid !== b &&
              A !== y &&
              e.slides.forEach(t => {
                t.style.setProperty(
                  S,
                  A - Math.abs(e.cssOverflowAdjustment()) + 'px'
                );
              }),
            e.updateProgress(),
            void i('virtualUpdate')
          );
        const z = n();
        if (z.renderExternal) {
          const t = [];
          for (let e = P; e <= L; e += 1) t.push(w[e]);
          return (
            z.renderExternal.call(e, { offset: A, from: P, to: L, slides: t }),
            void (z.renderExternalUpdate ? I() : i('virtualUpdate'))
          );
        }
        const $ = [],
          k = [],
          O = e => {
            let t = e;
            return (
              e < 0 ? (t = w.length + e) : t >= w.length && (t -= w.length),
              t
            );
          };
        if (t)
          e.slides
            .filter(t => t.matches(`.${e.params.slideClass}, swiper-slide`))
            .forEach(e => {
              e.remove();
            });
        else
          for (let t = g; t <= v; t += 1)
            if (t < P || t > L) {
              const s = O(t);
              e.slides
                .filter(t =>
                  t.matches(
                    `.${e.params.slideClass}[data-swiper-slide-index="${s}"], swiper-slide[data-swiper-slide-index="${s}"]`
                  )
                )
                .forEach(e => {
                  e.remove();
                });
            }
        const D = p ? -w.length : 0,
          G = p ? 2 * w.length : w.length;
        for (let e = D; e < G; e += 1)
          if (e >= P && e <= L) {
            const s = O(e);
            void 0 === v || t
              ? k.push(s)
              : (e > v && k.push(s), e < g && $.push(s));
          }
        if (
          (k.forEach(t => {
            e.slidesEl.append(o(w[t], t));
          }),
          p)
        )
          for (let t = $.length - 1; t >= 0; t -= 1) {
            const s = $[t];
            e.slidesEl.prepend(o(w[s], s));
          }
        else
          ($.sort((e, t) => t - e),
            $.forEach(t => {
              e.slidesEl.prepend(o(w[t], t));
            }));
        (d(e.slidesEl, '.swiper-slide, swiper-slide').forEach(t => {
          t.style.setProperty(
            S,
            A - Math.abs(e.cssOverflowAdjustment()) + 'px'
          );
        }),
          I());
      }
      (s('beforeInit', () => {
        if (!n().enabled) return;
        let t = !1;
        const s = e.passedParams.virtual;
        if (!s || 'object' != typeof s || void 0 === s.slides) {
          const s = [...e.slidesEl.children].filter(t =>
            t.matches(`.${e.params.slideClass}, swiper-slide`)
          );
          s &&
            s.length &&
            ((e.virtual.slides = [...s]),
            (t = !0),
            s.forEach((t, s) => {
              (t.setAttribute('data-swiper-slide-index', String(s)),
                (e.virtual.cache[s] = t),
                t.remove());
            }));
        }
        (t || (e.virtual.slides = n().slides),
          e.classNames.push(`${e.params.containerModifierClass}virtual`),
          (e.params.watchSlidesProgress = !0),
          (e.originalParams.watchSlidesProgress = !0),
          c(!1, !0));
      }),
        s('setTranslate', () => {
          n().enabled &&
            (e.params.cssMode && !e._immediateVirtual
              ? (clearTimeout(r),
                (r = setTimeout(() => {
                  c();
                }, 100)))
              : c());
        }),
        s('init update resize', () => {
          n().enabled &&
            e.params.cssMode &&
            l(e.wrapperEl, '--swiper-virtual-size', `${e.virtualSize}px`);
        }),
        Object.assign(e.virtual, {
          appendSlide: function (t) {
            if (null !== t && 'object' == typeof t && 'length' in t) {
              const s = t;
              for (let t = 0; t < s.length; t += 1)
                s[t] && e.virtual.slides.push(s[t]);
            } else e.virtual.slides.push(t);
            c(!0);
          },
          prependSlide: function (t) {
            const s = e.activeIndex;
            let i = s + 1,
              r = 1;
            if (Array.isArray(t)) {
              for (let s = 0; s < t.length; s += 1)
                t[s] && e.virtual.slides.unshift(t[s]);
              ((i = s + t.length), (r = t.length));
            } else e.virtual.slides.unshift(t);
            if (n().cache) {
              const t = e.virtual.cache,
                s = {};
              (Object.keys(t).forEach(e => {
                const i = t[Number(e)],
                  a = i.getAttribute('data-swiper-slide-index');
                (a &&
                  i.setAttribute(
                    'data-swiper-slide-index',
                    String(parseInt(a, 10) + r)
                  ),
                  (s[parseInt(e, 10) + r] = i));
              }),
                (e.virtual.cache = s));
            }
            (c(!0), e.slideTo(i, 0));
          },
          removeSlide: function (t) {
            if (null == t) return;
            let s = e.activeIndex;
            const i = t => {
              Object.keys(e.virtual.cache).forEach(s => {
                const i = Number(s);
                if (i > t) {
                  const t = e.virtual.cache[i];
                  ((e.virtual.cache[i - 1] = t),
                    t.setAttribute('data-swiper-slide-index', String(i - 1)),
                    delete e.virtual.cache[i]);
                }
              });
            };
            if (Array.isArray(t))
              for (let r = t.length - 1; r >= 0; r -= 1)
                (n().cache && (delete e.virtual.cache[t[r]], i(t[r])),
                  e.virtual.slides.splice(t[r], 1),
                  t[r] < s && (s -= 1),
                  (s = Math.max(s, 0)));
            else
              (n().cache && (delete e.virtual.cache[t], i(t)),
                e.virtual.slides.splice(t, 1),
                t < s && (s -= 1),
                (s = Math.max(s, 0)));
            (c(!0), e.slideTo(s, 0));
          },
          removeAllSlides: function () {
            ((e.virtual.slides = []),
              n().cache && (e.virtual.cache = {}),
              c(!0),
              e.slideTo(0, 0));
          },
          update: c,
        }));
    },
    ({ swiper: e, extendParams: t, on: s, emit: i }) => {
      function r() {
        return e.params.keyboard;
      }
      function a(t) {
        if (!e.enabled) return;
        const { rtlTranslate: s } = e,
          a = 'originalEvent' in t && t.originalEvent ? t.originalEvent : t,
          n = a.keyCode || a.charCode,
          l = r(),
          o = !!l.pageUpDown,
          d = o && 33 === n,
          c = o && 34 === n,
          p = 37 === n,
          m = 39 === n,
          h = 38 === n,
          g = 40 === n;
        if (
          !e.allowSlideNext &&
          ((e.isHorizontal() && m) || (e.isVertical() && g) || c)
        )
          return !1;
        if (
          !e.allowSlidePrev &&
          ((e.isHorizontal() && p) || (e.isVertical() && h) || d)
        )
          return !1;
        if (a.shiftKey || a.altKey || a.ctrlKey || a.metaKey) return;
        const v = document.activeElement;
        if (
          v &&
          (v.isContentEditable ||
            (v.nodeName &&
              ('input' === v.nodeName.toLowerCase() ||
                'textarea' === v.nodeName.toLowerCase())))
        )
          return;
        if (l.onlyInViewport && (d || c || p || m || h || g)) {
          let t = !1;
          if (
            f(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 &&
            0 === f(e.el, `.${e.params.slideActiveClass}`).length
          )
            return;
          const i = e.el,
            r = i.clientWidth,
            a = i.clientHeight,
            n = window.innerWidth,
            l = window.innerHeight,
            o = u(i);
          s && (o.left -= i.scrollLeft);
          const d = [
            [o.left, o.top],
            [o.left + r, o.top],
            [o.left, o.top + a],
            [o.left + r, o.top + a],
          ];
          for (let e = 0; e < d.length; e += 1) {
            const s = d[e];
            if (s[0] >= 0 && s[0] <= n && s[1] >= 0 && s[1] <= l) {
              if (0 === s[0] && 0 === s[1]) continue;
              t = !0;
            }
          }
          if (!t) return;
        }
        const w = l.speed;
        (e.isHorizontal()
          ? ((d || c || p || m) && a.cancelable && a.preventDefault(),
            (((c || m) && !s) || ((d || p) && s)) && e.slideNext(w),
            (((d || p) && !s) || ((c || m) && s)) && e.slidePrev(w))
          : ((d || c || h || g) && a.cancelable && a.preventDefault(),
            (c || g) && e.slideNext(w),
            (d || h) && e.slidePrev(w)),
          i('keyPress', n));
      }
      function n() {
        e.keyboard.enabled ||
          (document.addEventListener('keydown', a), (e.keyboard.enabled = !0));
      }
      function l() {
        e.keyboard.enabled &&
          (document.removeEventListener('keydown', a),
          (e.keyboard.enabled = !1));
      }
      (t({
        keyboard: {
          enabled: !1,
          onlyInViewport: !0,
          pageUpDown: !0,
          speed: void 0,
        },
      }),
        (e.keyboard = { enabled: !1, enable: n, disable: l }),
        s('init', () => {
          r().enabled && n();
        }),
        s('destroy', () => {
          e.keyboard.enabled && l();
        }));
    },
    ({ swiper: e, extendParams: i, on: r, emit: a }) => {
      let n;
      i({
        mousewheel: {
          enabled: !1,
          releaseOnEdges: !1,
          invert: !1,
          forceToAxis: !1,
          sensitivity: 1,
          eventsTarget: 'container',
          thresholdDelta: null,
          thresholdTime: null,
          noMousewheelClass: 'swiper-no-mousewheel',
        },
      });
      let l,
        o = s(),
        d = !1;
      const c = [];
      function p() {
        return e.params.mousewheel;
      }
      function u() {
        e.enabled && (d = !0);
      }
      function m() {
        e.enabled && (d = !1);
      }
      function h(t) {
        const i = p();
        return (
          !(i.thresholdDelta && t.delta < i.thresholdDelta) &&
          !(i.thresholdTime && s() - o < i.thresholdTime) &&
          ((t.delta >= 6 && s() - o < 60) ||
            (t.direction < 0
              ? (e.isEnd && !e.params.loop) ||
                e.animating ||
                (e.slideNext(), a('scroll', t.raw))
              : (e.isBeginning && !e.params.loop) ||
                e.animating ||
                (e.slidePrev(), a('scroll', t.raw)),
            (o = new window.Date().getTime()),
            !1))
        );
      }
      function f(i) {
        let r = 'originalEvent' in i && i.originalEvent ? i.originalEvent : i,
          o = !0;
        if (!e.enabled) return !1;
        const u = p();
        if (i.target.closest(`.${u.noMousewheelClass}`)) return !1;
        e.params.cssMode && r.preventDefault();
        let m = e.el;
        'container' !== u.eventsTarget &&
          (m = document.querySelector(u.eventsTarget));
        const f = m && m.contains(r.target);
        if (!d && !f && !u.releaseOnEdges) return !0;
        let g = 0;
        const v = e.rtlTranslate ? -1 : 1,
          w = (function (e) {
            const t = e;
            let s = 0,
              i = 0,
              r = 0,
              a = 0;
            return (
              void 0 !== t.detail && (i = t.detail),
              void 0 !== t.wheelDelta && (i = -t.wheelDelta / 120),
              void 0 !== t.wheelDeltaY && (i = -t.wheelDeltaY / 120),
              void 0 !== t.wheelDeltaX && (s = -t.wheelDeltaX / 120),
              void 0 !== t.axis &&
                void 0 !== t.HORIZONTAL_AXIS &&
                t.axis === t.HORIZONTAL_AXIS &&
                ((s = i), (i = 0)),
              (r = 10 * s),
              (a = 10 * i),
              void 0 !== t.deltaY && (a = t.deltaY),
              void 0 !== t.deltaX && (r = t.deltaX),
              t.shiftKey && !r && ((r = a), (a = 0)),
              (r || a) &&
                t.deltaMode &&
                (1 === t.deltaMode
                  ? ((r *= 40), (a *= 40))
                  : ((r *= 800), (a *= 800))),
              r && !s && (s = r < 1 ? -1 : 1),
              a && !i && (i = a < 1 ? -1 : 1),
              { spinX: s, spinY: i, pixelX: r, pixelY: a }
            );
          })(r);
        if (u.forceToAxis)
          if (e.isHorizontal()) {
            if (!(Math.abs(w.pixelX) > Math.abs(w.pixelY))) return !0;
            g = -w.pixelX * v;
          } else {
            if (!(Math.abs(w.pixelY) > Math.abs(w.pixelX))) return !0;
            g = -w.pixelY;
          }
        else
          g =
            Math.abs(w.pixelX) > Math.abs(w.pixelY) ? -w.pixelX * v : -w.pixelY;
        if (0 === g) return !0;
        u.invert && (g = -g);
        let b = e.getTranslate() + g * (u.sensitivity ?? 1);
        (b >= e.minTranslate() && (b = e.minTranslate()),
          b <= e.maxTranslate() && (b = e.maxTranslate()),
          (o =
            !!e.params.loop ||
            !(b === e.minTranslate() || b === e.maxTranslate())),
          o && e.params.nested && r.stopPropagation());
        const y = e.params.freeMode;
        if (e.params.freeMode && y?.enabled) {
          const i = { time: s(), delta: Math.abs(g), direction: Math.sign(g) },
            o =
              l &&
              i.time < l.time + 500 &&
              i.delta <= l.delta &&
              i.direction === l.direction;
          if (!o) {
            l = void 0;
            let s = e.getTranslate() + g * (u.sensitivity ?? 1);
            const d = e.isBeginning,
              p = e.isEnd;
            if (
              (s >= e.minTranslate() && (s = e.minTranslate()),
              s <= e.maxTranslate() && (s = e.maxTranslate()),
              e.setTransition(0),
              e.setTranslate(s),
              e.updateProgress(),
              e.updateActiveIndex(),
              e.updateSlidesClasses(),
              ((!d && e.isBeginning) || (!p && e.isEnd)) &&
                e.updateSlidesClasses(),
              e.params.loop &&
                e.loopFix({
                  direction: i.direction < 0 ? 'next' : 'prev',
                  byMousewheel: !0,
                }),
              y?.sticky)
            ) {
              (clearTimeout(n), (n = void 0), c.length >= 15 && c.shift());
              const s = c.length ? c[c.length - 1] : void 0,
                r = c[0];
              if (
                (c.push(i),
                s && (i.delta > s.delta || i.direction !== s.direction))
              )
                c.splice(0);
              else if (
                c.length >= 15 &&
                r &&
                i.time - r.time < 500 &&
                r.delta - i.delta >= 1 &&
                i.delta <= 6
              ) {
                const s = g > 0 ? 0.8 : 0.2;
                ((l = i),
                  c.splice(0),
                  (n = t(() => {
                    !e.destroyed &&
                      e.params &&
                      e.slideToClosest(e.params.speed, !0, void 0, s);
                  }, 0)));
              }
              n ||
                (n = t(() => {
                  if (e.destroyed || !e.params) return;
                  ((l = i),
                    c.splice(0),
                    e.slideToClosest(e.params.speed, !0, void 0, 0.5));
                }, 500));
            }
            o || a('scroll', r);
            const m = e.params.autoplay;
            if (
              (e.params.autoplay &&
                m?.disableOnInteraction &&
                e.autoplay.stop(),
              u.releaseOnEdges &&
                (s === e.minTranslate() || s === e.maxTranslate()))
            )
              return !0;
          }
        } else {
          const t = {
            time: s(),
            delta: Math.abs(g),
            direction: Math.sign(g),
            raw: i,
          };
          c.length >= 2 && c.shift();
          const r = c.length ? c[c.length - 1] : void 0;
          if (
            (c.push(t),
            r
              ? (t.direction !== r.direction ||
                  t.delta > r.delta ||
                  t.time > r.time + 150) &&
                h(t)
              : h(t),
            (function (t) {
              const s = p();
              if (t.direction < 0) {
                if (e.isEnd && !e.params.loop && s.releaseOnEdges) return !0;
              } else if (e.isBeginning && !e.params.loop && s.releaseOnEdges)
                return !0;
              return !1;
            })(t))
          )
            return !0;
        }
        return (r.cancelable && r.preventDefault(), !1);
      }
      function g(t) {
        const s = p();
        let i = e.el;
        ('container' !== s.eventsTarget &&
          (i = document.querySelector(s.eventsTarget)),
          i[t]('mouseenter', u),
          i[t]('mouseleave', m),
          i[t]('wheel', f));
      }
      function v() {
        return e.params.cssMode
          ? (e.wrapperEl.removeEventListener('wheel', f), !0)
          : !e.mousewheel.enabled &&
              (g('addEventListener'), (e.mousewheel.enabled = !0), !0);
      }
      function w() {
        return e.params.cssMode
          ? (e.wrapperEl.addEventListener('wheel', f), !0)
          : !!e.mousewheel.enabled &&
              (g('removeEventListener'), (e.mousewheel.enabled = !1), !0);
      }
      (r('init', () => {
        const t = p();
        (!t.enabled && e.params.cssMode && w(), t.enabled && v());
      }),
        (e.mousewheel = { enabled: !1, enable: v, disable: w }),
        r('destroy', () => {
          (e.params.cssMode && v(), e.mousewheel.enabled && w());
        }));
    },
    ({ swiper: e, extendParams: t, on: s, emit: i }) => {
      function r() {
        return e.params.navigation;
      }
      function a(t) {
        let s;
        return t &&
          'string' == typeof t &&
          e.isElement &&
          ((s = e.el.querySelector(t) || e.hostEl.querySelector(t)), s)
          ? s
          : (t &&
              ('string' == typeof t && (s = [...document.querySelectorAll(t)]),
              e.params.uniqueNavElements &&
              'string' == typeof t &&
              s &&
              s.length > 1 &&
              1 === e.el.querySelectorAll(t).length
                ? (s = e.el.querySelector(t))
                : s && 1 === s.length && (s = s[0])),
            t && !s ? t : s);
      }
      function n(t, s) {
        const i = r();
        w(t).forEach(t => {
          t &&
            (t.classList[s ? 'add' : 'remove'](...i.disabledClass.split(' ')),
            'BUTTON' === t.tagName && (t.disabled = s),
            e.params.watchOverflow &&
              e.enabled &&
              t.classList[e.isLocked ? 'add' : 'remove'](i.lockClass));
        });
      }
      function l() {
        const { nextEl: t, prevEl: s } = e.navigation;
        if (e.params.loop) return (n(s, !1), void n(t, !1));
        (n(s, e.isBeginning && !e.params.rewind),
          n(t, e.isEnd && !e.params.rewind));
      }
      function o(t) {
        (t.preventDefault(),
          (!e.isBeginning || e.params.loop || e.params.rewind) &&
            (e.slidePrev(), i('navigationPrev')));
      }
      function d(t) {
        (t.preventDefault(),
          (!e.isEnd || e.params.loop || e.params.rewind) &&
            (e.slideNext(), i('navigationNext')));
      }
      function c() {
        e.params.navigation = ae(
          e,
          e.originalParams.navigation,
          e.params.navigation,
          { nextEl: 'swiper-button-next', prevEl: 'swiper-button-prev' }
        );
        const t = r();
        if (!t.nextEl && !t.prevEl) return;
        const s = a(t.nextEl),
          i = a(t.prevEl);
        Object.assign(e.navigation, { nextEl: s, prevEl: i });
        const n = w(s),
          l = w(i),
          c = (s, i) => {
            if (s) {
              if (
                t.addIcons &&
                s.matches('.swiper-button-next,.swiper-button-prev') &&
                !s.querySelector('svg')
              ) {
                const e = document.createElement('div');
                y(e, ne);
                const t = e.querySelector('svg');
                (t && s.appendChild(t), e.remove());
              }
              s.addEventListener('click', 'next' === i ? d : o);
            }
            !e.enabled && s && s.classList.add(...t.lockClass.split(' '));
          };
        (n.forEach(e => c(e, 'next')), l.forEach(e => c(e, 'prev')));
      }
      function p() {
        const t = r(),
          { nextEl: s, prevEl: i } = e.navigation,
          a = w(s),
          n = w(i),
          l = (e, s) => {
            (e.removeEventListener('click', 'next' === s ? d : o),
              e.classList.remove(...t.disabledClass.split(' ')));
          };
        (a.forEach(e => l(e, 'next')), n.forEach(e => l(e, 'prev')));
      }
      (t({
        navigation: {
          nextEl: null,
          prevEl: null,
          addIcons: !0,
          hideOnClick: !1,
          disabledClass: 'swiper-button-disabled',
          hiddenClass: 'swiper-button-hidden',
          lockClass: 'swiper-button-lock',
          navigationDisabledClass: 'swiper-navigation-disabled',
        },
      }),
        (e.navigation = { nextEl: null, prevEl: null, arrowSvg: ne }),
        s('init', () => {
          !1 === r().enabled ? u() : (c(), l());
        }),
        s('toEdge fromEdge lock unlock', () => {
          l();
        }),
        s('destroy', () => {
          p();
        }),
        s('enable disable', () => {
          const t = r(),
            { nextEl: s, prevEl: i } = e.navigation,
            a = w(s),
            n = w(i);
          e.enabled
            ? l()
            : [...a, ...n]
                .filter(e => !!e)
                .forEach(e => e.classList.add(t.lockClass));
        }),
        s('click', (t, s) => {
          const a = r(),
            { nextEl: n, prevEl: l } = e.navigation,
            o = w(n),
            d = w(l),
            c = s.target;
          let p = d.includes(c) || o.includes(c);
          if (e.isElement && !p) {
            const e = s.composedPath ? s.composedPath() : [];
            e.length && (p = e.find(e => o.includes(e) || d.includes(e)));
          }
          if (a.hideOnClick && !p) {
            if (
              e.pagination &&
              e.params.pagination &&
              e.params.pagination.clickable &&
              (e.pagination.el === c || e.pagination.el.contains(c))
            )
              return;
            let t;
            (o.length
              ? (t = o[0].classList.contains(a.hiddenClass))
              : d.length && (t = d[0].classList.contains(a.hiddenClass)),
              i(!0 === t ? 'navigationShow' : 'navigationHide'),
              [...o, ...d]
                .filter(e => !!e)
                .forEach(e => e.classList.toggle(a.hiddenClass)));
          }
        }));
      const u = () => {
        const t = r();
        (e.el.classList.add(...t.navigationDisabledClass.split(' ')), p());
      };
      Object.assign(e.navigation, {
        enable: () => {
          const t = r();
          (e.el.classList.remove(...t.navigationDisabledClass.split(' ')),
            c(),
            l());
        },
        disable: u,
        update: l,
        init: c,
        destroy: p,
      });
    },
    ({ swiper: e, extendParams: t, on: s, emit: i }) => {
      const r = 'swiper-pagination';
      let a;
      (t({
        pagination: {
          el: null,
          bulletElement: 'span',
          clickable: !1,
          hideOnClick: !1,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: !1,
          type: 'bullets',
          dynamicBullets: !1,
          dynamicMainBullets: 1,
          formatFractionCurrent: e => e,
          formatFractionTotal: e => e,
          bulletClass: `${r}-bullet`,
          bulletActiveClass: `${r}-bullet-active`,
          modifierClass: `${r}-`,
          currentClass: `${r}-current`,
          totalClass: `${r}-total`,
          hiddenClass: `${r}-hidden`,
          progressbarFillClass: `${r}-progressbar-fill`,
          progressbarOppositeClass: `${r}-progressbar-opposite`,
          clickableClass: `${r}-clickable`,
          lockClass: `${r}-lock`,
          horizontalClass: `${r}-horizontal`,
          verticalClass: `${r}-vertical`,
          paginationDisabledClass: `${r}-disabled`,
        },
      }),
        (e.pagination = { el: null, bullets: [] }));
      let n = 0;
      function l() {
        return e.params.pagination;
      }
      function o() {
        return (
          !l().el ||
          !e.pagination.el ||
          (Array.isArray(e.pagination.el) && 0 === e.pagination.el.length)
        );
      }
      function d(e, t) {
        const { bulletActiveClass: s } = l();
        if (!e) return;
        let i = e[('prev' === t ? 'previous' : 'next') + 'ElementSibling'];
        i &&
          (i.classList.add(`${s}-${t}`),
          (i = i[('prev' === t ? 'previous' : 'next') + 'ElementSibling']),
          i && i.classList.add(`${s}-${t}-${t}`));
      }
      function c(t) {
        const s = t.target.closest(le(l().bulletClass));
        if (!s) return;
        t.preventDefault();
        const i = (h(s) ?? 0) * (e.params.slidesPerGroup ?? 1);
        if (e.params.loop) {
          if (e.realIndex === i) return;
          const t =
            ((r = e.realIndex),
            (a = i),
            (n = e.slides.length),
            (a %= n) === 1 + (r %= n)
              ? 'next'
              : a === r - 1
                ? 'previous'
                : void 0);
          'next' === t
            ? e.slideNext()
            : 'previous' === t
              ? e.slidePrev()
              : e.slideToLoop(i);
        } else e.slideTo(i);
        var r, a, n;
      }
      function p() {
        const t = e.rtl,
          s = l();
        if (o()) return;
        const r = w(e.pagination.el);
        let c, p;
        const u = oe(e) ? e.virtual.slides.length : e.slides.length,
          m = e.params.loop
            ? Math.ceil(u / (e.params.slidesPerGroup ?? 1))
            : e.snapGrid.length;
        if (
          (e.params.loop
            ? ((p = e.previousRealIndex || 0),
              (c =
                (e.params.slidesPerGroup ?? 1) > 1
                  ? Math.floor(e.realIndex / (e.params.slidesPerGroup ?? 1))
                  : e.realIndex))
            : void 0 !== e.snapIndex
              ? ((c = e.snapIndex), (p = e.previousSnapIndex))
              : ((p = e.previousIndex || 0), (c = e.activeIndex || 0)),
          'bullets' === s.type &&
            e.pagination.bullets &&
            e.pagination.bullets.length > 0)
        ) {
          const i = e.pagination.bullets;
          let l = 0,
            o = 0,
            u = 0;
          if (s.dynamicBullets) {
            a = v(i[0], e.isHorizontal() ? 'width' : 'height');
            const t = e.isHorizontal() ? 'width' : 'height';
            (r.forEach(e => {
              e.style[t] = (a ?? 0) * (s.dynamicMainBullets + 4) + 'px';
            }),
              s.dynamicMainBullets > 1 &&
                void 0 !== p &&
                ((n += c - (p || 0)),
                n > s.dynamicMainBullets - 1
                  ? (n = s.dynamicMainBullets - 1)
                  : n < 0 && (n = 0)),
              (l = Math.max(c - n, 0)),
              (o = l + (Math.min(i.length, s.dynamicMainBullets) - 1)),
              (u = (o + l) / 2));
          }
          if (
            (i.forEach(e => {
              const t = [
                '',
                '-next',
                '-next-next',
                '-prev',
                '-prev-prev',
                '-main',
              ]
                .map(e => `${s.bulletActiveClass}${e}`)
                .flatMap(e =>
                  'string' == typeof e && e.includes(' ') ? e.split(' ') : [e]
                );
              e.classList.remove(...t);
            }),
            r.length > 1)
          )
            i.forEach(t => {
              const i = h(t);
              (i === c
                ? t.classList.add(...s.bulletActiveClass.split(' '))
                : e.isElement && t.setAttribute('part', 'bullet'),
                s.dynamicBullets &&
                  void 0 !== i &&
                  (i >= l &&
                    i <= o &&
                    t.classList.add(
                      ...`${s.bulletActiveClass}-main`.split(' ')
                    ),
                  i === l && d(t, 'prev'),
                  i === o && d(t, 'next')));
            });
          else {
            const t = i[c];
            if (
              (t && t.classList.add(...s.bulletActiveClass.split(' ')),
              e.isElement &&
                i.forEach((e, t) => {
                  e.setAttribute('part', t === c ? 'bullet-active' : 'bullet');
                }),
              s.dynamicBullets)
            ) {
              const e = i[l],
                t = i[o];
              for (let e = l; e <= o; e += 1)
                i[e] &&
                  i[e].classList.add(
                    ...`${s.bulletActiveClass}-main`.split(' ')
                  );
              (d(e, 'prev'), d(t, 'next'));
            }
          }
          if (s.dynamicBullets) {
            const r = Math.min(i.length, s.dynamicMainBullets + 4),
              n = ((a ?? 0) * r - (a ?? 0)) / 2 - u * (a ?? 0),
              l = t ? 'right' : 'left',
              o = e.isHorizontal() ? l : 'top';
            i.forEach(e => {
              e.style[o] = `${n}px`;
            });
          }
        }
        r.forEach((t, r) => {
          if (
            ('fraction' === s.type &&
              (t.querySelectorAll(le(s.currentClass)).forEach(e => {
                e.textContent = String(s.formatFractionCurrent(c + 1));
              }),
              t.querySelectorAll(le(s.totalClass)).forEach(e => {
                e.textContent = String(s.formatFractionTotal(m));
              })),
            'progressbar' === s.type)
          ) {
            let i;
            i = s.progressbarOpposite
              ? e.isHorizontal()
                ? 'vertical'
                : 'horizontal'
              : e.isHorizontal()
                ? 'horizontal'
                : 'vertical';
            const r = (c + 1) / m;
            let a = 1,
              n = 1;
            ('horizontal' === i ? (a = r) : (n = r),
              t.querySelectorAll(le(s.progressbarFillClass)).forEach(t => {
                ((t.style.transform = `translate3d(0,0,0) scaleX(${a}) scaleY(${n})`),
                  (t.style.transitionDuration = `${e.params.speed}ms`));
              }));
          }
          ('custom' === s.type && s.renderCustom
            ? (y(t, s.renderCustom(e, c + 1, m)),
              0 === r && i('paginationRender', t))
            : (0 === r && i('paginationRender', t), i('paginationUpdate', t)),
            e.params.watchOverflow &&
              e.enabled &&
              t.classList[e.isLocked ? 'add' : 'remove'](s.lockClass));
        });
      }
      function u() {
        const t = l();
        if (o()) return;
        const s = e.params.grid,
          r = oe(e)
            ? e.virtual.slides.length
            : e.grid && s?.rows && s.rows > 1
              ? e.slides.length / Math.ceil(s.rows)
              : e.slides.length,
          a = w(e.pagination.el);
        let n = '';
        if ('bullets' === t.type) {
          let s = e.params.loop
            ? Math.ceil(r / (e.params.slidesPerGroup ?? 1))
            : e.snapGrid.length;
          e.params.freeMode &&
            (e => !!e.params.freeMode?.enabled)(e) &&
            s > r &&
            (s = r);
          for (let i = 0; i < s; i += 1)
            t.renderBullet
              ? (n += t.renderBullet.call(e, i, t.bulletClass))
              : (n += `<${t.bulletElement} ${e.isElement ? 'part="bullet"' : ''} class="${t.bulletClass}"></${t.bulletElement}>`);
        }
        ('fraction' === t.type &&
          (n = t.renderFraction
            ? t.renderFraction.call(e, t.currentClass, t.totalClass)
            : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`),
          'progressbar' === t.type &&
            (n = t.renderProgressbar
              ? t.renderProgressbar.call(e, t.progressbarFillClass)
              : `<span class="${t.progressbarFillClass}"></span>`),
          (e.pagination.bullets = []),
          a.forEach(s => {
            ('custom' !== t.type && y(s, n || ''),
              'bullets' === t.type &&
                e.pagination.bullets.push(
                  ...Array.from(s.querySelectorAll(le(t.bulletClass)))
                ));
          }),
          'custom' !== t.type && i('paginationRender', a[0]));
      }
      function m() {
        e.params.pagination = ae(
          e,
          e.originalParams.pagination,
          e.params.pagination,
          { el: 'swiper-pagination' }
        );
        const t = l();
        if (!t.el) return;
        let s;
        if (
          ('string' == typeof t.el &&
            e.isElement &&
            (s = e.el.querySelector(t.el)),
          s ||
            'string' != typeof t.el ||
            (s = [...document.querySelectorAll(t.el)]),
          s || (s = t.el),
          !s || (Array.isArray(s) && 0 === s.length))
        )
          return;
        if (
          e.params.uniqueNavElements &&
          'string' == typeof t.el &&
          Array.isArray(s) &&
          s.length > 1 &&
          ((s = [...e.el.querySelectorAll(t.el)]), s.length > 1)
        ) {
          const t = s.find(t => f(t, '.swiper')[0] === e.el);
          t && (s = t);
        }
        (Array.isArray(s) && 1 === s.length && (s = s[0]),
          Object.assign(e.pagination, { el: s }));
        w(s).forEach(s => {
          ('bullets' === t.type &&
            t.clickable &&
            s.classList.add(...(t.clickableClass || '').split(' ')),
            s.classList.add(t.modifierClass + t.type),
            s.classList.add(
              e.isHorizontal() ? t.horizontalClass : t.verticalClass
            ),
            'bullets' === t.type &&
              t.dynamicBullets &&
              (s.classList.add(`${t.modifierClass}${t.type}-dynamic`),
              (n = 0),
              t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
            'progressbar' === t.type &&
              t.progressbarOpposite &&
              s.classList.add(t.progressbarOppositeClass),
            t.clickable && s.addEventListener('click', c),
            e.enabled || s.classList.add(t.lockClass));
        });
      }
      function g() {
        const t = l();
        if (o()) return;
        const s = e.pagination.el;
        if (s) {
          w(s).forEach(s => {
            (s.classList.remove(t.hiddenClass),
              s.classList.remove(t.modifierClass + t.type),
              s.classList.remove(
                e.isHorizontal() ? t.horizontalClass : t.verticalClass
              ),
              t.clickable &&
                (s.classList.remove(...(t.clickableClass || '').split(' ')),
                s.removeEventListener('click', c)));
          });
        }
        e.pagination.bullets &&
          e.pagination.bullets.forEach(e =>
            e.classList.remove(...t.bulletActiveClass.split(' '))
          );
      }
      (s('changeDirection', () => {
        if (!e.pagination || !e.pagination.el) return;
        const t = l();
        w(e.pagination.el).forEach(s => {
          (s.classList.remove(t.horizontalClass, t.verticalClass),
            s.classList.add(
              e.isHorizontal() ? t.horizontalClass : t.verticalClass
            ));
        });
      }),
        s('init', () => {
          !1 === l().enabled ? b() : (m(), u(), p());
        }),
        s('activeIndexChange', () => {
          void 0 === e.snapIndex && p();
        }),
        s('snapIndexChange', () => {
          p();
        }),
        s('snapGridLengthChange', () => {
          (u(), p());
        }),
        s('destroy', () => {
          g();
        }),
        s('enable disable', () => {
          const { el: t } = e.pagination;
          if (t) {
            const s = l();
            w(t).forEach(t =>
              t.classList[e.enabled ? 'remove' : 'add'](s.lockClass)
            );
          }
        }),
        s('lock unlock', () => {
          p();
        }),
        s('click', (t, s) => {
          const r = s.target,
            a = w(e.pagination.el),
            n = l();
          if (
            n.el &&
            n.hideOnClick &&
            a &&
            a.length > 0 &&
            !r.classList.contains(n.bulletClass)
          ) {
            if (
              e.navigation &&
              ((e.navigation.nextEl && r === e.navigation.nextEl) ||
                (e.navigation.prevEl && r === e.navigation.prevEl))
            )
              return;
            const t = a[0].classList.contains(n.hiddenClass);
            (i(!0 === t ? 'paginationShow' : 'paginationHide'),
              a.forEach(e => e.classList.toggle(n.hiddenClass)));
          }
        }));
      const b = () => {
        const t = l();
        e.el.classList.add(t.paginationDisabledClass);
        const { el: s } = e.pagination;
        if (s) {
          w(s).forEach(e => e.classList.add(t.paginationDisabledClass));
        }
        g();
      };
      Object.assign(e.pagination, {
        enable: () => {
          const t = l();
          e.el.classList.remove(t.paginationDisabledClass);
          const { el: s } = e.pagination;
          if (s) {
            w(s).forEach(e => e.classList.remove(t.paginationDisabledClass));
          }
          (m(), u(), p());
        },
        disable: b,
        render: u,
        update: p,
        init: m,
        destroy: g,
      });
    },
    ({ swiper: s, extendParams: i, on: r, emit: a }) => {
      let n = !1,
        l = null,
        o = null,
        d = 0,
        c = 0,
        m = 0,
        h = 0;
      function f() {
        return s.params.scrollbar;
      }
      function g() {
        const e = f();
        if (!e.el || !s.scrollbar.el) return;
        const { scrollbar: t, rtlTranslate: i } = s,
          { dragEl: r, el: a } = t,
          n = s.params.loop ? (s.progressLoop ?? 0) : s.progress;
        let o = c,
          d = (m - c) * n;
        (i
          ? ((d = -d),
            d > 0 ? ((o = c - d), (d = 0)) : -d + c > m && (o = m + d))
          : d < 0
            ? ((o = c + d), (d = 0))
            : d + c > m && (o = m - d),
          s.isHorizontal()
            ? ((r.style.transform = `translate3d(${d}px, 0, 0)`),
              (r.style.width = `${o}px`))
            : ((r.style.transform = `translate3d(0px, ${d}px, 0)`),
              (r.style.height = `${o}px`)),
          e.hide &&
            (l && clearTimeout(l),
            (a.style.opacity = '1'),
            (l = setTimeout(() => {
              ((a.style.opacity = '0'), (a.style.transitionDuration = '400ms'));
            }, 1e3))));
      }
      function v() {
        const e = f();
        if (!e.el || !s.scrollbar.el) return;
        const { scrollbar: t } = s,
          { dragEl: i, el: r } = t;
        ((i.style.width = ''),
          (i.style.height = ''),
          (m = s.isHorizontal() ? r.offsetWidth : r.offsetHeight),
          (h =
            s.size /
            (s.virtualSize +
              (s.params.slidesOffsetBefore ?? 0) -
              (s.params.centeredSlides ? s.snapGrid[0] : 0))),
          (c =
            'auto' === e.dragSize ? m * h : parseInt(String(e.dragSize), 10)),
          s.isHorizontal()
            ? (i.style.width = `${c}px`)
            : (i.style.height = `${c}px`),
          (r.style.display = h >= 1 ? 'none' : ''),
          e.hide && (r.style.opacity = '0'),
          s.params.watchOverflow &&
            s.enabled &&
            t.el.classList[s.isLocked ? 'add' : 'remove'](e.lockClass));
      }
      function b(e) {
        return s.isHorizontal()
          ? (e.clientX ?? e.touches?.[0]?.clientX ?? 0)
          : (e.clientY ?? e.touches?.[0]?.clientY ?? 0);
      }
      function y(e) {
        const { scrollbar: t, rtlTranslate: i } = s,
          { el: r } = t;
        let a;
        ((a =
          (b(e) -
            u(r)[s.isHorizontal() ? 'left' : 'top'] -
            (null !== d ? d : c / 2)) /
          (m - c)),
          (a = Math.max(Math.min(a, 1), 0)),
          i && (a = 1 - a));
        const n = s.minTranslate() + (s.maxTranslate() - s.minTranslate()) * a;
        (s.updateProgress(n),
          s.setTranslate(n),
          s.updateActiveIndex(),
          s.updateSlidesClasses());
      }
      function E(e) {
        const t = f(),
          { scrollbar: i, wrapperEl: r } = s,
          { el: l, dragEl: c } = i;
        ((n = !0),
          (d =
            e.target === c
              ? b(e) -
                e.target.getBoundingClientRect()[
                  s.isHorizontal() ? 'left' : 'top'
                ]
              : null),
          e.preventDefault(),
          e.stopPropagation(),
          (r.style.transitionDuration = '100ms'),
          (c.style.transitionDuration = '100ms'),
          y(e),
          o && clearTimeout(o),
          (l.style.transitionDuration = '0ms'),
          t.hide && (l.style.opacity = '1'),
          s.params.cssMode && (s.wrapperEl.style.scrollSnapType = 'none'),
          a('scrollbarDragStart', e));
      }
      function S(e) {
        const { scrollbar: t, wrapperEl: i } = s,
          { el: r, dragEl: l } = t;
        n &&
          (e.cancelable && e.preventDefault(),
          y(e),
          (i.style.transitionDuration = '0ms'),
          (r.style.transitionDuration = '0ms'),
          (l.style.transitionDuration = '0ms'),
          a('scrollbarDragMove', e));
      }
      function x(e) {
        const i = f(),
          { scrollbar: r, wrapperEl: l } = s,
          { el: d } = r;
        n &&
          ((n = !1),
          s.params.cssMode &&
            ((s.wrapperEl.style.scrollSnapType = ''),
            (l.style.transitionDuration = '')),
          i.hide &&
            (o && clearTimeout(o),
            (o = t(() => {
              ((d.style.opacity = '0'), (d.style.transitionDuration = '400ms'));
            }, 1e3))),
          a('scrollbarDragEnd', e),
          i.snapOnRelease && s.slideToClosest());
      }
      function T(e) {
        const { scrollbar: t, params: i } = s,
          r = t.el;
        if (!r) return;
        const a = !!i.passiveListeners && { passive: !1, capture: !1 },
          n = !!i.passiveListeners && { passive: !0, capture: !1 },
          l = 'on' === e ? 'addEventListener' : 'removeEventListener';
        (r[l]('pointerdown', E, a),
          document[l]('pointermove', S, a),
          document[l]('pointerup', x, n));
      }
      function M() {
        const { scrollbar: t, el: i } = s;
        s.params.scrollbar = ae(
          s,
          s.originalParams.scrollbar,
          s.params.scrollbar,
          { el: 'swiper-scrollbar' }
        );
        const r = f();
        if (!r.el) return;
        let a;
        if (
          ((a =
            'string' == typeof r.el && s.isElement
              ? s.el.querySelector(r.el)
              : r.el),
          a || 'string' != typeof r.el)
        )
          a || (a = r.el);
        else if (((a = document.querySelectorAll(r.el)), !a.length)) return;
        (s.params.uniqueNavElements &&
          'string' == typeof r.el &&
          a.length > 1 &&
          1 === i.querySelectorAll(r.el).length &&
          (a = i.querySelector(r.el)),
          a.length > 0 && (a = a[0]));
        const n = a;
        n.classList.add(s.isHorizontal() ? r.horizontalClass : r.verticalClass);
        let l = null;
        (n &&
          ((l = n.querySelector(le(r.dragClass))),
          l || ((l = p('div', r.dragClass)), n.append(l))),
          Object.assign(t, { el: n, dragEl: l }),
          r.draggable && f().el && s.scrollbar.el && T('on'),
          n && n.classList[s.enabled ? 'remove' : 'add'](...e(r.lockClass)));
      }
      function C() {
        const t = f(),
          i = s.scrollbar.el;
        (i &&
          i.classList.remove(
            ...e(s.isHorizontal() ? t.horizontalClass : t.verticalClass)
          ),
          f().el && s.scrollbar.el && T('off'));
      }
      (i({
        scrollbar: {
          el: null,
          dragSize: 'auto',
          hide: !1,
          draggable: !1,
          snapOnRelease: !0,
          lockClass: 'swiper-scrollbar-lock',
          dragClass: 'swiper-scrollbar-drag',
          scrollbarDisabledClass: 'swiper-scrollbar-disabled',
          horizontalClass: 'swiper-scrollbar-horizontal',
          verticalClass: 'swiper-scrollbar-vertical',
        },
      }),
        (s.scrollbar = { el: null, dragEl: null }),
        r('changeDirection', () => {
          if (!s.scrollbar || !s.scrollbar.el) return;
          const e = f();
          w(s.scrollbar.el).forEach(t => {
            (t.classList.remove(e.horizontalClass, e.verticalClass),
              t.classList.add(
                s.isHorizontal() ? e.horizontalClass : e.verticalClass
              ));
          });
        }),
        r('init', () => {
          !1 === f().enabled ? P() : (M(), v(), g());
        }),
        r('update resize observerUpdate lock unlock changeDirection', () => {
          v();
        }),
        r('setTranslate', () => {
          g();
        }),
        r('setTransition', (e, t) => {
          !(function (e) {
            f().el &&
              s.scrollbar.el &&
              (s.scrollbar.dragEl.style.transitionDuration = `${e}ms`);
          })(t);
        }),
        r('enable disable', () => {
          const { el: t } = s.scrollbar;
          t && t.classList[s.enabled ? 'remove' : 'add'](...e(f().lockClass));
        }),
        r('destroy', () => {
          C();
        }));
      const P = () => {
        const t = f();
        (s.el.classList.add(...e(t.scrollbarDisabledClass)),
          s.scrollbar.el &&
            s.scrollbar.el.classList.add(...e(t.scrollbarDisabledClass)),
          C());
      };
      Object.assign(s.scrollbar, {
        enable: () => {
          const t = f();
          (s.el.classList.remove(...e(t.scrollbarDisabledClass)),
            s.scrollbar.el &&
              s.scrollbar.el.classList.remove(...e(t.scrollbarDisabledClass)),
            M(),
            v(),
            g());
        },
        disable: P,
        updateSize: v,
        setTranslate: g,
        init: M,
        destroy: C,
      });
    },
    ({ swiper: e, extendParams: t, on: s }) => {
      function i() {
        return e.params.parallax;
      }
      t({ parallax: { enabled: !1 } });
      const r =
          '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]',
        a = (t, s) => {
          const { rtl: i } = e,
            r = i ? -1 : 1,
            a = t.getAttribute('data-swiper-parallax') || '0';
          let n = t.getAttribute('data-swiper-parallax-x'),
            l = t.getAttribute('data-swiper-parallax-y');
          const o = t.getAttribute('data-swiper-parallax-scale'),
            d = t.getAttribute('data-swiper-parallax-opacity'),
            c = t.getAttribute('data-swiper-parallax-rotate');
          if (
            (n || l
              ? ((n = n || '0'), (l = l || '0'))
              : e.isHorizontal()
                ? ((n = a), (l = '0'))
                : ((l = a), (n = '0')),
            (n =
              n.indexOf('%') >= 0
                ? parseInt(n, 10) * s * r + '%'
                : Number(n) * s * r + 'px'),
            (l =
              l.indexOf('%') >= 0
                ? parseInt(l, 10) * s + '%'
                : Number(l) * s + 'px'),
            null != d)
          ) {
            const e = Number(d),
              i = e - (e - 1) * (1 - Math.abs(s));
            t.style.opacity = String(i);
          }
          let p = `translate3d(${n}, ${l}, 0px)`;
          if (null != o) {
            const e = Number(o);
            p += ` scale(${e - (e - 1) * (1 - Math.abs(s))})`;
          }
          if (c && null != c) {
            p += ` rotate(${Number(c) * s * -1}deg)`;
          }
          t.style.transform = p;
        },
        n = () => {
          const { el: t, slides: s, progress: i, snapGrid: n } = e,
            l = d(t, r);
          (e.isElement && l.push(...d(e.hostEl, r)),
            l.forEach(e => {
              a(e, i);
            }),
            s.forEach((t, s) => {
              let l = t.progress ?? 0;
              ((e.params.slidesPerGroup ?? 1) > 1 &&
                'auto' !== e.params.slidesPerView &&
                (l += Math.ceil(s / 2) - i * (n.length - 1)),
                (l = Math.min(Math.max(l, -1), 1)),
                t
                  .querySelectorAll(`${r}, [data-swiper-parallax-rotate]`)
                  .forEach(e => {
                    a(e, l);
                  }));
            }));
        };
      (s('beforeInit', () => {
        i().enabled &&
          ((e.params.watchSlidesProgress = !0),
          (e.originalParams.watchSlidesProgress = !0));
      }),
        s('init', () => {
          i().enabled && n();
        }),
        s('setTranslate', () => {
          i().enabled && n();
        }),
        s('setTransition', (t, s) => {
          i().enabled &&
            ((t = e.params.speed ?? 300) => {
              const { el: s, hostEl: i } = e,
                a = [...s.querySelectorAll(r)];
              (e.isElement && a.push(...i.querySelectorAll(r)),
                a.forEach(e => {
                  const s = e.getAttribute('data-swiper-parallax-duration');
                  let i = (s ? parseInt(s, 10) : 0) || t;
                  (0 === t && (i = 0), (e.style.transitionDuration = `${i}ms`));
                }));
            })(s);
        }));
    },
    ({ swiper: e, extendParams: t, on: s, emit: r }) => {
      function a() {
        return e.params.zoom;
      }
      (t({
        zoom: {
          enabled: !1,
          limitToOriginalSize: !1,
          maxRatio: 3,
          minRatio: 1,
          panOnMouseMove: !1,
          toggle: !0,
          containerClass: 'swiper-zoom-container',
          zoomedSlideClass: 'swiper-slide-zoomed',
        },
      }),
        (e.zoom = { enabled: !1 }));
      let n = 1,
        l = !1,
        o = !1,
        c = { x: 0, y: 0 };
      let p = !1,
        m = !1;
      const h = [],
        g = {
          originX: 0,
          originY: 0,
          slideEl: void 0,
          slideWidth: void 0,
          slideHeight: void 0,
          imageEl: void 0,
          imageWrapEl: void 0,
          maxRatio: 3,
        },
        v = {
          isTouched: void 0,
          isMoved: void 0,
          currentX: void 0,
          currentY: void 0,
          minX: void 0,
          minY: void 0,
          maxX: void 0,
          maxY: void 0,
          width: void 0,
          height: void 0,
          startX: void 0,
          startY: void 0,
          touchesStart: {},
          touchesCurrent: {},
        },
        w = {
          x: void 0,
          y: void 0,
          prevPositionX: void 0,
          prevPositionY: void 0,
          prevTime: void 0,
        };
      let b,
        y = 1;
      function E() {
        if (h.length < 2) return 1;
        const e = h[0].pageX,
          t = h[0].pageY,
          s = h[1].pageX,
          i = h[1].pageY;
        return Math.sqrt((s - e) ** 2 + (i - t) ** 2);
      }
      function S() {
        const e = a(),
          t = g.imageWrapEl?.getAttribute('data-swiper-zoom'),
          s = null != t ? Number(t) : e.maxRatio,
          i = g.imageEl;
        if (e.limitToOriginalSize && i && i.naturalWidth) {
          const e = i.naturalWidth / i.offsetWidth;
          return Math.min(e, s);
        }
        return s;
      }
      function x(t) {
        const s = e.isElement ? 'swiper-slide' : `.${e.params.slideClass}`,
          i = t.target;
        return (
          !!i &&
          (!!i.matches(s) || e.slides.filter(e => e.contains(i)).length > 0)
        );
      }
      function T(t) {
        const s = `.${a().containerClass}`,
          i = t.target;
        return (
          !!i &&
          (!!i.matches(s) ||
            [...e.hostEl.querySelectorAll(s)].filter(e => e.contains(i))
              .length > 0)
        );
      }
      function M(t) {
        if (('mouse' === t.pointerType && h.splice(0, h.length), !x(t))) return;
        const s = a();
        if (((p = !1), (m = !1), h.push(t), !(h.length < 2))) {
          if (((p = !0), (g.scaleStart = E()), !g.slideEl)) {
            const i = t.target;
            ((g.slideEl =
              i?.closest(`.${e.params.slideClass}, swiper-slide`) ?? void 0),
              g.slideEl || (g.slideEl = e.slides[e.activeIndex]));
            let r = g.slideEl?.querySelector(`.${s.containerClass}`) ?? null;
            if (
              (r &&
                (r =
                  r.querySelectorAll(
                    'picture, img, svg, canvas, .swiper-zoom-target'
                  )[0] ?? null),
              (g.imageEl = r ?? void 0),
              (g.imageWrapEl = r
                ? (f(r, `.${s.containerClass}`)[0] ?? void 0)
                : void 0),
              !g.imageWrapEl)
            )
              return void (g.imageEl = void 0);
            g.maxRatio = S();
          }
          if (g.imageEl) {
            const [e, t] = (function () {
              if (h.length < 2 || !g.imageEl) return [null, null];
              const e = g.imageEl.getBoundingClientRect();
              return [
                (h[0].pageX +
                  (h[1].pageX - h[0].pageX) / 2 -
                  e.x -
                  window.scrollX) /
                  n,
                (h[0].pageY +
                  (h[1].pageY - h[0].pageY) / 2 -
                  e.y -
                  window.scrollY) /
                  n,
              ];
            })();
            ((g.originX = e ?? 0),
              (g.originY = t ?? 0),
              (g.imageEl.style.transitionDuration = '0ms'));
          }
          l = !0;
        }
      }
      function C(t) {
        if (!x(t)) return;
        const s = a(),
          i = e.zoom,
          r = h.findIndex(e => e.pointerId === t.pointerId);
        (r >= 0 && (h[r] = t),
          h.length < 2 ||
            ((m = !0),
            (g.scaleMove = E()),
            g.imageEl &&
              ((i.scale = (g.scaleMove / (g.scaleStart ?? 1)) * n),
              i.scale > g.maxRatio &&
                (i.scale = g.maxRatio - 1 + (i.scale - g.maxRatio + 1) ** 0.5),
              i.scale < s.minRatio &&
                (i.scale = s.minRatio + 1 - (s.minRatio - i.scale + 1) ** 0.5),
              (g.imageEl.style.transform = `translate3d(0,0,0) scale(${i.scale})`))));
      }
      function P(t) {
        if (!x(t)) return;
        if ('mouse' === t.pointerType && 'pointerout' === t.type) return;
        const s = a(),
          i = e.zoom,
          r = h.findIndex(e => e.pointerId === t.pointerId);
        (r >= 0 && h.splice(r, 1),
          p &&
            m &&
            ((p = !1),
            (m = !1),
            g.imageEl &&
              ((i.scale = Math.max(Math.min(i.scale, g.maxRatio), s.minRatio)),
              (g.imageEl.style.transitionDuration = `${e.params.speed}ms`),
              (g.imageEl.style.transform = `translate3d(0,0,0) scale(${i.scale})`),
              (n = i.scale),
              (l = !1),
              i.scale > 1 && g.slideEl
                ? g.slideEl.classList.add(`${s.zoomedSlideClass}`)
                : i.scale <= 1 &&
                  g.slideEl &&
                  g.slideEl.classList.remove(`${s.zoomedSlideClass}`),
              1 === i.scale &&
                ((g.originX = 0), (g.originY = 0), (g.slideEl = void 0)))));
      }
      function L() {
        e.touchEventsData.preventTouchMoveFromPointerMove = !1;
      }
      function A(t) {
        const s = 'mouse' === t.pointerType && a().panOnMouseMove;
        if (!x(t) || !T(t)) return;
        const r = e.zoom;
        if (!g.imageEl) return;
        if (!v.isTouched || !g.slideEl) return void (s && z(t));
        if (s) return void z(t);
        v.isMoved ||
          ((v.width = g.imageEl.offsetWidth || g.imageEl.clientWidth),
          (v.height = g.imageEl.offsetHeight || g.imageEl.clientHeight),
          (v.startX = i(g.imageWrapEl, 'x') || 0),
          (v.startY = i(g.imageWrapEl, 'y') || 0),
          (g.slideWidth = g.slideEl.offsetWidth),
          (g.slideHeight = g.slideEl.offsetHeight),
          (g.imageWrapEl.style.transitionDuration = '0ms'));
        const o = v.width * r.scale,
          d = v.height * r.scale;
        ((v.minX = Math.min(g.slideWidth / 2 - o / 2, 0)),
          (v.maxX = -v.minX),
          (v.minY = Math.min(g.slideHeight / 2 - d / 2, 0)),
          (v.maxY = -v.minY),
          (v.touchesCurrent.x = h.length > 0 ? h[0].pageX : t.pageX),
          (v.touchesCurrent.y = h.length > 0 ? h[0].pageY : t.pageY));
        Math.max(
          Math.abs(v.touchesCurrent.x - (v.touchesStart.x ?? 0)),
          Math.abs(v.touchesCurrent.y - (v.touchesStart.y ?? 0))
        ) > 5 && (e.allowClick = !1);
        const c = v.startX ?? 0,
          p = v.startY ?? 0;
        if (!v.isMoved && !l) {
          if (
            e.isHorizontal() &&
            ((Math.floor(v.minX) === Math.floor(c) &&
              v.touchesCurrent.x < (v.touchesStart.x ?? 0)) ||
              (Math.floor(v.maxX) === Math.floor(c) &&
                v.touchesCurrent.x > (v.touchesStart.x ?? 0)))
          )
            return ((v.isTouched = !1), void L());
          if (
            !e.isHorizontal() &&
            ((Math.floor(v.minY) === Math.floor(p) &&
              v.touchesCurrent.y < (v.touchesStart.y ?? 0)) ||
              (Math.floor(v.maxY) === Math.floor(p) &&
                v.touchesCurrent.y > (v.touchesStart.y ?? 0)))
          )
            return ((v.isTouched = !1), void L());
        }
        (t.cancelable && t.preventDefault(),
          t.stopPropagation(),
          void 0 !== b && clearTimeout(b),
          (e.touchEventsData.preventTouchMoveFromPointerMove = !0),
          (b = setTimeout(() => {
            e.destroyed || L();
          })),
          (v.isMoved = !0));
        const u = (r.scale - n) / (g.maxRatio - a().minRatio),
          { originX: m, originY: f } = g;
        ((v.currentX =
          v.touchesCurrent.x -
          (v.touchesStart.x ?? 0) +
          c +
          u * (v.width - 2 * m)),
          (v.currentY =
            v.touchesCurrent.y -
            (v.touchesStart.y ?? 0) +
            p +
            u * (v.height - 2 * f)),
          v.currentX < v.minX &&
            (v.currentX = v.minX + 1 - (v.minX - v.currentX + 1) ** 0.8),
          v.currentX > v.maxX &&
            (v.currentX = v.maxX - 1 + (v.currentX - v.maxX + 1) ** 0.8),
          v.currentY < v.minY &&
            (v.currentY = v.minY + 1 - (v.minY - v.currentY + 1) ** 0.8),
          v.currentY > v.maxY &&
            (v.currentY = v.maxY - 1 + (v.currentY - v.maxY + 1) ** 0.8),
          w.prevPositionX || (w.prevPositionX = v.touchesCurrent.x),
          w.prevPositionY || (w.prevPositionY = v.touchesCurrent.y),
          w.prevTime || (w.prevTime = Date.now()),
          (w.x =
            (v.touchesCurrent.x - w.prevPositionX) /
            (Date.now() - w.prevTime) /
            2),
          (w.y =
            (v.touchesCurrent.y - w.prevPositionY) /
            (Date.now() - w.prevTime) /
            2),
          Math.abs(v.touchesCurrent.x - w.prevPositionX) < 2 && (w.x = 0),
          Math.abs(v.touchesCurrent.y - w.prevPositionY) < 2 && (w.y = 0),
          (w.prevPositionX = v.touchesCurrent.x),
          (w.prevPositionY = v.touchesCurrent.y),
          (w.prevTime = Date.now()),
          (g.imageWrapEl.style.transform = `translate3d(${v.currentX}px, ${v.currentY}px,0)`));
      }
      function I() {
        const t = e.zoom;
        g.slideEl &&
          e.activeIndex !== e.slides.indexOf(g.slideEl) &&
          (g.imageEl &&
            (g.imageEl.style.transform = 'translate3d(0,0,0) scale(1)'),
          g.imageWrapEl &&
            (g.imageWrapEl.style.transform = 'translate3d(0,0,0)'),
          g.slideEl.classList.remove(`${a().zoomedSlideClass}`),
          (t.scale = 1),
          (n = 1),
          (g.slideEl = void 0),
          (g.imageEl = void 0),
          (g.imageWrapEl = void 0),
          (g.originX = 0),
          (g.originY = 0));
      }
      function z(e) {
        if (n <= 1 || !g.imageWrapEl) return;
        if (!x(e) || !T(e)) return;
        const t = window.getComputedStyle(g.imageWrapEl).transform,
          s = new window.DOMMatrix(t);
        if (!o)
          return (
            (o = !0),
            (c.x = e.clientX),
            (c.y = e.clientY),
            (v.startX = s.e),
            (v.startY = s.f),
            (v.width = g.imageEl.offsetWidth || g.imageEl.clientWidth),
            (v.height = g.imageEl.offsetHeight || g.imageEl.clientHeight),
            (g.slideWidth = g.slideEl.offsetWidth),
            void (g.slideHeight = g.slideEl.offsetHeight)
          );
        const i = -3 * (e.clientX - c.x),
          r = -3 * (e.clientY - c.y),
          a = v.width * n,
          l = v.height * n,
          d = g.slideWidth,
          p = g.slideHeight,
          u = Math.min(d / 2 - a / 2, 0),
          m = -u,
          h = Math.min(p / 2 - l / 2, 0),
          f = -h,
          w = Math.max(Math.min(v.startX + i, m), u),
          b = Math.max(Math.min(v.startY + r, f), h);
        ((g.imageWrapEl.style.transitionDuration = '0ms'),
          (g.imageWrapEl.style.transform = `translate3d(${w}px, ${b}px, 0)`),
          (c.x = e.clientX),
          (c.y = e.clientY),
          (v.startX = w),
          (v.startY = b),
          (v.currentX = w),
          (v.currentY = b));
      }
      function $(t) {
        const s = e.zoom,
          i = a();
        if (!g.slideEl) {
          if (
            (t &&
              'number' != typeof t &&
              'target' in t &&
              t.target &&
              (g.slideEl =
                t.target.closest(`.${e.params.slideClass}, swiper-slide`) ??
                void 0),
            !g.slideEl)
          ) {
            const t = e.params.virtual;
            t && t.enabled && e.virtual
              ? (g.slideEl =
                  d(e.slidesEl, `.${e.params.slideActiveClass}`)[0] ?? void 0)
              : (g.slideEl = e.slides[e.activeIndex]);
          }
          let s = g.slideEl?.querySelector(`.${i.containerClass}`) ?? null;
          (s &&
            (s =
              s.querySelectorAll(
                'picture, img, svg, canvas, .swiper-zoom-target'
              )[0] ?? null),
            (g.imageEl = s ?? void 0),
            (g.imageWrapEl = s
              ? (f(s, `.${i.containerClass}`)[0] ?? void 0)
              : void 0));
        }
        if (!g.imageEl || !g.imageWrapEl || !g.slideEl) return;
        let r, l, o, c, p, m, h, w, b, y, E, x, T, M, C, P, L, A;
        ((g.maxRatio = S()),
          e.params.cssMode &&
            ((e.wrapperEl.style.overflow = 'hidden'),
            (e.wrapperEl.style.touchAction = 'none')),
          g.slideEl.classList.add(`${i.zoomedSlideClass}`));
        const I = t && 'number' != typeof t;
        void 0 === v.touchesStart.x && I
          ? ((r = t.pageX), (l = t.pageY))
          : ((r = v.touchesStart.x), (l = v.touchesStart.y));
        const z = n,
          $ = 'number' == typeof t ? t : null;
        1 === n &&
          $ &&
          ((r = void 0),
          (l = void 0),
          (v.touchesStart.x = void 0),
          (v.touchesStart.y = void 0));
        const k = S();
        ((s.scale = $ || k),
          (n = $ || k),
          !t || (1 === n && $)
            ? ((h = 0), (w = 0))
            : ((L = g.slideEl.offsetWidth),
              (A = g.slideEl.offsetHeight),
              (o = u(g.slideEl).left + window.scrollX),
              (c = u(g.slideEl).top + window.scrollY),
              (p = o + L / 2 - (r ?? 0)),
              (m = c + A / 2 - (l ?? 0)),
              (b = g.imageEl.offsetWidth || g.imageEl.clientWidth),
              (y = g.imageEl.offsetHeight || g.imageEl.clientHeight),
              (E = b * s.scale),
              (x = y * s.scale),
              (T = Math.min(L / 2 - E / 2, 0)),
              (M = Math.min(A / 2 - x / 2, 0)),
              (C = -T),
              (P = -M),
              z > 0 &&
              $ &&
              'number' == typeof v.currentX &&
              'number' == typeof v.currentY
                ? ((h = (v.currentX * s.scale) / z),
                  (w = (v.currentY * s.scale) / z))
                : ((h = p * s.scale), (w = m * s.scale)),
              h < T && (h = T),
              h > C && (h = C),
              w < M && (w = M),
              w > P && (w = P)),
          $ && 1 === s.scale && ((g.originX = 0), (g.originY = 0)),
          (v.currentX = h),
          (v.currentY = w),
          (g.imageWrapEl.style.transitionDuration = '300ms'),
          (g.imageWrapEl.style.transform = `translate3d(${h}px, ${w}px,0)`),
          (g.imageEl.style.transitionDuration = '300ms'),
          (g.imageEl.style.transform = `translate3d(0,0,0) scale(${s.scale})`));
      }
      function k() {
        const t = e.zoom,
          s = a();
        if (!g.slideEl) {
          const t = e.params.virtual;
          t && t.enabled && e.virtual
            ? (g.slideEl =
                d(e.slidesEl, `.${e.params.slideActiveClass}`)[0] ?? void 0)
            : (g.slideEl = e.slides[e.activeIndex]);
          let i = g.slideEl?.querySelector(`.${s.containerClass}`) ?? null;
          (i &&
            (i =
              i.querySelectorAll(
                'picture, img, svg, canvas, .swiper-zoom-target'
              )[0] ?? null),
            (g.imageEl = i ?? void 0),
            (g.imageWrapEl = i
              ? (f(i, `.${s.containerClass}`)[0] ?? void 0)
              : void 0));
        }
        g.imageEl &&
          g.imageWrapEl &&
          g.slideEl &&
          ((g.maxRatio = S()),
          e.params.cssMode &&
            ((e.wrapperEl.style.overflow = ''),
            (e.wrapperEl.style.touchAction = '')),
          (t.scale = 1),
          (n = 1),
          (v.currentX = void 0),
          (v.currentY = void 0),
          (v.touchesStart.x = void 0),
          (v.touchesStart.y = void 0),
          (g.imageWrapEl.style.transitionDuration = '300ms'),
          (g.imageWrapEl.style.transform = 'translate3d(0,0,0)'),
          (g.imageEl.style.transitionDuration = '300ms'),
          (g.imageEl.style.transform = 'translate3d(0,0,0) scale(1)'),
          g.slideEl.classList.remove(`${s.zoomedSlideClass}`),
          (g.slideEl = void 0),
          (g.originX = 0),
          (g.originY = 0),
          s.panOnMouseMove &&
            ((c = { x: 0, y: 0 }),
            o && ((o = !1), (v.startX = 0), (v.startY = 0))));
      }
      function O(t) {
        const s = e.zoom;
        s.scale && 1 !== s.scale ? k() : $(t);
      }
      function D() {
        return {
          passiveListener: !!e.params.passiveListeners && {
            passive: !0,
            capture: !1,
          },
          activeListenerWithCapture: !e.params.passiveListeners || {
            passive: !1,
            capture: !0,
          },
        };
      }
      function G() {
        const t = e.zoom;
        if (t.enabled) return;
        t.enabled = !0;
        const { passiveListener: s, activeListenerWithCapture: i } = D();
        (e.wrapperEl.addEventListener('pointerdown', M, s),
          e.wrapperEl.addEventListener('pointermove', C, i),
          ['pointerup', 'pointercancel', 'pointerout'].forEach(t => {
            e.wrapperEl.addEventListener(t, P, s);
          }),
          e.wrapperEl.addEventListener('pointermove', A, i));
      }
      function X() {
        const t = e.zoom;
        if (!t.enabled) return;
        t.enabled = !1;
        const { passiveListener: s, activeListenerWithCapture: i } = D();
        (e.wrapperEl.removeEventListener('pointerdown', M, s),
          e.wrapperEl.removeEventListener('pointermove', C, i),
          ['pointerup', 'pointercancel', 'pointerout'].forEach(t => {
            e.wrapperEl.removeEventListener(t, P, s);
          }),
          e.wrapperEl.removeEventListener('pointermove', A, i));
      }
      (Object.defineProperty(e.zoom, 'scale', {
        get: () => y,
        set(e) {
          if (y !== e) {
            const t = g.imageEl,
              s = g.slideEl;
            r('zoomChange', e, t, s);
          }
          y = e;
        },
      }),
        s('init', () => {
          a().enabled && G();
        }),
        s('destroy', () => {
          X();
        }),
        s('touchStart', (t, s) => {
          e.zoom.enabled &&
            (function (t) {
              const s = e.device;
              if (!g.imageEl) return;
              if (v.isTouched) return;
              (s.android && t.cancelable && t.preventDefault(),
                (v.isTouched = !0));
              const i = h.length > 0 ? h[0] : t;
              ((v.touchesStart.x = i.pageX), (v.touchesStart.y = i.pageY));
            })(s);
        }),
        s('touchEnd', () => {
          e.zoom.enabled &&
            (function () {
              const t = e.zoom;
              if (((h.length = 0), !g.imageEl)) return;
              if (!v.isTouched || !v.isMoved)
                return ((v.isTouched = !1), void (v.isMoved = !1));
              ((v.isTouched = !1), (v.isMoved = !1));
              let s = 300,
                i = 300;
              const r = w.x ?? 0,
                a = w.y ?? 0,
                n = r * s,
                l = v.currentX + n,
                o = a * i,
                d = v.currentY + o;
              (0 !== r && (s = Math.abs((l - v.currentX) / r)),
                0 !== a && (i = Math.abs((d - v.currentY) / a)));
              const c = Math.max(s, i);
              ((v.currentX = l), (v.currentY = d));
              const p = v.width * t.scale,
                u = v.height * t.scale;
              ((v.minX = Math.min(g.slideWidth / 2 - p / 2, 0)),
                (v.maxX = -v.minX),
                (v.minY = Math.min(g.slideHeight / 2 - u / 2, 0)),
                (v.maxY = -v.minY),
                (v.currentX = Math.max(Math.min(v.currentX, v.maxX), v.minX)),
                (v.currentY = Math.max(Math.min(v.currentY, v.maxY), v.minY)),
                (g.imageWrapEl.style.transitionDuration = `${c}ms`),
                (g.imageWrapEl.style.transform = `translate3d(${v.currentX}px, ${v.currentY}px,0)`));
            })();
        }),
        s('doubleTap', (t, s) => {
          !e.animating && a().enabled && e.zoom.enabled && a().toggle && O(s);
        }),
        s('transitionEnd', () => {
          e.zoom.enabled && a().enabled && I();
        }),
        s('slideChange', () => {
          e.zoom.enabled && a().enabled && e.params.cssMode && I();
        }),
        Object.assign(e.zoom, {
          enable: G,
          disable: X,
          in: $,
          out: k,
          toggle: O,
        }));
    },
    ({ swiper: e, extendParams: s, on: i }) => {
      function r() {
        return e.params.controller;
      }
      function a() {
        e.controller.control &&
          e.controller.spline &&
          ((e.controller.spline = void 0), delete e.controller.spline);
      }
      (s({ controller: { control: void 0, inverse: !1, by: 'slide' } }),
        (e.controller = { control: void 0 }),
        i('beforeInit', () => {
          const t = r().control;
          if (
            'undefined' != typeof window &&
            ('string' == typeof t || t instanceof HTMLElement)
          ) {
            return void (
              'string' == typeof t ? [...document.querySelectorAll(t)] : [t]
            ).forEach(t => {
              e.controller.control || (e.controller.control = []);
              const s = e.controller.control;
              if (t && t.swiper) s.push(t.swiper);
              else if (t) {
                const i = `${e.params.eventsPrefix}init`,
                  r = a => {
                    const n = a.detail;
                    (n && n[0] && s.push(n[0]),
                      e.update(),
                      t.removeEventListener(i, r));
                  };
                t.addEventListener(i, r);
              }
            });
          }
          e.controller.control = t;
        }),
        i('update', () => {
          a();
        }),
        i('resize', () => {
          a();
        }),
        i('observerUpdate', () => {
          a();
        }),
        i('setTranslate', (t, s, i) => {
          e.controller.control &&
            ((!Array.isArray(e.controller.control) &&
              e.controller.control.destroyed) ||
              e.controller.setTranslate(s, i));
        }),
        i('setTransition', (t, s, i) => {
          e.controller.control &&
            ((!Array.isArray(e.controller.control) &&
              e.controller.control.destroyed) ||
              e.controller.setTransition(s, i));
        }),
        Object.assign(e.controller, {
          setTranslate: function (t, s) {
            const i = e.controller.control;
            let a, n;
            const l = e.constructor;
            function o(t) {
              if (t.destroyed) return;
              const s = e.rtlTranslate ? -e.translate : e.translate,
                i = r();
              ('slide' === i.by
                ? (!(function (t) {
                    e.controller.spline = e.params.loop
                      ? new de(e.slidesGrid, t.slidesGrid)
                      : new de(e.snapGrid, t.snapGrid);
                  })(t),
                  (n = -e.controller.spline.interpolate(-s)))
                : (n = 0),
                (n && 'container' !== i.by) ||
                  ((a =
                    (t.maxTranslate() - t.minTranslate()) /
                    (e.maxTranslate() - e.minTranslate())),
                  (!Number.isNaN(a) && Number.isFinite(a)) || (a = 1),
                  (n = (s - e.minTranslate()) * a + t.minTranslate())),
                i.inverse && (n = t.maxTranslate() - n),
                t.updateProgress(n),
                t.setTranslate(n, e),
                t.updateActiveIndex(),
                t.updateSlidesClasses());
            }
            if (Array.isArray(i))
              for (let e = 0; e < i.length; e += 1) {
                const t = i[e];
                t && t !== s && t instanceof l && o(t);
              }
            else i instanceof l && s !== i && o(i);
          },
          setTransition: function (s, i) {
            const r = e.constructor,
              a = e.controller.control;
            function n(i) {
              i.destroyed ||
                (i.setTransition(s, e),
                0 !== s &&
                  (i.transitionStart(),
                  i.params.autoHeight &&
                    t(() => {
                      i.updateAutoHeight();
                    }),
                  g(i.wrapperEl, () => {
                    a && i.transitionEnd();
                  })));
            }
            if (Array.isArray(a))
              for (let e = 0; e < a.length; e += 1) {
                const t = a[e];
                t && t !== i && t instanceof r && n(t);
              }
            else a instanceof r && i !== a && n(a);
          },
        }));
    },
    ({ swiper: e, extendParams: t, on: s }) => {
      (t({
        a11y: {
          enabled: !0,
          notificationClass: 'swiper-notification',
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide',
          paginationBulletMessage: 'Go to slide {{index}}',
          slideLabelMessage: '{{index}} / {{slidesLength}}',
          containerMessage: null,
          containerRoleDescriptionMessage: null,
          containerRole: null,
          itemRoleDescriptionMessage: null,
          slideRole: 'group',
          id: null,
          scrollOnFocus: !0,
          wrapperLiveRegion: !0,
        },
      }),
        (e.a11y = { clicked: !1 }));
      let i,
        r = null,
        a = !1,
        n = new Date().getTime();
      function l() {
        return e.params.a11y;
      }
      function o(e) {
        r && e && y(r, e);
      }
      function d(e) {
        w(e).forEach(e => {
          e.setAttribute('tabIndex', '0');
        });
      }
      function c(e) {
        w(e).forEach(e => {
          e.setAttribute('tabIndex', '-1');
        });
      }
      function u(e, t) {
        w(e).forEach(e => {
          e.setAttribute('role', t);
        });
      }
      function m(e, t) {
        w(e).forEach(e => {
          e.setAttribute('aria-roledescription', t);
        });
      }
      function f(e, t) {
        w(e).forEach(e => {
          e.setAttribute('aria-label', t);
        });
      }
      function g(e) {
        w(e).forEach(e => {
          e.setAttribute('aria-disabled', 'true');
        });
      }
      function v(e) {
        w(e).forEach(e => {
          e.removeAttribute('aria-disabled');
        });
      }
      function b(t) {
        if (13 !== t.keyCode && 32 !== t.keyCode) return;
        const s = l(),
          i = e.params.pagination,
          r = t.target;
        if (
          !e.pagination ||
          !e.pagination.el ||
          (r !== e.pagination.el && !e.pagination.el.contains(r)) ||
          r.matches(le(i?.bulletClass))
        ) {
          if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
            const t = w(e.navigation.prevEl);
            (w(e.navigation.nextEl).includes(r) &&
              ((e.isEnd && !e.params.loop) || e.slideNext(),
              e.isEnd ? o(s.lastSlideMessage) : o(s.nextSlideMessage)),
              t.includes(r) &&
                ((e.isBeginning && !e.params.loop) || e.slidePrev(),
                e.isBeginning
                  ? o(s.firstSlideMessage)
                  : o(s.prevSlideMessage)));
          }
          e.pagination && r.matches(le(i?.bulletClass)) && r.click();
        }
      }
      function E() {
        return !!(
          e.pagination &&
          e.pagination.bullets &&
          e.pagination.bullets.length
        );
      }
      function S() {
        const t = e.params.pagination;
        return E() && !!t?.clickable;
      }
      const x = (e, t, s) => {
          (d(e),
            'BUTTON' !== e.tagName &&
              (u(e, 'button'), e.addEventListener('keydown', b)),
            f(e, s));
        },
        T = t => {
          (i && i !== t.target && !i.contains(t.target) && (a = !0),
            (e.a11y.clicked = !0));
        },
        M = () => {
          ((a = !1),
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                e.destroyed || (e.a11y.clicked = !1);
              });
            }));
        },
        C = e => {
          n = new Date().getTime();
        },
        P = t => {
          const s = l();
          if (e.a11y.clicked || !s.scrollOnFocus) return;
          if (new Date().getTime() - n < 100) return;
          const r = t.target.closest(`.${e.params.slideClass}, swiper-slide`);
          if (!r || !e.slides.includes(r)) return;
          i = r;
          const o = (e => !!e.virtual && !!e.params.virtual?.enabled)(e),
            d =
              (o
                ? parseInt(r.getAttribute('data-swiper-slide-index') || '0', 10)
                : e.slides.indexOf(r)) === e.activeIndex,
            c =
              e.params.watchSlidesProgress &&
              e.visibleSlides &&
              e.visibleSlides.includes(r);
          if (d || c) return;
          const p = t.sourceCapabilities;
          (p && p.firesTouchEvents) ||
            (e.isHorizontal() ? (e.el.scrollLeft = 0) : (e.el.scrollTop = 0),
            requestAnimationFrame(() => {
              a ||
                (e.params.loop
                  ? e.slideToLoop(
                      e.getSlideIndexWhenGrid(
                        parseInt(
                          r.getAttribute('data-swiper-slide-index') || '0',
                          10
                        )
                      ),
                      0
                    )
                  : o
                    ? e.slideTo(
                        e.getSlideIndexWhenGrid(
                          parseInt(
                            r.getAttribute('data-swiper-slide-index') || '0',
                            10
                          )
                        ),
                        0
                      )
                    : e.slideTo(
                        e.getSlideIndexWhenGrid(e.slides.indexOf(r)),
                        0
                      ),
                (a = !1));
            }));
        },
        L = () => {
          const t = l();
          (t.itemRoleDescriptionMessage &&
            m(e.slides, t.itemRoleDescriptionMessage),
            t.slideRole && u(e.slides, t.slideRole));
          const s = e.slides.length,
            i = t.slideLabelMessage;
          i &&
            e.slides.forEach((t, r) => {
              const a = e.params.loop
                ? parseInt(t.getAttribute('data-swiper-slide-index') || '0', 10)
                : r;
              f(
                t,
                i
                  .replace(/\{\{index\}\}/, String(a + 1))
                  .replace(/\{\{slidesLength\}\}/, String(s))
              );
            });
        },
        A = () => {
          const t = l();
          r && e.el.append(r);
          const s = e.el;
          (t.containerRoleDescriptionMessage &&
            m(s, t.containerRoleDescriptionMessage),
            t.containerMessage && f(s, t.containerMessage),
            t.containerRole && u(s, t.containerRole));
          const i = e.wrapperEl,
            a = String(
              t.id ||
                i.getAttribute('id') ||
                `swiper-wrapper-${(function (e = 16) {
                  return 'x'
                    .repeat(e)
                    .replace(/x/g, () =>
                      Math.round(16 * Math.random()).toString(16)
                    );
                })(16)}`
            );
          var n;
          if (
            ((n = a),
            w(i).forEach(e => {
              e.setAttribute('id', n);
            }),
            t.wrapperLiveRegion)
          ) {
            const t = e.params.autoplay;
            !(function (e, t) {
              w(e).forEach(e => {
                e.setAttribute('aria-live', t);
              });
            })(i, e.params.autoplay && t?.enabled ? 'off' : 'polite');
          }
          L();
          const o = e.navigation
              ? e.navigation
              : { nextEl: void 0, prevEl: void 0 },
            d = w(o.nextEl),
            c = w(o.prevEl);
          if (
            (d && d.forEach(e => x(e, 0, t.nextSlideMessage)),
            c && c.forEach(e => x(e, 0, t.prevSlideMessage)),
            S())
          ) {
            w(e.pagination.el).forEach(e => {
              e.addEventListener('keydown', b);
            });
          }
          (document.addEventListener('visibilitychange', C),
            e.el.addEventListener('focus', P, !0),
            e.el.addEventListener('pointerdown', T, !0),
            e.el.addEventListener('pointerup', M, !0));
        };
      (s('beforeInit', () => {
        ((r = p('span', l().notificationClass)),
          r.setAttribute('aria-live', 'assertive'),
          r.setAttribute('aria-atomic', 'true'));
      }),
        s('afterInit', () => {
          l().enabled && A();
        }),
        s(
          'slidesLengthChange snapGridLengthChange slidesGridLengthChange',
          () => {
            l().enabled && L();
          }
        ),
        s('fromEdge toEdge afterInit lock unlock', () => {
          l().enabled &&
            (function () {
              if (e.params.loop || e.params.rewind || !e.navigation) return;
              const { nextEl: t, prevEl: s } = e.navigation;
              (s && (e.isBeginning ? (g(s), c(s)) : (v(s), d(s))),
                t && (e.isEnd ? (g(t), c(t)) : (v(t), d(t))));
            })();
        }),
        s('paginationUpdate', () => {
          l().enabled &&
            (function () {
              const t = l();
              if (!E()) return;
              const s = e.params.pagination;
              e.pagination.bullets.forEach(e => {
                (s.clickable &&
                  (d(e),
                  s.renderBullet ||
                    (u(e, 'button'),
                    f(
                      e,
                      t.paginationBulletMessage.replace(
                        /\{\{index\}\}/,
                        String((h(e) ?? 0) + 1)
                      )
                    ))),
                  e.matches(le(s.bulletActiveClass))
                    ? e.setAttribute('aria-current', 'true')
                    : e.removeAttribute('aria-current'));
              });
            })();
        }),
        s('destroy', () => {
          l().enabled &&
            (function () {
              r && r.remove();
              const t = e.navigation
                  ? e.navigation
                  : { nextEl: void 0, prevEl: void 0 },
                s = w(t.nextEl),
                i = w(t.prevEl);
              (s && s.forEach(e => e.removeEventListener('keydown', b)),
                i && i.forEach(e => e.removeEventListener('keydown', b)),
                S() &&
                  w(e.pagination.el).forEach(e => {
                    e.removeEventListener('keydown', b);
                  }));
              (document.removeEventListener('visibilitychange', C),
                e.el &&
                  'string' != typeof e.el &&
                  (e.el.removeEventListener('focus', P, !0),
                  e.el.removeEventListener('pointerdown', T, !0),
                  e.el.removeEventListener('pointerup', M, !0)));
            })();
        }));
    },
    ({ swiper: e, extendParams: t, on: s }) => {
      t({
        history: {
          enabled: !1,
          root: '',
          replaceState: !1,
          key: 'slides',
          keepQuery: !1,
        },
      });
      let i = !1,
        r = { key: void 0, value: void 0 };
      function a() {
        return e.params.history;
      }
      const n = e =>
          e
            .toString()
            .replace(/\s+/g, '-')
            .replace(/[^\w-]+/g, '')
            .replace(/--+/g, '-')
            .replace(/^-+/, '')
            .replace(/-+$/, ''),
        l = e => {
          let t;
          t = e ? new URL(e) : window.location;
          const s = t.pathname
              .slice(1)
              .split('/')
              .filter(e => '' !== e),
            i = s.length;
          return { key: s[i - 2], value: s[i - 1] };
        },
        o = (t, s) => {
          const r = a();
          if (!i || !r.enabled) return;
          let l;
          l = e.params.url ? new URL(e.params.url) : window.location;
          const o = !!e.params.virtual?.enabled,
            d =
              e.virtual && o
                ? e.slidesEl.querySelector(`[data-swiper-slide-index="${s}"]`)
                : e.slides[s];
          if (!d) return;
          let c = n(d.getAttribute('data-history') || '');
          const p = r.root;
          if (p.length > 0) {
            c = `${'/' === p[p.length - 1] ? p.slice(0, p.length - 1) : p}/${t ? `${t}/` : ''}${c}`;
          } else
            l.pathname.includes(t || '') || (c = `${t ? `${t}/` : ''}${c}`);
          r.keepQuery && (c += l.search);
          const u = window.history.state;
          (u && u.value === c) ||
            (r.replaceState
              ? window.history.replaceState({ value: c }, '', c)
              : window.history.pushState({ value: c }, '', c));
        },
        d = (t, s, i) => {
          if (s)
            for (let r = 0, a = e.slides.length; r < a; r += 1) {
              const a = e.slides[r];
              if (n(a.getAttribute('data-history') || '') === s) {
                const s = e.getSlideIndex(a);
                e.slideTo(s, t, i);
              }
            }
          else e.slideTo(0, t, i);
        },
        c = () => {
          ((r = l(e.params.url)), d(e.params.speed, r.value, !1));
        };
      (s('init', () => {
        a().enabled &&
          (() => {
            const t = e.params.history;
            if (t) {
              if (!window.history || !window.history.pushState) {
                t.enabled = !1;
                const s = e.params.hashNavigation;
                return void (s && (s.enabled = !0));
              }
              ((i = !0),
                (r = l(e.params.url)),
                r.key || r.value
                  ? (d(0, r.value, e.params.runCallbacksOnInit),
                    t.replaceState || window.addEventListener('popstate', c))
                  : t.replaceState || window.addEventListener('popstate', c));
            }
          })();
      }),
        s('destroy', () => {
          a().enabled &&
            (a().replaceState || window.removeEventListener('popstate', c));
        }),
        s('transitionEnd _freeModeNoMomentumRelease', () => {
          i && o(a().key, e.activeIndex);
        }),
        s('slideChange', () => {
          i && e.params.cssMode && o(a().key, e.activeIndex);
        }));
    },
    ({ swiper: e, extendParams: t, emit: s, on: i }) => {
      let r = !1;
      function a() {
        return e.params.hashNavigation;
      }
      t({
        hashNavigation: {
          enabled: !1,
          replaceState: !1,
          watchState: !1,
          getSlideIndex(t, s) {
            if (ce(e)) {
              const t = e.slides.find(e => e.getAttribute('data-hash') === s);
              if (!t) return 0;
              return parseInt(
                t.getAttribute('data-swiper-slide-index') || '0',
                10
              );
            }
            const i = d(
              e.slidesEl,
              `.${e.params.slideClass}[data-hash="${s}"], swiper-slide[data-hash="${s}"]`
            )[0];
            return i ? e.getSlideIndex(i) : 0;
          },
        },
      });
      const n = () => {
          s('hashChange');
          const t = document.location.hash.replace('#', ''),
            i = ce(e)
              ? e.slidesEl.querySelector(
                  `[data-swiper-slide-index="${e.activeIndex}"]`
                )
              : e.slides[e.activeIndex];
          if (t !== (i ? i.getAttribute('data-hash') : '')) {
            const s = a().getSlideIndex(e, t);
            if (void 0 === s || Number.isNaN(s)) return;
            e.slideTo(s);
          }
        },
        l = () => {
          const t = a();
          if (!r || !t.enabled) return;
          const i = ce(e)
              ? e.slidesEl.querySelector(
                  `[data-swiper-slide-index="${e.activeIndex}"]`
                )
              : e.slides[e.activeIndex],
            n = i
              ? i.getAttribute('data-hash') || i.getAttribute('data-history')
              : '';
          t.replaceState && window.history && window.history.replaceState
            ? (window.history.replaceState(null, '', `#${n}` || ''),
              s('hashSet'))
            : ((document.location.hash = n || ''), s('hashSet'));
        };
      (i('init', () => {
        a().enabled &&
          (() => {
            const t = a(),
              s = e.params.history;
            if (!t.enabled || (s && s.enabled)) return;
            r = !0;
            const i = document.location.hash.replace('#', '');
            if (i) {
              const s = 0,
                r = t.getSlideIndex(e, i);
              e.slideTo(r || 0, s, e.params.runCallbacksOnInit, !0);
            }
            t.watchState && window.addEventListener('hashchange', n);
          })();
      }),
        i('destroy', () => {
          a().enabled &&
            a().watchState &&
            window.removeEventListener('hashchange', n);
        }),
        i('transitionEnd _freeModeNoMomentumRelease', () => {
          r && l();
        }),
        i('slideChange', () => {
          r && e.params.cssMode && l();
        }));
    },
    ({ swiper: e, extendParams: t, on: s, emit: i, params: r }) => {
      function a() {
        return e.params.autoplay;
      }
      ((e.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
        t({
          autoplay: {
            enabled: !1,
            delay: 3e3,
            waitForTransition: !0,
            disableOnInteraction: !1,
            stopOnLastSlide: !1,
            reverseDirection: !1,
            pauseOnMouseEnter: !1,
          },
        }));
      const n =
        'object' == typeof r.autoplay &&
        r.autoplay &&
        'number' == typeof r.autoplay.delay
          ? r.autoplay.delay
          : 3e3;
      let l,
        o,
        d,
        c = n,
        p = n,
        u = 0,
        m = new Date().getTime(),
        h = !1,
        f = !1,
        g = !1,
        v = !1,
        w = !1;
      function b(t) {
        if (!e || e.destroyed || !e.wrapperEl) return;
        if (t.target !== e.wrapperEl) return;
        e.wrapperEl.removeEventListener('transitionend', b);
        const s = t.detail;
        w || (s && s.bySwiperTouchMove) || C();
      }
      const y = () => {
          if (e.destroyed || !e.autoplay.running) return;
          e.autoplay.paused ? (h = !0) : h && ((p = u), (h = !1));
          const t = e.autoplay.paused ? u : m + p - new Date().getTime();
          ((e.autoplay.timeLeft = t),
            i('autoplayTimeLeft', t, t / c),
            (o = requestAnimationFrame(() => {
              y();
            })));
        },
        E = () => {
          let t = a().delay;
          const s = (() => {
            let t;
            const s = !!e.params.virtual?.enabled;
            if (
              ((t =
                e.virtual && s
                  ? e.slides.find(e =>
                      e.classList.contains('swiper-slide-active')
                    )
                  : e.slides[e.activeIndex]),
              !t)
            )
              return;
            const i = t.getAttribute('data-swiper-autoplay');
            return null != i ? parseInt(i, 10) : void 0;
          })();
          return (
            'number' == typeof s && !Number.isNaN(s) && s > 0 && (t = s),
            t
          );
        },
        S = t => {
          if (e.destroyed || !e.autoplay.running) return 0;
          (void 0 !== o && cancelAnimationFrame(o), y());
          let s = t;
          (void 0 === s && ((s = E()), (c = s), (p = s)), (u = s));
          const r = e.params.speed,
            n = () => {
              if (!e || e.destroyed) return;
              const t = a();
              (t.reverseDirection
                ? !e.isBeginning || e.params.loop || e.params.rewind
                  ? (e.slidePrev(r, !0, !0), i('autoplay'))
                  : t.stopOnLastSlide ||
                    (e.slideTo(e.slides.length - 1, r, !0, !0), i('autoplay'))
                : !e.isEnd || e.params.loop || e.params.rewind
                  ? (e.slideNext(r, !0, !0), i('autoplay'))
                  : t.stopOnLastSlide ||
                    (e.slideTo(0, r, !0, !0), i('autoplay')),
                e.params.cssMode &&
                  ((m = new Date().getTime()),
                  requestAnimationFrame(() => {
                    S();
                  })));
            };
          return (
            s > 0
              ? (void 0 !== l && clearTimeout(l),
                (l = setTimeout(() => {
                  n();
                }, s)))
              : requestAnimationFrame(() => {
                  n();
                }),
            s
          );
        },
        x = () => (
          (m = new Date().getTime()),
          (e.autoplay.running = !0),
          S(),
          i('autoplayStart'),
          !0
        ),
        T = () => (
          (e.autoplay.running = !1),
          void 0 !== l && clearTimeout(l),
          void 0 !== o && cancelAnimationFrame(o),
          i('autoplayStop'),
          !0
        ),
        M = (t, s) => {
          if (e.destroyed || !e.autoplay.running) return;
          (void 0 !== l && clearTimeout(l), t || (v = !0));
          const r = () => {
            (i('autoplayPause'),
              a().waitForTransition
                ? e.wrapperEl.addEventListener('transitionend', b)
                : C());
          };
          if (((e.autoplay.paused = !0), s)) return void r();
          const n = u || a().delay;
          ((u = n - (new Date().getTime() - m)),
            (e.isEnd && u < 0 && !e.params.loop) || (u < 0 && (u = 0), r()));
        },
        C = () => {
          (e.isEnd && u < 0 && !e.params.loop) ||
            e.destroyed ||
            !e.autoplay.running ||
            ((m = new Date().getTime()),
            v ? ((v = !1), S(u)) : S(),
            (e.autoplay.paused = !1),
            i('autoplayResume'));
        },
        P = () => {
          !e.destroyed &&
            e.autoplay.running &&
            ('hidden' === document.visibilityState && ((v = !0), M(!0)),
            'visible' === document.visibilityState && C());
        },
        L = t => {
          'mouse' === t.pointerType &&
            ((v = !0), (w = !0), e.animating || e.autoplay.paused || M(!0));
        },
        A = t => {
          'mouse' === t.pointerType && ((w = !1), e.autoplay.paused && C());
        };
      (s('init', () => {
        a().enabled &&
          (a().pauseOnMouseEnter &&
            (e.el.addEventListener('pointerenter', L),
            e.el.addEventListener('pointerleave', A)),
          document.addEventListener('visibilitychange', P),
          x());
      }),
        s('destroy', () => {
          (e.el &&
            'string' != typeof e.el &&
            (e.el.removeEventListener('pointerenter', L),
            e.el.removeEventListener('pointerleave', A)),
            document.removeEventListener('visibilitychange', P),
            e.autoplay.running && T());
        }),
        s('_freeModeStaticRelease', () => {
          (g || v) && C();
        }),
        s('_freeModeNoMomentumRelease', () => {
          a().disableOnInteraction ? T() : M(!0, !0);
        }),
        s('beforeTransitionStart', (t, s, i) => {
          !e.destroyed &&
            e.autoplay.running &&
            (i || !a().disableOnInteraction ? M(!0, !0) : T());
        }),
        s('sliderFirstMove', () => {
          !e.destroyed &&
            e.autoplay.running &&
            (a().disableOnInteraction
              ? T()
              : ((f = !0),
                (g = !1),
                (v = !1),
                (d = setTimeout(() => {
                  ((v = !0), (g = !0), M(!0));
                }, 200))));
        }),
        s('touchEnd', () => {
          if (!e.destroyed && e.autoplay.running && f) {
            if (
              (void 0 !== d && clearTimeout(d),
              void 0 !== l && clearTimeout(l),
              a().disableOnInteraction)
            )
              return ((g = !1), void (f = !1));
            (g && e.params.cssMode && C(), (g = !1), (f = !1));
          }
        }),
        s('slideChange', () => {
          !e.destroyed &&
            e.autoplay.running &&
            e.autoplay.paused &&
            ((u = E()), (c = E()));
        }),
        Object.assign(e.autoplay, { start: x, stop: T, pause: M, resume: C }));
    },
    ({ swiper: e, extendParams: t, on: s }) => {
      t({
        thumbs: {
          swiper: null,
          multipleActiveThumbs: !0,
          autoScrollOffset: 0,
          slideThumbActiveClass: 'swiper-slide-thumb-active',
          thumbsContainerClass: 'swiper-thumbs',
        },
      });
      let i = !1,
        a = !1;
      function n() {
        return e.params.thumbs;
      }
      function l() {
        const t = e.thumbs.swiper;
        if (!t || t.destroyed) return !1;
        const s = t.params.virtual;
        return !!s && !!s.enabled;
      }
      function o() {
        const t = e.thumbs.swiper;
        if (!t || t.destroyed) return;
        const s = t.clickedIndex,
          i = t.clickedSlide,
          r = n();
        if (i && i.classList.contains(r.slideThumbActiveClass)) return;
        if (null == s) return;
        let a;
        if (t.params.loop) {
          const e = t.clickedSlide?.getAttribute('data-swiper-slide-index');
          a = null == e ? s : parseInt(e, 10);
        } else a = s;
        e.params.loop ? e.slideToLoop(a) : e.slideTo(a);
      }
      function c() {
        const t = n();
        if (i) return !1;
        i = !0;
        const s = e.constructor;
        if (t.swiper instanceof s) {
          if (t.swiper.destroyed) return ((i = !1), !1);
          const s = t.swiper;
          ((e.thumbs.swiper = s),
            Object.assign(s.originalParams, {
              watchSlidesProgress: !0,
              slideToClickedSlide: !1,
            }),
            Object.assign(s.params, {
              watchSlidesProgress: !0,
              slideToClickedSlide: !1,
            }),
            s.update());
        } else if (r(t.swiper)) {
          const i = Object.assign({}, t.swiper);
          (Object.assign(i, {
            watchSlidesProgress: !0,
            slideToClickedSlide: !1,
          }),
            (e.thumbs.swiper = new s(i)),
            (a = !0));
        }
        const d = e.thumbs.swiper;
        return (
          !!d &&
          (d.el.classList.add(t.thumbsContainerClass),
          d.on('tap', o),
          l() &&
            d.on('virtualUpdate', () => {
              p(!1, { autoScroll: !1 });
            }),
          !0)
        );
      }
      function p(t, s) {
        const i = e.thumbs.swiper;
        if (!i || i.destroyed) return;
        let r = 1;
        const a = n(),
          o = a.slideThumbActiveClass,
          c = e.params.slidesPerView;
        if (
          ('number' == typeof c && c > 1 && !e.params.centeredSlides && (r = c),
          a.multipleActiveThumbs || (r = 1),
          (r = Math.floor(r)),
          i.slides.forEach(e => e.classList.remove(o)),
          i.params.loop || l())
        )
          for (let t = 0; t < r; t += 1)
            d(
              i.slidesEl,
              `[data-swiper-slide-index="${e.realIndex + t}"]`
            ).forEach(e => {
              e.classList.add(o);
            });
        else
          for (let t = 0; t < r; t += 1) {
            const s = i.slides[e.realIndex + t];
            s && s.classList.add(o);
          }
        (s?.autoScroll ?? 1) &&
          (function (t) {
            const s = e.thumbs.swiper;
            if (!s || s.destroyed) return;
            const i = s.params.slidesPerView,
              r = 'auto' === i ? s.slidesPerViewDynamic() : (i ?? 1),
              a = n().autoScrollOffset,
              l = a && !s.params.loop;
            if (e.realIndex !== s.realIndex || l) {
              const i = s.activeIndex;
              let n, o;
              if (s.params.loop) {
                const t = s.slides.find(
                  t =>
                    t.getAttribute('data-swiper-slide-index') ===
                    `${e.realIndex}`
                );
                ((n = t ? s.slides.indexOf(t) : -1),
                  (o = e.activeIndex > e.previousIndex ? 'next' : 'prev'));
              } else
                ((n = e.realIndex),
                  (o = n > e.previousIndex ? 'next' : 'prev'));
              (l && (n += 'next' === o ? a : -1 * a),
                s.visibleSlidesIndexes &&
                  s.visibleSlidesIndexes.indexOf(n) < 0 &&
                  (s.params.centeredSlides
                    ? (n =
                        n > i
                          ? n - Math.floor(r / 2) + 1
                          : n + Math.floor(r / 2) - 1)
                    : n > i && s.params.slidesPerGroup,
                  s.slideTo(n, t)));
            }
          })(t ? 0 : void 0);
      }
      ((e.thumbs = { swiper: null }),
        s('beforeInit', () => {
          const t = e.params.thumbs;
          if (t && t.swiper)
            if (
              'string' == typeof t.swiper ||
              t.swiper instanceof HTMLElement
            ) {
              const s = () => {
                  const s =
                    'string' == typeof t.swiper
                      ? document.querySelector(t.swiper)
                      : t.swiper;
                  if (s && s.swiper) ((t.swiper = s.swiper), c(), p(!0));
                  else if (s) {
                    const i = `${e.params.eventsPrefix}init`,
                      r = a => {
                        const n = a.detail;
                        ((t.swiper = n[0]),
                          s.removeEventListener(i, r),
                          c(),
                          p(!0),
                          t.swiper.update(),
                          e.update());
                      };
                    s.addEventListener(i, r);
                  }
                  return s;
                },
                i = () => {
                  if (e.destroyed) return;
                  s() || requestAnimationFrame(i);
                };
              requestAnimationFrame(i);
            } else (c(), p(!0));
        }),
        s('slideChange update resize observerUpdate', () => {
          p();
        }),
        s('setTransition', (t, s) => {
          const i = e.thumbs.swiper;
          i && !i.destroyed && i.setTransition(s);
        }),
        s('beforeDestroy', () => {
          const t = e.thumbs.swiper;
          t && !t.destroyed && a && t.destroy();
        }),
        Object.assign(e.thumbs, { init: c, update: p }));
    },
    ({ swiper: e, extendParams: t, emit: i, once: r }) => {
      (t({
        freeMode: {
          enabled: !1,
          momentum: !0,
          momentumRatio: 1,
          momentumBounce: !0,
          momentumBounceRatio: 1,
          momentumVelocityRatio: 1,
          sticky: !1,
          minimumVelocity: 0.02,
        },
      }),
        (e.freeMode = {
          onTouchStart: function () {
            if (e.params.cssMode) return;
            const t = e.getTranslate();
            (e.setTranslate(t),
              e.setTransition(0),
              (e.touchEventsData.velocities.length = 0),
              e.freeMode.onTouchEnd({
                currentPos: e.rtl ? e.translate : -e.translate,
              }));
          },
          onTouchMove: function () {
            if (e.params.cssMode) return;
            const { touchEventsData: t, touches: i } = e;
            (0 === t.velocities.length &&
              t.velocities.push({
                position: i[e.isHorizontal() ? 'startX' : 'startY'],
                time: t.touchStartTime ?? s(),
              }),
              t.velocities.push({
                position: i[e.isHorizontal() ? 'currentX' : 'currentY'],
                time: s(),
              }));
          },
          onTouchEnd: function ({ currentPos: t }) {
            if (e.params.cssMode) return;
            const {
                wrapperEl: a,
                rtlTranslate: n,
                snapGrid: l,
                touchEventsData: o,
              } = e,
              d = e.params,
              c = e.params.freeMode,
              p = s(),
              u = p - (o.touchStartTime ?? p);
            if (t < -e.minTranslate()) e.slideTo(e.activeIndex);
            else if (t > -e.maxTranslate())
              e.slides.length < l.length
                ? e.slideTo(l.length - 1)
                : e.slideTo(e.slides.length - 1);
            else {
              if (c.momentum) {
                if (o.velocities.length > 1) {
                  const t = o.velocities.pop(),
                    i = o.velocities.pop(),
                    r = t.position - i.position,
                    a = t.time - i.time;
                  ((e.velocity = r / a),
                    (e.velocity /= 2),
                    Math.abs(e.velocity) < c.minimumVelocity &&
                      (e.velocity = 0),
                    (a > 150 || s() - t.time > 300) && (e.velocity = 0));
                } else e.velocity = 0;
                ((e.velocity *= c.momentumVelocityRatio),
                  (o.velocities.length = 0));
                let t = 1e3 * c.momentumRatio;
                const p = e.velocity * t;
                let u = e.translate + p;
                n && (u = -u);
                let m,
                  h = !1;
                const f = 20 * Math.abs(e.velocity) * c.momentumBounceRatio;
                let v = !1;
                if (u < e.maxTranslate())
                  (c.momentumBounce
                    ? (u + e.maxTranslate() < -f && (u = e.maxTranslate() - f),
                      (m = e.maxTranslate()),
                      (h = !0),
                      (o.allowMomentumBounce = !0))
                    : (u = e.maxTranslate()),
                    d.loop && d.centeredSlides && (v = !0));
                else if (u > e.minTranslate())
                  (c.momentumBounce
                    ? (u - e.minTranslate() > f && (u = e.minTranslate() + f),
                      (m = e.minTranslate()),
                      (h = !0),
                      (o.allowMomentumBounce = !0))
                    : (u = e.minTranslate()),
                    d.loop && d.centeredSlides && (v = !0));
                else if (c.sticky) {
                  let t = 0;
                  for (let e = 0; e < l.length; e += 1)
                    if (l[e] > -u) {
                      t = e;
                      break;
                    }
                  ((u =
                    Math.abs(l[t] - u) < Math.abs((l[t - 1] ?? l[t]) - u) ||
                    'next' === e.swipeDirection
                      ? l[t]
                      : l[t - 1]),
                    (u = -u));
                }
                if (
                  (v &&
                    r('transitionEnd', () => {
                      e.loopFix();
                    }),
                  0 !== e.velocity)
                ) {
                  if (
                    ((t = n
                      ? Math.abs((-u - e.translate) / e.velocity)
                      : Math.abs((u - e.translate) / e.velocity)),
                    c.sticky)
                  ) {
                    const s = Math.abs((n ? -u : u) - e.translate),
                      i = e.slidesSizesGrid[e.activeIndex],
                      r = d.speed;
                    t = s < i ? r : s < 2 * i ? 1.5 * r : 2.5 * r;
                  }
                } else if (c.sticky) return void e.slideToClosest();
                (c.momentumBounce && h && void 0 !== m
                  ? (e.updateProgress(m),
                    e.setTransition(t),
                    e.setTranslate(u),
                    e.transitionStart(!0, e.swipeDirection),
                    (e.animating = !0),
                    g(a, () => {
                      e &&
                        !e.destroyed &&
                        o.allowMomentumBounce &&
                        (i('momentumBounce'),
                        e.setTransition(d.speed),
                        setTimeout(() => {
                          (e.setTranslate(m),
                            g(a, () => {
                              e && !e.destroyed && e.transitionEnd();
                            }));
                        }, 0));
                    }))
                  : e.velocity
                    ? (i('_freeModeNoMomentumRelease'),
                      e.updateProgress(u),
                      e.setTransition(t),
                      e.setTranslate(u),
                      e.transitionStart(!0, e.swipeDirection),
                      e.animating ||
                        ((e.animating = !0),
                        g(a, () => {
                          e && !e.destroyed && e.transitionEnd();
                        })))
                    : e.updateProgress(u),
                  e.updateActiveIndex(),
                  e.updateSlidesClasses());
              } else {
                if (c.sticky) return void e.slideToClosest();
                i('_freeModeNoMomentumRelease');
              }
              (!c.momentum || u >= d.longSwipesMs) &&
                (i('_freeModeStaticRelease'),
                e.updateProgress(),
                e.updateActiveIndex(),
                e.updateSlidesClasses());
            }
          },
        }));
    },
    ({ swiper: e, extendParams: t, on: s }) => {
      function i() {
        return e.params.grid;
      }
      let r, a, n, l;
      t({ grid: { rows: 1, fill: 'column' } });
      const o = () => {
          let t = e.params.spaceBetween ?? 0;
          return (
            'string' == typeof t && t.indexOf('%') >= 0
              ? (t = (parseFloat(t.replace('%', '')) / 100) * e.size)
              : 'string' == typeof t && (t = parseFloat(t)),
            t
          );
        },
        d = () => {
          const t = e.params.virtual;
          return (
            !!e.virtual && 'object' == typeof t && null !== t && !!t.enabled
          );
        };
      (s('init', () => {
        const t = e.params.grid;
        l = !!(t && (t.rows ?? 1) > 1);
      }),
        s('update', () => {
          const { params: t, el: s } = e,
            i = t.grid,
            r = !!(i && (i.rows ?? 1) > 1);
          (l && !r
            ? (s.classList.remove(
                `${t.containerModifierClass}grid`,
                `${t.containerModifierClass}grid-column`
              ),
              (n = 1),
              e.emitContainerClasses())
            : !l &&
              r &&
              (s.classList.add(`${t.containerModifierClass}grid`),
              'column' === i.fill &&
                s.classList.add(`${t.containerModifierClass}grid-column`),
              e.emitContainerClasses()),
            (l = r));
        }),
        (e.grid = {
          initSlides: t => {
            const { slidesPerView: s } = e.params,
              { rows: l, fill: o } = i(),
              c = d() ? e.virtual.slides.length : t.length;
            ((n = Math.floor(c / l)),
              (r = Math.floor(c / l) === c / l ? c : Math.ceil(c / l) * l),
              'auto' !== s &&
                'row' === o &&
                (r = Math.max(r, Math.floor(s ?? 1) * l)),
              (a = r / l));
          },
          unsetSlides: () => {
            e.slides &&
              e.slides.forEach(t => {
                t.swiperSlideGridSet &&
                  ((t.style.height = ''),
                  t.style.setProperty(e.getDirectionLabel('margin-top'), ''));
              });
          },
          updateSlide: (t, s, l) => {
            const { slidesPerGroup: c } = e.params,
              p = o(),
              { rows: u, fill: m } = i(),
              h = d() ? e.virtual.slides.length : l.length;
            let f, g, v;
            if ('row' === m && (c ?? 1) > 1) {
              const e = c ?? 1,
                i = Math.floor(t / (e * u)),
                a = t - u * e * i,
                n = 0 === i ? e : Math.min(Math.ceil((h - i * u * e) / u), e);
              ((v = Math.floor(a / n)),
                (g = a - v * n + i * e),
                (f = g + (v * r) / u),
                (s.style.order = String(f)));
            } else
              'column' === m
                ? ((g = Math.floor(t / u)),
                  (v = t - g * u),
                  (g > n || (g === n && v === u - 1)) &&
                    ((v += 1), v >= u && ((v = 0), (g += 1))))
                : ((v = Math.floor(t / a)), (g = t - v * a));
            const w = s;
            ((w.row = v),
              (w.column = g),
              (s.style.height = `calc((100% - ${(u - 1) * p}px) / ${u})`),
              s.style.setProperty(
                e.getDirectionLabel('margin-top'),
                0 !== v && p ? `${p}px` : ''
              ),
              (w.swiperSlideGridSet = !0));
          },
          updateWrapperSize: (t, s) => {
            const { centeredSlides: a, roundLengths: n } = e.params,
              l = o(),
              { rows: d } = i();
            if (
              ((e.virtualSize = (t + l) * r),
              (e.virtualSize = Math.ceil(e.virtualSize / d) - l),
              e.params.cssMode ||
                e.wrapperEl.style.setProperty(
                  e.getDirectionLabel('width'),
                  `${e.virtualSize + l}px`
                ),
              a)
            ) {
              const t = [];
              for (let i = 0; i < s.length; i += 1) {
                let r = s[i];
                (n && (r = Math.floor(r)),
                  s[i] < e.virtualSize + s[0] && t.push(r));
              }
              (s.splice(0, s.length), s.push(...t));
            }
          },
        }));
    },
    ({ swiper: e }) => {
      Object.assign(e, {
        appendSlide: ue.bind(e),
        prependSlide: me.bind(e),
        addSlide: pe.bind(e),
        removeSlide: fe.bind(e),
        removeAllSlides: he.bind(e),
      });
    },
    ({ swiper: e, extendParams: t, on: s }) => {
      t({ fadeEffect: { crossFade: !1 } });
      ge({
        effect: 'fade',
        swiper: e,
        on: s,
        setTranslate: () => {
          const { slides: t } = e,
            s = e.params.fadeEffect;
          for (let i = 0; i < t.length; i += 1) {
            const r = t[i];
            let a = -(r.swiperSlideOffset ?? 0);
            e.params.virtualTranslate || (a -= e.translate);
            let n = 0;
            e.isHorizontal() || ((n = a), (a = 0));
            const l = r.progress ?? 0,
              o = s.crossFade
                ? Math.max(1 - Math.abs(l), 0)
                : 1 + Math.min(Math.max(l, -1), 0),
              d = ve(0, r);
            ((d.style.opacity = String(o)),
              (d.style.transform = `translate3d(${a}px, ${n}px, 0px)`));
          }
        },
        setTransition: t => {
          const s = e.slides.map(e => o(e));
          (s.forEach(e => {
            e.style.transitionDuration = `${t}ms`;
          }),
            we({
              swiper: e,
              duration: t,
              transformElements: s,
              allSlides: !0,
            }));
        },
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          spaceBetween: 0,
          virtualTranslate: !e.params.cssMode,
        }),
      });
    },
    ({ swiper: e, extendParams: t, on: s }) => {
      t({
        cubeEffect: {
          slideShadows: !0,
          shadow: !0,
          shadowOffset: 20,
          shadowScale: 0.94,
        },
      });
      const i = (e, t, s) => {
        let i = s
            ? e.querySelector('.swiper-slide-shadow-left')
            : e.querySelector('.swiper-slide-shadow-top'),
          r = s
            ? e.querySelector('.swiper-slide-shadow-right')
            : e.querySelector('.swiper-slide-shadow-bottom');
        (i ||
          ((i = p(
            'div',
            (
              'swiper-slide-shadow-cube swiper-slide-shadow-' +
              (s ? 'left' : 'top')
            ).split(' ')
          )),
          e.append(i)),
          r ||
            ((r = p(
              'div',
              (
                'swiper-slide-shadow-cube swiper-slide-shadow-' +
                (s ? 'right' : 'bottom')
              ).split(' ')
            )),
            e.append(r)),
          i && (i.style.opacity = String(Math.max(-t, 0))),
          r && (r.style.opacity = String(Math.max(t, 0))));
      };
      ge({
        effect: 'cube',
        swiper: e,
        on: s,
        setTranslate: () => {
          const {
              el: t,
              wrapperEl: s,
              slides: r,
              width: a,
              height: n,
              rtlTranslate: l,
              size: o,
            } = e,
            d = b(e),
            c = e.params.cubeEffect,
            u = e.isHorizontal(),
            m = !(!e.virtual || !e.params.virtual?.enabled);
          let h = 0,
            f = null;
          c.shadow &&
            (u
              ? ((f = e.wrapperEl.querySelector('.swiper-cube-shadow')),
                f ||
                  ((f = p('div', 'swiper-cube-shadow')), e.wrapperEl.append(f)),
                (f.style.height = `${a}px`))
              : ((f = t.querySelector('.swiper-cube-shadow')),
                f || ((f = p('div', 'swiper-cube-shadow')), t.append(f))));
          for (let e = 0; e < r.length; e += 1) {
            const t = r[e];
            let s = e;
            m &&
              (s = parseInt(
                t.getAttribute('data-swiper-slide-index') ?? '0',
                10
              ));
            let a = 90 * s,
              n = Math.floor(a / 360);
            l && ((a = -a), (n = Math.floor(-a / 360)));
            const p = Math.max(Math.min(t.progress ?? 0, 1), -1);
            let f = 0,
              g = 0,
              v = 0;
            (s % 4 == 0
              ? ((f = 4 * -n * o), (v = 0))
              : (s - 1) % 4 == 0
                ? ((f = 0), (v = 4 * -n * o))
                : (s - 2) % 4 == 0
                  ? ((f = o + 4 * n * o), (v = o))
                  : (s - 3) % 4 == 0 && ((f = -o), (v = 3 * o + 4 * o * n)),
              l && (f = -f),
              u || ((g = f), (f = 0)));
            const w = `rotateX(${d(u ? 0 : -a)}deg) rotateY(${d(u ? a : 0)}deg) translate3d(${f}px, ${g}px, ${v}px)`;
            (p <= 1 &&
              p > -1 &&
              ((h = 90 * s + 90 * p), l && (h = 90 * -s - 90 * p)),
              (t.style.transform = w),
              c.slideShadows && i(t, p, u));
          }
          if (
            ((s.style.transformOrigin = `50% 50% -${o / 2}px`),
            s.style.setProperty(
              '-webkit-transform-origin',
              `50% 50% -${o / 2}px`
            ),
            c.shadow && f)
          )
            if (u)
              f.style.transform = `translate3d(0px, ${a / 2 + c.shadowOffset}px, ${-a / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${c.shadowScale})`;
            else {
              const e = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90),
                t =
                  1.5 -
                  (Math.sin((2 * e * Math.PI) / 360) / 2 +
                    Math.cos((2 * e * Math.PI) / 360) / 2),
                s = c.shadowScale,
                i = c.shadowScale / t,
                r = c.shadowOffset;
              f.style.transform = `scale3d(${s}, 1, ${i}) translate3d(0px, ${n / 2 + r}px, ${-n / 2 / i}px) rotateX(-89.99deg)`;
            }
          ((s.style.transform = `translate3d(0px,0,0px) rotateX(${d(e.isHorizontal() ? 0 : h)}deg) rotateY(${d(e.isHorizontal() ? -h : 0)}deg)`),
            s.style.setProperty('--swiper-cube-translate-z', '0px'));
        },
        setTransition: t => {
          const { el: s, slides: i } = e;
          if (
            (i.forEach(e => {
              ((e.style.transitionDuration = `${t}ms`),
                e
                  .querySelectorAll(
                    '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                  )
                  .forEach(e => {
                    e.style.transitionDuration = `${t}ms`;
                  }));
            }),
            e.params.cubeEffect?.shadow && !e.isHorizontal())
          ) {
            const e = s.querySelector('.swiper-cube-shadow');
            e && (e.style.transitionDuration = `${t}ms`);
          }
        },
        recreateShadows: () => {
          const t = e.isHorizontal();
          e.slides.forEach(e => {
            const s = Math.max(Math.min(e.progress ?? 0, 1), -1);
            i(e, s, t);
          });
        },
        getEffectParams: () => e.params.cubeEffect,
        perspective: () => !0,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: !1,
          virtualTranslate: !0,
        }),
      });
    },
    ({ swiper: e, extendParams: t, on: s }) => {
      function i() {
        return e.params.flipEffect;
      }
      t({ flipEffect: { slideShadows: !0, limitRotation: !0 } });
      const r = (t, s) => {
        let i = e.isHorizontal()
            ? t.querySelector('.swiper-slide-shadow-left')
            : t.querySelector('.swiper-slide-shadow-top'),
          r = e.isHorizontal()
            ? t.querySelector('.swiper-slide-shadow-right')
            : t.querySelector('.swiper-slide-shadow-bottom');
        (i || (i = be('flip', t, e.isHorizontal() ? 'left' : 'top')),
          r || (r = be('flip', t, e.isHorizontal() ? 'right' : 'bottom')),
          i && (i.style.opacity = String(Math.max(-s, 0))),
          r && (r.style.opacity = String(Math.max(s, 0))));
      };
      ge({
        effect: 'flip',
        swiper: e,
        on: s,
        setTranslate: () => {
          const { slides: t, rtlTranslate: s } = e,
            a = i(),
            n = b(e);
          for (let i = 0; i < t.length; i += 1) {
            const l = t[i];
            let o = l.progress ?? 0;
            a.limitRotation && (o = Math.max(Math.min(o, 1), -1));
            const d = l.swiperSlideOffset ?? 0;
            let c = -180 * o,
              p = 0,
              u = e.params.cssMode ? -d - e.translate : -d,
              m = 0;
            (e.isHorizontal()
              ? s && (c = -c)
              : ((m = u), (u = 0), (p = -c), (c = 0)),
              (l.style.zIndex = String(-Math.abs(Math.round(o)) + t.length)),
              a.slideShadows && r(l, o));
            const h = `translate3d(${u}px, ${m}px, 0px) rotateX(${n(p)}deg) rotateY(${n(c)}deg)`;
            ve(0, l).style.transform = h;
          }
        },
        setTransition: t => {
          const s = e.slides.map(e => o(e));
          (s.forEach(e => {
            ((e.style.transitionDuration = `${t}ms`),
              e
                .querySelectorAll(
                  '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                )
                .forEach(e => {
                  e.style.transitionDuration = `${t}ms`;
                }));
          }),
            we({ swiper: e, duration: t, transformElements: s }));
        },
        recreateShadows: () => {
          const t = i();
          e.slides.forEach(e => {
            let s = e.progress ?? 0;
            (t.limitRotation && (s = Math.max(Math.min(s, 1), -1)), r(e, s));
          });
        },
        getEffectParams: () => e.params.flipEffect,
        perspective: () => !0,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          spaceBetween: 0,
          virtualTranslate: !e.params.cssMode,
        }),
      });
    },
    ({ swiper: e, extendParams: t, on: s }) => {
      t({
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          scale: 1,
          modifier: 1,
          slideShadows: !0,
        },
      });
      ge({
        effect: 'coverflow',
        swiper: e,
        on: s,
        setTranslate: () => {
          const { width: t, height: s, slides: i, slidesSizesGrid: r } = e,
            a = e.params.coverflowEffect,
            n = e.isHorizontal(),
            l = e.translate,
            o = n ? t / 2 - l : s / 2 - l,
            d = n ? a.rotate : -a.rotate,
            c = a.depth,
            p = b(e);
          for (let e = 0, t = i.length; e < t; e += 1) {
            const t = i[e],
              s = r[e],
              l = (o - (t.swiperSlideOffset ?? 0) - s / 2) / s,
              u =
                'function' == typeof a.modifier
                  ? a.modifier(l)
                  : l * a.modifier;
            let m = n ? d * u : 0,
              h = n ? 0 : d * u,
              f = -c * Math.abs(u),
              g =
                'string' == typeof a.stretch && -1 !== a.stretch.indexOf('%')
                  ? (parseFloat(a.stretch) / 100) * s
                  : a.stretch,
              v = n ? 0 : g * u,
              w = n ? g * u : 0,
              b = 1 - (1 - a.scale) * Math.abs(u);
            (Math.abs(w) < 0.001 && (w = 0),
              Math.abs(v) < 0.001 && (v = 0),
              Math.abs(f) < 0.001 && (f = 0),
              Math.abs(m) < 0.001 && (m = 0),
              Math.abs(h) < 0.001 && (h = 0),
              Math.abs(b) < 0.001 && (b = 0));
            const y = `translate3d(${w}px,${v}px,${f}px)  rotateX(${p(h)}deg) rotateY(${p(m)}deg) scale(${b})`;
            if (
              ((ve(0, t).style.transform = y),
              (t.style.zIndex = String(1 - Math.abs(Math.round(u)))),
              a.slideShadows)
            ) {
              let e = n
                  ? t.querySelector('.swiper-slide-shadow-left')
                  : t.querySelector('.swiper-slide-shadow-top'),
                s = n
                  ? t.querySelector('.swiper-slide-shadow-right')
                  : t.querySelector('.swiper-slide-shadow-bottom');
              (e || (e = be('coverflow', t, n ? 'left' : 'top')),
                s || (s = be('coverflow', t, n ? 'right' : 'bottom')),
                e && (e.style.opacity = String(u > 0 ? u : 0)),
                s && (s.style.opacity = String(-u > 0 ? -u : 0)));
            }
          }
        },
        setTransition: t => {
          e.slides
            .map(e => o(e))
            .forEach(e => {
              ((e.style.transitionDuration = `${t}ms`),
                e
                  .querySelectorAll(
                    '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                  )
                  .forEach(e => {
                    e.style.transitionDuration = `${t}ms`;
                  }));
            });
        },
        perspective: () => !0,
        overwriteParams: () => ({ watchSlidesProgress: !0 }),
      });
    },
    ({ swiper: e, extendParams: t, on: s }) => {
      function i() {
        return e.params.creativeEffect;
      }
      t({
        creativeEffect: {
          limitProgress: 1,
          shadowPerProgress: !1,
          progressMultiplier: 1,
          perspective: !0,
          prev: {
            translate: [0, 0, 0],
            rotate: [0, 0, 0],
            opacity: 1,
            scale: 1,
          },
          next: {
            translate: [0, 0, 0],
            rotate: [0, 0, 0],
            opacity: 1,
            scale: 1,
          },
        },
      });
      const r = e => ('string' == typeof e ? e : `${e}px`);
      ge({
        effect: 'creative',
        swiper: e,
        on: s,
        setTranslate: () => {
          const { slides: t, wrapperEl: s, slidesSizesGrid: a } = e,
            n = i(),
            { progressMultiplier: l } = n,
            o = e.params.centeredSlides,
            d = b(e);
          if (o) {
            const t = a[0] / 2 - (e.params.slidesOffsetBefore ?? 0);
            s.style.transform = `translateX(calc(50% - ${t}px))`;
          }
          for (let s = 0; s < t.length; s += 1) {
            const i = t[s],
              a = i.progress ?? 0,
              c = Math.min(Math.max(a, -n.limitProgress), n.limitProgress);
            let p = c;
            o ||
              (p = Math.min(
                Math.max(i.originalProgress ?? 0, -n.limitProgress),
                n.limitProgress
              ));
            const u = i.swiperSlideOffset ?? 0,
              m = [e.params.cssMode ? -u - e.translate : -u, 0, 0],
              h = [0, 0, 0];
            let f = !1;
            e.isHorizontal() || ((m[1] = m[0]), (m[0] = 0));
            let g = {
              translate: [0, 0, 0],
              rotate: [0, 0, 0],
              scale: 1,
              opacity: 1,
            };
            (c < 0
              ? ((g = n.next), (f = !0))
              : c > 0 && ((g = n.prev), (f = !0)),
              m.forEach((e, t) => {
                m[t] =
                  `calc(${e}px + (${r(g.translate[t])} * ${Math.abs(c * l)}))`;
              }),
              h.forEach((e, t) => {
                h[t] = g.rotate[t] * Math.abs(c * l);
              }),
              (i.style.zIndex = String(-Math.abs(Math.round(a)) + t.length)));
            const v = m.join(', '),
              w = `rotateX(${d(h[0])}deg) rotateY(${d(h[1])}deg) rotateZ(${d(h[2])}deg)`,
              b =
                p < 0
                  ? `scale(${1 + (1 - g.scale) * p * l})`
                  : `scale(${1 - (1 - g.scale) * p * l})`,
              y =
                p < 0
                  ? 1 + (1 - g.opacity) * p * l
                  : 1 - (1 - g.opacity) * p * l,
              E = `translate3d(${v}) ${w} ${b}`;
            if ((f && g.shadow) || !f) {
              let e = i.querySelector('.swiper-slide-shadow');
              if ((!e && g.shadow && (e = be('creative', i)), e)) {
                const t = n.shadowPerProgress ? c * (1 / n.limitProgress) : c;
                e.style.opacity = String(Math.min(Math.max(Math.abs(t), 0), 1));
              }
            }
            const S = ve(0, i);
            ((S.style.transform = E),
              (S.style.opacity = String(y)),
              g.origin && (S.style.transformOrigin = g.origin));
          }
        },
        setTransition: t => {
          const s = e.slides.map(e => o(e));
          (s.forEach(e => {
            ((e.style.transitionDuration = `${t}ms`),
              e.querySelectorAll('.swiper-slide-shadow').forEach(e => {
                e.style.transitionDuration = `${t}ms`;
              }));
          }),
            we({
              swiper: e,
              duration: t,
              transformElements: s,
              allSlides: !0,
            }));
        },
        perspective: () => i().perspective,
        overwriteParams: () => ({
          watchSlidesProgress: !0,
          virtualTranslate: !e.params.cssMode,
        }),
      });
    },
    ({ swiper: e, extendParams: t, on: s }) => {
      function i() {
        return e.params.cardsEffect;
      }
      t({
        cardsEffect: {
          slideShadows: !0,
          rotate: !0,
          perSlideRotate: 2,
          perSlideOffset: 8,
        },
      });
      ge({
        effect: 'cards',
        swiper: e,
        on: s,
        setTranslate: () => {
          const { slides: t, activeIndex: s, rtlTranslate: r } = e,
            a = i(),
            { startTranslate: n, isTouched: l } = e.touchEventsData,
            o = r ? -e.translate : e.translate;
          for (let i = 0; i < t.length; i += 1) {
            const d = t[i],
              c = d.progress ?? 0,
              p = Math.min(Math.max(c, -4), 4);
            let u = d.swiperSlideOffset ?? 0;
            (e.params.centeredSlides &&
              !e.params.cssMode &&
              (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`),
              e.params.centeredSlides &&
                e.params.cssMode &&
                (u -= t[0].swiperSlideOffset ?? 0));
            let m = e.params.cssMode ? -u - e.translate : -u,
              h = 0;
            const f = -100 * Math.abs(p);
            let g = 1,
              v = -a.perSlideRotate * p,
              w = a.perSlideOffset - 0.75 * Math.abs(p);
            const b =
                e.virtual && e.params.virtual?.enabled ? e.virtual.from + i : i,
              y =
                (b === s || b === s - 1) &&
                p > 0 &&
                p < 1 &&
                (l || e.params.cssMode) &&
                (o ?? 0) < (n ?? 0),
              E =
                (b === s || b === s + 1) &&
                p < 0 &&
                p > -1 &&
                (l || e.params.cssMode) &&
                (o ?? 0) > (n ?? 0);
            if (y || E) {
              const t = (1 - Math.abs((Math.abs(p) - 0.5) / 0.5)) ** 0.5;
              ((v += -28 * p * t),
                (g += -0.5 * t),
                (w += 96 * t),
                (h =
                  (a.rotate || e.isHorizontal() ? -25 : 0) * t * Math.abs(p) +
                  '%'));
            }
            if (
              ((m =
                p < 0
                  ? `calc(${m}px ${r ? '-' : '+'} (${w * Math.abs(p)}%))`
                  : p > 0
                    ? `calc(${m}px ${r ? '-' : '+'} (-${w * Math.abs(p)}%))`
                    : `${m}px`),
              !e.isHorizontal())
            ) {
              const e = h;
              ((h = m), (m = e));
            }
            const S = p < 0 ? '' + (1 + (1 - g) * p) : '' + (1 - (1 - g) * p),
              x = `\n        translate3d(${m}, ${h}, ${f}px)\n        rotateZ(${a.rotate ? (r ? -v : v) : 0}deg)\n        scale(${S})\n      `;
            if (a.slideShadows) {
              let e = d.querySelector('.swiper-slide-shadow');
              (e || (e = be('cards', d)),
                e &&
                  (e.style.opacity = String(
                    Math.min(Math.max((Math.abs(p) - 0.5) / 0.5, 0), 1)
                  )));
            }
            d.style.zIndex = String(-Math.abs(Math.round(c)) + t.length);
            ve(0, d).style.transform = x;
          }
        },
        setTransition: t => {
          const s = e.slides.map(e => o(e));
          (s.forEach(e => {
            ((e.style.transitionDuration = `${t}ms`),
              e.querySelectorAll('.swiper-slide-shadow').forEach(e => {
                e.style.transitionDuration = `${t}ms`;
              }));
          }),
            we({ swiper: e, duration: t, transformElements: s }));
        },
        perspective: () => !0,
        overwriteParams: () => ({
          _loopSwapReset: !1,
          watchSlidesProgress: !0,
          loopAdditionalSlides: i().rotate ? 3 : 2,
          centeredSlides: !0,
          virtualTranslate: !e.params.cssMode,
        }),
      });
    },
  ];
  return (se.use(ye), se);
})();
//# sourceMappingURL=swiper-bundle.min.js.ma
